(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9603],{

/***/ 68389:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search",
      function () {
        return __webpack_require__(99690);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 13971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ atom_Skeleton; }
});

// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(62230);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(75190);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(44376);
// EXTERNAL MODULE: ./src/utils/opacity.ts + 1 modules
var opacity = __webpack_require__(52172);
;// CONCATENATED MODULE: ./src/components/atom/Skeleton/styles.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  to {\n    background-position-x: -20%;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 5px;\n  ",
        "\n  background-size: 200% 100%;\n  background-position-x: 180%;\n  animation: 1.6s ",
        " ease-in-out infinite;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var loading = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject());
var StyledSkeleton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a4c00a2-0"
})(_templateObject1(), function(param) {
    var _backgroundColor = param.backgroundColor, backgroundColor = _backgroundColor === void 0 ? theme/* default.color.gray40 */.Z.color.gray40 : _backgroundColor, _gradientColor = param.gradientColor, gradientColor = _gradientColor === void 0 ? "#ffffff" : _gradientColor;
    return "\n    background-color: ".concat(backgroundColor, ";\n    background: linear-gradient(\n        120deg,\n        ").concat((0,opacity/* withOpacity */.C)(gradientColor, "0%"), " 40%,\n        ").concat((0,opacity/* withOpacity */.C)(gradientColor, "50%"), " 50%,\n        ").concat((0,opacity/* withOpacity */.C)(gradientColor, "0%"), " 60%\n      )\n      ").concat(backgroundColor, ";\n  ");
}, loading);

;// CONCATENATED MODULE: ./src/components/atom/Skeleton/index.tsx



var Skeleton = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSkeleton, (0,_object_spread/* default */.Z)({}, props));
};
/* harmony default export */ var atom_Skeleton = (Skeleton);


/***/ }),

/***/ 57849:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44376);


var ContentFile = function(param) {
    var _size = param.size, size = _size === void 0 ? 48 : _size, _bodyColor = param.bodyColor, bodyColor = _bodyColor === void 0 ? _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* ["default"].color.gray100 */ .Z.color.gray100 : _bodyColor, _edgeColor = param.edgeColor, edgeColor = _edgeColor === void 0 ? _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* ["default"].color.gray300 */ .Z.color.gray300 : _edgeColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                clipPath: "url(#clip0_3040_59478)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M8.57157 0C7.20761 0 5.89948 0.541834 4.93502 1.50631C3.97056 2.47078 3.42871 3.7789 3.42871 5.14286V42.8571C3.42871 44.221 3.97056 45.5294 4.93502 46.4938C5.89948 47.4583 7.20758 48 8.57157 48H39.4287C40.7926 48 42.1009 47.4583 43.0654 46.4938C44.0299 45.5294 44.5716 44.221 44.5716 42.8571V18.8571C44.5716 18.4025 44.3909 17.9664 44.0696 17.645L26.9266 0.502104C26.6051 0.180612 26.1691 0 25.7144 0H8.57157Z",
                        fill: bodyColor
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M44.5715 18.8571C44.5715 18.4025 44.3908 17.9664 44.0696 17.645L26.9265 0.502104C26.6051 0.180612 26.169 0 25.7144 0V17.1429C25.7144 18.0896 26.4819 18.8571 27.4286 18.8571H44.5715Z",
                        fill: edgeColor
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_3040_59478",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "48",
                        height: "48",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ContentFile);


/***/ }),

/***/ 34766:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44376);


var FavoriteStar = function(param) {
    var _size = param.size, size = _size === void 0 ? 16 : _size, _color = param.color, color = _color === void 0 ? _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* ["default"].color.gray600 */ .Z.color.gray600 : _color, _fullColor = param.fullColor, fullColor = _fullColor === void 0 ? _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* ["default"].color.gray600 */ .Z.color.gray600 : _fullColor, _empty = param.empty, empty = _empty === void 0 ? false : _empty;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                clipPath: "url(#clip0_2330_43927)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: empty ? "M7.91106 0.314532C7.74268 0.32419 7.58355 0.366481 7.43068 0.442187C7.20803 0.552452 7.04363 0.695505 6.9091 0.896036C6.86333 0.964254 6.84128 1.00828 5.86564 2.97924C5.42307 3.87332 5.05767 4.60802 5.05365 4.6119C5.04964 4.61578 4.16507 4.74903 3.08795 4.90802C2.01083 5.06701 1.09929 5.20267 1.06231 5.20951C0.936279 5.23282 0.844906 5.26371 0.726346 5.3231C0.598595 5.38709 0.494653 5.46221 0.384727 5.56999C0.0911394 5.85785 -0.0507422 6.2975 0.0189666 6.70334C0.0626146 6.95746 0.160624 7.16594 0.323939 7.35207C0.358704 7.39169 1.01643 8.03061 1.78555 8.7719C2.55467 9.51318 3.19769 10.1332 3.21449 10.1497L3.24503 10.1797L2.90631 12.1635C2.72002 13.2545 2.56459 14.1717 2.56089 14.2016C2.5373 14.3928 2.55228 14.5633 2.60868 14.7456C2.67085 14.9467 2.77197 15.1205 2.91182 15.2666C3.1785 15.5453 3.53678 15.692 3.91675 15.6782C4.11792 15.6709 4.28084 15.6292 4.46075 15.5392C4.50123 15.5189 5.3141 15.0902 6.26713 14.5865L7.99991 13.6708L9.73273 14.5867C10.6858 15.0905 11.5054 15.5222 11.5541 15.5461C11.9315 15.7311 12.3778 15.7235 12.7477 15.5259C13.2324 15.267 13.5058 14.7433 13.439 14.2016C13.4353 14.1717 13.2799 13.2646 13.0936 12.1858L12.7549 10.2243L12.9646 10.0155C13.08 9.90068 13.7287 9.2567 14.4063 8.58446C15.0953 7.90093 15.6567 7.339 15.6799 7.30955C15.869 7.07017 15.9677 6.78789 15.9679 6.48603C15.968 6.23634 15.8915 5.98249 15.752 5.77067C15.5764 5.5038 15.2954 5.30113 14.9951 5.22468C14.9168 5.20473 15.006 5.21825 12.8255 4.8958C11.7959 4.74354 10.9502 4.61578 10.9462 4.6119C10.9422 4.60802 10.5754 3.87044 10.131 2.97284C9.1534 0.997879 9.13658 0.964299 9.09079 0.896036C8.95538 0.69418 8.78953 0.550347 8.56635 0.441195C8.41248 0.365937 8.2555 0.323665 8.10342 0.316529C8.06235 0.314596 8.02155 0.312254 8.01275 0.311319C8.00395 0.310385 7.95819 0.311831 7.91106 0.314532ZM7.39216 3.06404C6.20894 5.45339 6.2525 5.36649 6.1965 5.44964C6.11188 5.57526 6.0323 5.65907 5.90768 5.75377C5.75749 5.8679 5.56506 5.95418 5.38795 5.98679C5.35847 5.99222 4.4777 6.12351 3.43068 6.27855C2.38367 6.43358 1.52606 6.56139 1.52487 6.56257C1.5237 6.56375 2.1269 7.14747 2.86533 7.85973C4.32652 9.26912 4.31968 9.26245 4.37228 9.32854C4.56471 9.57031 4.67095 9.8905 4.65665 10.1856C4.65444 10.2314 4.64865 10.2962 4.64379 10.3296C4.63894 10.3631 4.48907 11.244 4.31076 12.2873C4.13244 13.3306 3.9874 14.1878 3.98844 14.1922C3.98961 14.1971 4.63524 13.8591 5.64795 13.3236C6.55963 12.8414 7.34587 12.4271 7.39515 12.403C7.5947 12.3052 7.77859 12.2624 7.99995 12.2624C8.2213 12.2624 8.40334 12.3048 8.60475 12.4031C8.65403 12.4272 9.44027 12.8414 10.3519 13.3235C11.2954 13.8225 12.0103 14.197 12.0114 14.1927C12.0123 14.1886 11.8664 13.3357 11.687 12.2974C11.5077 11.2591 11.3579 10.3879 11.3543 10.3614C11.3063 10.0123 11.4062 9.65112 11.6277 9.37334C11.6774 9.31095 11.6864 9.30197 13.1487 7.85212C13.8633 7.14368 14.4487 6.56243 14.4495 6.56045C14.4504 6.55846 13.7045 6.44634 12.7919 6.31129C10.4506 5.96478 10.5983 5.98742 10.5079 5.96141C10.3641 5.92 10.2417 5.86078 10.1183 5.77289C9.99076 5.68198 9.89579 5.58512 9.80574 5.45405C9.75464 5.37967 9.72755 5.32562 8.60132 3.05124C8.27232 2.38685 8.0017 1.84325 7.99993 1.84324C7.99816 1.84324 7.72467 2.39259 7.39216 3.06404Z" : "M7.9999 0.316406C7.77312 0.316406 7.55107 0.381284 7.35998 0.503381C7.17131 0.623918 7.02058 0.795253 6.92506 0.997602L5.11071 4.66056C5.10714 4.66776 5.10372 4.67503 5.10047 4.68238C5.09966 4.6842 5.09838 4.68578 5.09676 4.68696C5.09515 4.68814 5.09327 4.68888 5.09128 4.6891C5.08432 4.68986 5.07737 4.69077 5.07044 4.69179L1.07549 5.28364C0.85469 5.30511 0.64413 5.38797 0.46777 5.52305C0.285287 5.66284 0.147251 5.85253 0.070382 6.06916C-0.00648674 6.28578 -0.0188903 6.52006 0.0346744 6.7436C0.0880316 6.96626 0.204567 7.16877 0.370243 7.32677L3.29456 10.1483L3.30122 10.1546C3.30539 10.1585 3.30854 10.1634 3.31034 10.1688C3.31215 10.1742 3.31257 10.18 3.31156 10.1856L3.31092 10.1894L2.61408 14.2675C2.57579 14.4886 2.60003 14.7169 2.68439 14.9247C2.76886 15.1329 2.91007 15.3131 3.09193 15.445C3.2738 15.5768 3.48903 15.655 3.71312 15.6705C3.93676 15.6861 4.16028 15.6386 4.35834 15.5337L4.35954 15.533L7.95895 13.6307C7.97185 13.6251 7.9858 13.6222 7.99992 13.6222C8.01403 13.6222 8.02798 13.6251 8.04089 13.6307L11.6402 15.533C11.8384 15.6383 12.0629 15.6862 12.2866 15.6705C12.5108 15.655 12.726 15.5768 12.9079 15.445C13.0897 15.3131 13.231 15.1329 13.3154 14.9247C13.3998 14.7169 13.4241 14.4897 13.386 14.2688L13.3857 14.2675L12.6889 10.1894L12.6882 10.1856C12.6872 10.18 12.6877 10.1742 12.6895 10.1688C12.6912 10.1634 12.6944 10.1585 12.6985 10.1546L12.7053 10.1483L15.6296 7.32673C15.7952 7.16873 15.9118 6.96625 15.9652 6.7436C16.0186 6.52006 16.0063 6.28578 15.9294 6.06916C15.8526 5.85253 15.7145 5.66284 15.532 5.52305C15.3557 5.38797 15.1452 5.30511 14.9244 5.28364L10.9294 4.69179C10.9224 4.69077 10.9155 4.68986 10.9085 4.6891C10.9065 4.68888 10.9046 4.68814 10.903 4.68696C10.9014 4.68578 10.9001 4.6842 10.8993 4.68238C10.8961 4.67503 10.8927 4.66776 10.8891 4.66056L9.07473 0.997586C8.97921 0.795244 8.82848 0.623915 8.63983 0.503381C8.44872 0.381284 8.22667 0.316406 7.9999 0.316406Z",
                    fill: empty ? color : fullColor
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_2330_43927",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FavoriteStar);


/***/ }),

/***/ 94781:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44376);



var IconLocationPinMono = function(param) {
    var _size = param.size, size = _size === void 0 ? 14 : _size, _fill = param.fill, fill = _fill === void 0 ? _styles_theme__WEBPACK_IMPORTED_MODULE_2__/* ["default"].color.blue500 */ .Z.color.blue500 : _fill;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 14 14",
        fill: "none",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.00042 7.43283C6.79 7.43687 6.58088 7.39892 6.3853 7.32118C6.18972 7.24345 6.0116 7.1275 5.86136 6.98012C5.71112 6.83274 5.59178 6.65688 5.5103 6.46282C5.42883 6.26877 5.38687 6.06042 5.38687 5.84996C5.38687 5.6395 5.42883 5.43115 5.5103 5.2371C5.59178 5.04304 5.71112 4.86718 5.86136 4.7198C6.0116 4.57241 6.18972 4.45647 6.3853 4.37873C6.58088 4.301 6.79 4.26304 7.00042 4.26708C7.41497 4.27504 7.80984 4.44531 8.1002 4.74129C8.39055 5.03727 8.5532 5.43534 8.5532 5.84996C8.5532 6.26458 8.39055 6.66265 8.1002 6.95863C7.80984 7.25461 7.41497 7.42488 7.00042 7.43283ZM5.76142 0.604918C3.27059 1.16083 1.52409 3.50525 1.62209 6.05558C1.69909 8.05875 2.92817 9.85075 6.58509 13.3665C6.81609 13.5882 7.18592 13.5893 7.41751 13.3671C11.1998 9.73117 12.3852 7.93917 12.3852 5.84967C12.3852 2.47217 9.27426 -0.179082 5.76142 0.605501",
            fill: fill
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (IconLocationPinMono);


/***/ }),

/***/ 20053:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44376);


var MailChatBubbleTypingOval = function(param) {
    var _color = param.color, color = _color === void 0 ? _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* ["default"].color.blue500 */ .Z.color.blue500 : _color;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                clipPath: "url(#clip0_1604_35615)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M11.4516 0.840737C10.3743 0.321619 9.19361 0.0523678 7.99766 0.0530485C6.56023 0.0535261 5.14967 0.443869 3.91654 1.18251C2.68335 1.92118 1.67362 2.9805 0.994872 4.24766C0.316128 5.51481 -0.00620198 6.94234 0.0622128 8.37821C0.125915 9.71517 0.526169 11.0127 1.22371 12.1513L0.0874464 15.1744C0.0150872 15.367 0.0517637 15.5835 0.183481 15.7415C0.315199 15.8994 0.521635 15.9744 0.724018 15.9378L4.68514 15.2215C5.71293 15.6936 6.83037 15.9413 7.96284 15.9469C9.15883 15.9527 10.3407 15.6887 11.4204 15.1742C12.5001 14.6598 13.4498 13.9082 14.1986 12.9757C14.9475 12.0432 15.4762 10.9536 15.7454 9.7883C16.0144 8.62298 16.0171 7.41194 15.753 6.24545C15.489 5.07897 14.965 3.98713 14.2203 3.05132C13.4755 2.11552 12.5291 1.35987 11.4516 0.840737Z",
                        fill: color
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M4.3163 8L4.31577 7.99823L4.31513 7.99711L4.31401 7.99647L4.31224 7.99594L4.31048 7.99647L4.30936 7.99711L4.30872 7.99823L4.30819 8L4.30872 8.00176L4.30936 8.00288L4.31048 8.00352L4.31224 8.00404L4.31401 8.00352L4.31513 8.00288L4.31577 8.00176L4.3163 8ZM3.17346 8C3.17346 7.37107 3.68331 6.86122 4.31224 6.86122C4.94117 6.86122 5.45102 7.37107 5.45102 8C5.45102 8.62892 4.94117 9.13878 4.31224 9.13878C3.68331 9.13878 3.17346 8.62892 3.17346 8ZM8.00403 8L8.00351 7.99823L8.00287 7.99711L8.00175 7.99647L7.99999 7.99594L7.99823 7.99647L7.9971 7.99711L7.99646 7.99823L7.99593 8L7.99646 8.00176L7.9971 8.00288L7.99823 8.00352L7.99999 8.00404L8.00175 8.00352L8.00287 8.00288L8.00351 8.00176L8.00403 8ZM6.86121 8C6.86121 7.37107 7.37106 6.86122 7.99999 6.86122C8.62891 6.86122 9.13876 7.37107 9.13876 8C9.13876 8.62892 8.62891 9.13878 7.99999 9.13878C7.37106 9.13878 6.86121 8.62892 6.86121 8ZM11.6913 7.99823L11.6918 8L11.6913 8.00176L11.6906 8.00288L11.6895 8.00352L11.6878 8.00404L11.686 8.00352L11.6849 8.00288L11.6842 8.00176L11.6838 8L11.6842 7.99823L11.6849 7.99711L11.686 7.99647L11.6878 7.99594L11.6895 7.99647L11.6906 7.99711L11.6913 7.99823ZM11.6878 6.86122C11.0588 6.86122 10.549 7.37107 10.549 8C10.549 8.62892 11.0588 9.13878 11.6878 9.13878C12.3167 9.13878 12.8265 8.62892 12.8265 8C12.8265 7.37107 12.3167 6.86122 11.6878 6.86122Z",
                        fill: "white"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_1604_35615",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (MailChatBubbleTypingOval);


/***/ }),

/***/ 75528:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);

var Phone = function(param) {
    var _fill = param.fill, fill = _fill === void 0 ? "#FD7E14" : _fill, _size = param.size, size = _size === void 0 ? 12 : _size;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 12 12",
        fill: "none",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
            id: "call",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("mask", {
                    id: "mask0_1975_37498",
                    maskUnits: "userSpaceOnUse",
                    x: "0",
                    y: "0",
                    width: "12",
                    height: "12",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        id: "Bounding box",
                        width: "12",
                        height: "12",
                        fill: "#D9D9D9"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                    mask: "url(#mask0_1975_37498)",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        id: "call_2",
                        d: "M10.3542 11C9.19676 11 8.05324 10.7477 6.92361 10.2431C5.79398 9.73843 4.7662 9.02315 3.84028 8.09722C2.91435 7.1713 2.19907 6.14352 1.69444 5.01389C1.18981 3.88426 0.9375 2.74074 0.9375 1.58333C0.9375 1.41667 0.993056 1.27778 1.10417 1.16667C1.21528 1.05556 1.35417 1 1.52083 1H3.77083C3.90046 1 4.0162 1.04398 4.11806 1.13194C4.21991 1.21991 4.28009 1.32407 4.29861 1.44444L4.65972 3.38889C4.67824 3.53704 4.67361 3.66204 4.64583 3.76389C4.61806 3.86574 4.56713 3.9537 4.49306 4.02778L3.14583 5.38889C3.33102 5.73148 3.55093 6.0625 3.80556 6.38194C4.06019 6.70139 4.34028 7.00926 4.64583 7.30556C4.93287 7.59259 5.2338 7.8588 5.54861 8.10417C5.86343 8.34954 6.19676 8.57407 6.54861 8.77778L7.85417 7.47222C7.9375 7.38889 8.0463 7.32639 8.18056 7.28472C8.31482 7.24306 8.44676 7.23148 8.57639 7.25L10.4931 7.63889C10.6227 7.67593 10.7292 7.74306 10.8125 7.84028C10.8958 7.9375 10.9375 8.0463 10.9375 8.16667V10.4167C10.9375 10.5833 10.8819 10.7222 10.7708 10.8333C10.6597 10.9444 10.5208 11 10.3542 11Z",
                        fill: fill
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Phone);


/***/ }),

/***/ 10211:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);

var Star = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                clipPath: "url(#clip0_662_5056)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M6.99991 0.276855C6.80148 0.276855 6.60719 0.333623 6.43998 0.440458C6.2749 0.545929 6.14301 0.695847 6.05943 0.872902L4.47187 4.07799C4.46875 4.08429 4.46576 4.09065 4.46291 4.09708C4.4622 4.09867 4.46108 4.10006 4.45967 4.10109C4.45826 4.10212 4.45661 4.10277 4.45487 4.10296C4.44878 4.10363 4.4427 4.10442 4.43664 4.10532L0.941057 4.62318C0.747853 4.64197 0.563613 4.71447 0.409298 4.83267C0.249626 4.95498 0.128844 5.12096 0.0615843 5.31051C-0.0056759 5.50006 -0.016529 5.70505 0.0303401 5.90065C0.0770277 6.09548 0.178996 6.27267 0.323962 6.41092L2.88274 8.87974L2.88857 8.88527C2.89222 8.88869 2.89497 8.89296 2.89655 8.89771C2.89813 8.90245 2.8985 8.90752 2.89762 8.91244L2.89706 8.91571L2.28732 12.4841C2.25382 12.6775 2.27503 12.8773 2.34884 13.0591C2.42275 13.2413 2.54631 13.399 2.70544 13.5144C2.86458 13.6297 3.0529 13.6981 3.24898 13.7117C3.44467 13.7253 3.64025 13.6838 3.81355 13.592L3.8146 13.5914L6.96408 11.9269C6.97537 11.922 6.98758 11.9194 6.99993 11.9194C7.01228 11.9194 7.02448 11.922 7.03578 11.9269L10.1852 13.5914C10.3586 13.6835 10.555 13.7254 10.7508 13.7117C10.9469 13.6981 11.1352 13.6297 11.2944 13.5144C11.4535 13.399 11.5771 13.2413 11.651 13.0591C11.7248 12.8773 11.7461 12.6785 11.7127 12.4852L11.7125 12.4841L11.1028 8.9157L11.1022 8.91244C11.1013 8.90752 11.1017 8.90245 11.1033 8.89771C11.1048 8.89297 11.1076 8.88869 11.1112 8.88527L11.1171 8.87974L13.6759 6.41089C13.8208 6.27264 13.9228 6.09547 13.9695 5.90065C14.0163 5.70505 14.0055 5.50006 13.9382 5.31051C13.871 5.12096 13.7502 4.95498 13.5905 4.83267C13.4362 4.71447 13.252 4.64197 13.0588 4.62318L9.56319 4.10532C9.55713 4.10442 9.55105 4.10363 9.54496 4.10296C9.54322 4.10277 9.54156 4.10212 9.54015 4.10109C9.53874 4.10006 9.53763 4.09867 9.53692 4.09708C9.53407 4.09065 9.53108 4.08429 9.52796 4.07799L7.94039 0.872888C7.85681 0.695839 7.72492 0.545925 7.55985 0.440458C7.39263 0.333623 7.19834 0.276855 6.99991 0.276855Z",
                    fill: "#FCC419"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_662_5056",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "14",
                        height: "14",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Star);


/***/ }),

/***/ 64761:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);


var RightArrowCircle = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "64",
        height: "64",
        viewBox: "0 0 64 64",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                filter: "url(#filter0_d_6968_177710)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                    cx: "32",
                    cy: "24",
                    r: "16",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("mask", {
                id: "mask0_6968_177710",
                "mask-type": "mask-type:alpha",
                maskUnits: "userSpaceOnUse",
                x: "24",
                y: "16",
                width: "16",
                height: "16",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                    x: "24",
                    y: "16",
                    width: "16",
                    height: "16",
                    fill: "#D9D9D9"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                mask: "url(#mask0_6968_177710)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M33.65 23.9998L28.75 19.0998C28.5833 18.9332 28.5028 18.7359 28.5083 18.5082C28.5139 18.2804 28.6 18.0832 28.7667 17.9165C28.9333 17.7498 29.1305 17.6665 29.3583 17.6665C29.5861 17.6665 29.7833 17.7498 29.95 17.9165L35.0667 23.0498C35.2 23.1832 35.3 23.3332 35.3667 23.4998C35.4333 23.6665 35.4667 23.8332 35.4667 23.9998C35.4667 24.1665 35.4333 24.3332 35.3667 24.4998C35.3 24.6665 35.2 24.8165 35.0667 24.9498L29.9333 30.0832C29.7667 30.2498 29.5722 30.3304 29.35 30.3248C29.1278 30.3193 28.9333 30.2332 28.7667 30.0665C28.6 29.8998 28.5167 29.7026 28.5167 29.4748C28.5167 29.2471 28.6 29.0498 28.7667 28.8832L33.65 23.9998Z",
                    fill: "#71767A"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
                    id: "filter0_d_6968_177710",
                    x: "0",
                    y: "0",
                    width: "64",
                    height: "64",
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
                            floodOpacity: "0",
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                            dy: "8"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                            stdDeviation: "8"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feComposite", {
                            in2: "hardAlpha",
                            operator: "out"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                            mode: "normal",
                            in2: "BackgroundImageFix",
                            result: "effect1_dropShadow_6968_177710"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                            mode: "normal",
                            in: "SourceGraphic",
                            in2: "effect1_dropShadow_6968_177710",
                            result: "shape"
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (RightArrowCircle);


/***/ }),

/***/ 64903:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);


var SmallRightArrowCircle = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "12",
                fill: "#F5F6F7"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M9.30005 15.625L12.7219 12.2812L9.30005 8.95312L10.2375 8L14.6438 12.2812L10.2375 16.5781L9.30005 15.625Z",
                fill: "#8D9297"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SmallRightArrowCircle);


/***/ }),

/***/ 74976:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);

var HelpQuestion = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M10.5833 45.0348V38.375H24L13.8265 46.5554C12.528 47.5995 10.5833 46.6877 10.5833 45.0348Z",
                fill: "#F1F3F6"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "1",
                y: "1",
                width: "46",
                height: "37.375",
                rx: "6",
                fill: "#F1F3F6"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M23.669 7.50884C22.6371 7.54995 21.6747 7.8002 20.7235 8.27478C18.6217 9.32333 17.1579 11.3339 16.827 13.6268C16.6838 14.6191 16.7373 15.2085 17.0136 15.6827C17.3123 16.1952 17.7835 16.5589 18.3395 16.7059C18.5038 16.7494 18.5665 16.7556 18.857 16.757C19.2407 16.7589 19.403 16.7318 19.6888 16.6181C20.2736 16.3856 20.7644 15.8447 20.9374 15.2424C20.9721 15.1213 20.9922 14.9863 21.0058 14.7813C21.0354 14.338 21.0612 14.1342 21.1127 13.9383C21.3946 12.8664 22.222 12.0608 23.3084 11.8004C24.6277 11.4841 26.0206 12.1126 26.6394 13.3033C26.8735 13.7536 26.9746 14.1661 26.9739 14.668C26.9729 15.464 26.6708 16.182 26.0993 16.7468C25.7176 17.1239 25.2771 17.3724 24.7384 17.5142C24.5358 17.5675 24.3543 17.5908 23.9704 17.6125C23.5951 17.6338 23.3565 17.6841 23.1218 17.7912C22.5695 18.0434 22.1134 18.5596 21.9505 19.1171C21.8753 19.3743 21.8609 19.6071 21.8609 20.5645C21.8609 21.7462 21.8828 21.926 22.0744 22.3142C22.2464 22.6626 22.5085 22.9568 22.8425 23.1765C23.0314 23.3007 23.2229 23.3839 23.4736 23.4506C23.6397 23.4948 23.6952 23.5 23.9995 23.5C24.3039 23.5 24.3594 23.4948 24.5255 23.4506C24.7762 23.3839 24.9677 23.3007 25.1566 23.1765C25.699 22.8198 26.0639 22.242 26.1121 21.6636L26.1244 21.5153L26.282 21.464C27.813 20.9656 29.1522 19.9477 30.06 18.5924C30.9244 17.3018 31.3466 15.706 31.2313 14.1648C31.1593 13.2015 30.9173 12.3214 30.4939 11.483C29.6288 9.77015 28.1541 8.49535 26.3132 7.8689C25.7444 7.67536 24.9849 7.53518 24.3981 7.51547C24.2377 7.51009 24.0802 7.50351 24.0482 7.50086C24.0161 7.49823 23.8455 7.50182 23.669 7.50884ZM23.4809 26.5108C22.5197 26.6199 21.7143 27.2604 21.3849 28.1778C21.2052 28.6782 21.205 29.3178 21.3846 29.8205C21.6705 30.6212 22.3214 31.2165 23.1367 31.423C24.1719 31.6852 25.2524 31.2641 25.8462 30.367C25.9537 30.2046 26.0447 30.0207 26.1166 29.8205C26.2938 29.327 26.2945 28.7217 26.1184 28.2093C25.8691 27.4839 25.2681 26.8837 24.5417 26.6347C24.229 26.5275 23.7876 26.476 23.4809 26.5108Z",
                fill: "#C6CACE"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HelpQuestion);


/***/ }),

/***/ 9558:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75190);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89961);
/* harmony import */ var _utils_logger__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78287);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var ClickEventLogger = function(param) {
    var children = param.children, eventName = param.eventName, pageName = param.pageName, payload = param.payload;
    var onClickEventLog = function() {
        (0,_utils_logger__WEBPACK_IMPORTED_MODULE_3__/* .mobileLogger */ .Pp)({
            logger: {
                eventName: eventName,
                pageName: pageName,
                payload: payload
            }
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Wrapper, {
        role: "button",
        onClick: onClickEventLog,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ClickEventLogger);
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-1551bdea-0"
})(_templateObject());


/***/ }),

/***/ 18163:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ common_InfiniteScroll; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(75190);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
;// CONCATENATED MODULE: ./src/components/common/InfiniteScroll/styles.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  //overflow-y: scroll;\n  width: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var InfiniteScrollContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-d3f94304-0"
})(_templateObject());

// EXTERNAL MODULE: ./src/components/molecules/Loader/index.tsx + 1 modules
var Loader = __webpack_require__(6505);
// EXTERNAL MODULE: ./src/hooks/useIntersectionObserver.tsx
var useIntersectionObserver = __webpack_require__(13041);
;// CONCATENATED MODULE: ./src/components/common/InfiniteScroll/index.tsx





var InfiniteScroll = function(param) {
    var _threshold = param.threshold, threshold = _threshold === void 0 ? 0 : _threshold, rootMargin = param.rootMargin, children = param.children, _loader = param.loader, loader = _loader === void 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* default */.Z, {}) : _loader, isLoading = param.isLoading, hasNextPage = param.hasNextPage, fetchNextPage = param.fetchNextPage;
    var ref = (0,react.useState)(), loaderElement = ref[0], setLoaderElement = ref[1];
    var entry = (0,useIntersectionObserver/* default */.Z)({
        target: loaderElement,
        threshold: threshold,
        rootMargin: rootMargin
    });
    (0,react.useEffect)(function() {
        if ((entry === null || entry === void 0 ? void 0 : entry.isIntersecting) && hasNextPage && !isLoading) {
            fetchNextPage();
        }
    }, [
        entry,
        hasNextPage,
        isLoading,
        fetchNextPage
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfiniteScrollContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: children
            }),
            hasNextPage && !isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: function(ref) {
                    return setLoaderElement(ref);
                },
                children: loader
            })
        ]
    });
};
/* harmony default export */ var common_InfiniteScroll = (InfiniteScroll);


/***/ }),

/***/ 79476:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ magazine_ListMagazineLine; }
});

// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(75190);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
// EXTERNAL MODULE: ./src/components/atom/MaterialIcon.tsx
var MaterialIcon = __webpack_require__(17986);
;// CONCATENATED MODULE: ./src/components/atom/icon/OpenInNew.tsx


var OpenInNew = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "mask0_1074_1939",
                "mask-type": "mask-type:alpha",
                maskUnits: "userSpaceOnUse",
                x: "0",
                y: "0",
                width: "16",
                height: "16",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    width: "16",
                    height: "16",
                    fill: "#D9D9D9"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                mask: "url(#mask0_1074_1939)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M3.33333 14C2.96667 14 2.65278 13.8694 2.39167 13.6083C2.13056 13.3472 2 13.0333 2 12.6667V3.33333C2 2.96667 2.13056 2.65278 2.39167 2.39167C2.65278 2.13056 2.96667 2 3.33333 2H7.33333C7.52222 2 7.68056 2.06389 7.80833 2.19167C7.93611 2.31944 8 2.47778 8 2.66667C8 2.85556 7.93611 3.01389 7.80833 3.14167C7.68056 3.26944 7.52222 3.33333 7.33333 3.33333H3.33333V12.6667H12.6667V8.66667C12.6667 8.47778 12.7306 8.31944 12.8583 8.19167C12.9861 8.06389 13.1444 8 13.3333 8C13.5222 8 13.6806 8.06389 13.8083 8.19167C13.9361 8.31944 14 8.47778 14 8.66667V12.6667C14 13.0333 13.8694 13.3472 13.6083 13.6083C13.3472 13.8694 13.0333 14 12.6667 14H3.33333ZM12.6667 4.26667L6.93333 10C6.81111 10.1222 6.65556 10.1833 6.46667 10.1833C6.27778 10.1833 6.12222 10.1222 6 10C5.87778 9.87778 5.81667 9.72222 5.81667 9.53333C5.81667 9.34444 5.87778 9.18889 6 9.06667L11.7333 3.33333H10C9.81111 3.33333 9.65278 3.26944 9.525 3.14167C9.39722 3.01389 9.33333 2.85556 9.33333 2.66667C9.33333 2.47778 9.39722 2.31944 9.525 2.19167C9.65278 2.06389 9.81111 2 10 2H14V6C14 6.18889 13.9361 6.34722 13.8083 6.475C13.6806 6.60278 13.5222 6.66667 13.3333 6.66667C13.1444 6.66667 12.9861 6.60278 12.8583 6.475C12.7306 6.34722 12.6667 6.18889 12.6667 6V4.26667Z",
                    fill: "#A9AEB1"
                })
            })
        ]
    });
};
/* harmony default export */ var icon_OpenInNew = (OpenInNew);

// EXTERNAL MODULE: ./src/components/atom/text/DefaultText.tsx
var DefaultText = __webpack_require__(40202);
// EXTERNAL MODULE: ./src/styles/layout.ts
var layout = __webpack_require__(64952);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(44376);
// EXTERNAL MODULE: ./src/utils/mobile/RNPlugins.tsx
var RNPlugins = __webpack_require__(10712);
;// CONCATENATED MODULE: ./src/components/common/communication/magazine/ListMagazineLineItem.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  padding: 20px 0;\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  ",
        ";\n  margin-bottom: 2px;\n  ",
        ";\n  word-break: unset;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  ",
        ";\n  ",
        ";\n  margin-bottom: 8px;\n  word-break: unset;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  ",
        ";\n  display: flex;\n  align-items: center;\n  & > svg {\n    margin-left: 2px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  min-width: 96px;\n  max-width: 128px;\n  height: 100%;\n  border-radius: 12px;\n  margin-left: 24px;\n\n  @media screen and (max-width: ",
        ") {\n    max-width: 96px;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  min-height: 72px;\n  max-height: 96px;\n  border-radius: 12px;\n  border: 1px solid ",
        ";\n  object-fit: cover;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}









var ListMagazineLineItem = function(param) {
    var magazine = param.magazine, isExternal = param.isExternal, isLast = param.isLast;
    var image = magazine.image, date = magazine.date;
    var title = (0,react.useMemo)(function() {
        return (0,RNPlugins/* isWebView */.vp)() ? magazine.mobileTitle : magazine.title;
    }, [
        magazine.mobileTitle,
        magazine.title
    ]);
    var description = (0,react.useMemo)(function() {
        return (0,RNPlugins/* isWebView */.vp)() ? magazine.mobileDescription : magazine.description;
    }, [
        magazine.description,
        magazine.mobileDescription
    ]);
    var siteName = (0,react.useMemo)(function() {
        if (isExternal && magazine.siteName) {
            return magazine.siteName;
        }
        return "";
    }, [
        isExternal,
        magazine.siteName
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        isLast: isLast,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Description, {
                        children: description
                    }),
                    isExternal ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(OuterLink, {
                        children: [
                            siteName,
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_OpenInNew, {})
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ListMagazineLineItem_Date, {
                        children: date
                    })
                ]
            }),
            image === "" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                name: "chevron_right",
                color: theme/* default.color.gray400 */.Z.color.gray400
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                    src: image,
                    alt: "이미지"
                })
            })
        ]
    });
};
/* harmony default export */ var magazine_ListMagazineLineItem = (ListMagazineLineItem);
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-16f0600a-0"
})(_templateObject(), function(param) {
    var _$theme = param.theme, isLast = param.isLast;
    return "\n    border-bottom: ".concat(!isLast ? "1px solid ".concat(_$theme.color.gray30) : "none", ";\n  ");
});
var Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-16f0600a-1"
})(_templateObject1());
var Title = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    componentId: "sc-16f0600a-2"
})(_templateObject2(), theme/* default.color.gray600 */.Z.color.gray600, theme/* default.typography.UI17SB */.Z.typography.UI17SB, DefaultText/* EllipsisTextStyle */.Ew);
var Description = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-16f0600a-3"
})(_templateObject3(), theme/* default.color.gray500 */.Z.color.gray500, theme/* default.typography.UI14R */.Z.typography.UI14R, DefaultText/* EllipsisTextStyle */.Ew);
var ListMagazineLineItem_Date = styled_components_browser_esm/* default.time.withConfig */.ZP.time.withConfig({
    componentId: "sc-16f0600a-4"
})(_templateObject4(), theme/* default.color.gray300 */.Z.color.gray300, theme/* default.typography.UI13R */.Z.typography.UI13R);
var OuterLink = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-16f0600a-5"
})(_templateObject5(), theme/* default.color.gray300 */.Z.color.gray300, theme/* default.typography.UI13R */.Z.typography.UI13R);
var ImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-16f0600a-6"
})(_templateObject6(), layout/* Tablet */.YD);
var Image = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-16f0600a-7"
})(_templateObject7(), theme/* default.color.gray40 */.Z.color.gray40);

;// CONCATENATED MODULE: ./src/components/common/communication/magazine/ListMagazineLine.tsx

function ListMagazineLine_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 24px;\n  &:hover {\n    background-color: ",
        ";\n  }\n\n  &:active {\n    background-color: ",
        ";\n  }\n"
    ]);
    ListMagazineLine_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var ListMagazineLine = function(param) {
    var magazine = param.magazine, _isExternal = param.isExternal, isExternal = _isExternal === void 0 ? false : _isExternal, _isLast = param.isLast, isLast = _isLast === void 0 ? false : _isLast;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ListMagazineLine_Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(magazine_ListMagazineLineItem, {
            magazine: magazine,
            isExternal: isExternal,
            isLast: isLast
        })
    });
};
/* harmony default export */ var magazine_ListMagazineLine = (ListMagazineLine);
var ListMagazineLine_Wrapper = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-7794afd-0"
})(ListMagazineLine_templateObject(), theme/* default.color.gray30 */.Z.color.gray30, theme/* default.color.gray50 */.Z.color.gray50);


/***/ }),

/***/ 4032:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75190);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89961);
/* harmony import */ var _types_hospital__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24396);
/* harmony import */ var _utils_format__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4611);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  height: 18px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 6px;\n  height: 6px;\n  border-radius: 3px;\n  background-color: ",
        ";\n  margin-right: 4px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var DiagnosisStatus = function(props) {
    var text = (0,_utils_format__WEBPACK_IMPORTED_MODULE_3__/* .getDiagnosisStateText */ .QN)(props.type);
    switch(props.type){
        case _types_hospital__WEBPACK_IMPORTED_MODULE_2__/* .DiagnosisState.On */ .J0.On:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StatusWrapper, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StatusOn, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StatusText, {
                        type: _types_hospital__WEBPACK_IMPORTED_MODULE_2__/* .DiagnosisState.On */ .J0.On,
                        children: text
                    })
                ]
            });
        case _types_hospital__WEBPACK_IMPORTED_MODULE_2__/* .DiagnosisState.Off */ .J0.Off:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StatusWrapper, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StatusText, {
                    type: _types_hospital__WEBPACK_IMPORTED_MODULE_2__/* .DiagnosisState.Off */ .J0.Off,
                    children: text
                })
            });
        case _types_hospital__WEBPACK_IMPORTED_MODULE_2__/* .DiagnosisState.Lunch */ .J0.Lunch:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StatusWrapper, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StatusText, {
                    type: _types_hospital__WEBPACK_IMPORTED_MODULE_2__/* .DiagnosisState.Lunch */ .J0.Lunch,
                    children: text
                })
            });
        case _types_hospital__WEBPACK_IMPORTED_MODULE_2__/* .DiagnosisState.DayOff */ .J0.DayOff:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StatusWrapper, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StatusText, {
                    type: _types_hospital__WEBPACK_IMPORTED_MODULE_2__/* .DiagnosisState.DayOff */ .J0.DayOff,
                    children: text
                })
            });
        case _types_hospital__WEBPACK_IMPORTED_MODULE_2__/* .DiagnosisState.Unknown */ .J0.Unknown:
            return null;
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (DiagnosisStatus);
var StatusWrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-fbccb5ee-0"
})(_templateObject());
var StatusOn = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-fbccb5ee-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.color.green500;
});
var StatusText = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-fbccb5ee-2"
})(_templateObject2(), function(param) {
    var theme = param.theme, type = param.type;
    return "\n        ".concat(theme.typography.UI13M, "\n        color: ").concat(type === _types_hospital__WEBPACK_IMPORTED_MODULE_2__/* .DiagnosisState.On */ .J0.On ? theme.color.green700 : theme.color.gray300, ";\n    ");
});


/***/ }),

/***/ 79771:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ molecules_ScrollTopStickyButton; }
});

// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(75190);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
// EXTERNAL MODULE: ./src/components/atom/buttons/DefaultButton.tsx
var DefaultButton = __webpack_require__(47641);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(44376);
// EXTERNAL MODULE: ./src/types/common.ts
var common = __webpack_require__(70138);
;// CONCATENATED MODULE: ./src/components/atom/icon/Arrow/ArrowInCircle.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  transition: transform 0.1s linear;\n  transform: rotate(\n    ",
        "deg\n  );\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var ArrowInCircle = function(param) {
    var _direction = param.direction, direction = _direction === void 0 ? common/* DIRECTION.RIGHT */.JR.RIGHT : _direction, _size = param.size, size = _size === void 0 ? 16 : _size, _color = param.color, color = _color === void 0 ? theme/* default.color.white */.Z.color.white : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArrowInCircleSVG, {
        direction: direction,
        width: size,
        height: size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0_1728_38508)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M7.71199 0.00365558C7.40199 0.0174604 7.16633 0.0378636 6.89919 0.0740236C5.8055 0.222068 4.72382 0.613396 3.77279 1.20511C2.68739 1.88042 1.75155 2.83904 1.1038 3.9391C0.969715 4.16681 0.78807 4.52047 0.684986 4.75454C0.31984 5.58364 0.105338 6.4179 0.029088 7.3055C0.00733441 7.55872 0.00336641 7.66559 0.00330881 7.9999C0.00323841 8.38025 0.012736 8.56881 0.048256 8.8927C0.176986 10.0664 0.575565 11.2151 1.2052 12.2271C1.70536 13.031 2.36305 13.7564 3.12639 14.3461C3.81718 14.8798 4.61871 15.3064 5.46239 15.5894C6.06347 15.791 6.66767 15.916 7.30559 15.9708C7.56083 15.9927 7.66525 15.9966 7.99999 15.9966C8.38048 15.9966 8.5695 15.9871 8.89279 15.9516C10.0664 15.8229 11.2153 15.4243 12.2272 14.7947C12.6163 14.5526 12.9777 14.2806 13.3504 13.9494C13.462 13.8501 13.8502 13.4619 13.9494 13.3503C14.4614 12.7742 14.8403 12.216 15.1679 11.5551C15.6134 10.6564 15.8774 9.72425 15.9682 8.73007C15.9798 8.60248 15.9935 8.37651 15.9936 8.31228C15.9936 8.27786 15.9964 8.24849 16 8.2463C16.0041 8.24377 16.0064 8.15343 16.0064 7.99632C16.0064 7.83657 16.0041 7.7503 16 7.7503C15.9962 7.7503 15.9936 7.72522 15.9936 7.6879C15.9935 7.58302 15.9738 7.30899 15.9517 7.1071C15.8235 5.93502 15.4243 4.78451 14.7948 3.7727C14.5051 3.30711 14.1701 2.8765 13.7864 2.4767C13.118 1.78016 12.3994 1.25039 11.5552 0.831963C10.59 0.353537 9.6183 0.0922316 8.51874 0.0153804C8.39084 0.00644598 7.83183 -0.00168202 7.71199 0.00365558ZM7.87199 1.40599C6.51278 1.42618 5.16218 1.88736 4.06399 2.70629C3.55807 3.08356 3.08446 3.55715 2.70634 4.0639C2.28567 4.62765 1.95731 5.26075 1.73208 5.9423C1.55219 6.4867 1.44975 7.03306 1.41411 7.6383C1.4049 7.79487 1.4049 8.20493 1.41411 8.3615C1.45084 8.98511 1.55818 9.54453 1.74937 10.1087C2.13642 11.2508 2.8074 12.2385 3.73439 13.0307C4.75758 13.9051 6.06682 14.4534 7.40799 14.5692C7.78637 14.6019 8.2136 14.6019 8.59199 14.5692C9.93328 14.4534 11.2413 13.9056 12.2656 13.0307C12.5331 12.8022 12.8023 12.533 13.0307 12.2655C13.8517 11.3044 14.3852 10.0943 14.5433 8.8351C14.6005 8.37976 14.6094 7.886 14.5691 7.4079C14.4623 6.14101 13.9559 4.87986 13.1538 3.88332C12.8906 3.55628 12.587 3.24375 12.2656 2.96911C11.3046 2.14789 10.0901 1.61279 8.83199 1.45631C8.52785 1.41848 8.19735 1.40116 7.87199 1.40599ZM7.91999 5.05669C7.80378 5.06771 7.68763 5.11258 7.58967 5.18431C7.50807 5.24407 4.09794 8.65663 4.05223 8.72428C4.00618 8.79243 3.97108 8.86842 3.9508 8.9439C3.93508 9.00232 3.9336 9.01794 3.93373 9.1231C3.93386 9.22723 3.93551 9.2444 3.95085 9.30184C3.99114 9.45262 4.08821 9.59317 4.22079 9.69266C4.27789 9.73551 4.37846 9.7836 4.45119 9.80282C4.50818 9.81788 4.52745 9.81978 4.62719 9.82022C4.75531 9.82077 4.80218 9.81264 4.89905 9.77308C5.03337 9.71821 4.92938 9.81739 6.53599 8.21185L8 6.74883L9.46399 8.21187C11.0707 9.8175 10.9666 9.7182 11.1009 9.77308C11.1978 9.81264 11.2447 9.82077 11.3728 9.82022C11.4725 9.81978 11.4918 9.81788 11.5488 9.80282C11.6994 9.76302 11.8368 9.66766 11.9373 9.53325C12.0326 9.4057 12.0767 9.25483 12.0684 9.08508C12.0619 8.95062 12.0238 8.83684 11.9477 8.72428C11.902 8.65663 8.4919 5.24407 8.4103 5.18431C8.30816 5.10952 8.19884 5.06847 8.06959 5.05636C8.02955 5.05261 7.99247 5.04992 7.98719 5.05039C7.98191 5.05085 7.95167 5.05368 7.91999 5.05669ZM0.00289921 8.0031C0.00289921 8.14038 0.00374401 8.19563 0.00478081 8.12588C0.00581761 8.05612 0.00581121 7.9438 0.00477441 7.87628C0.00374401 7.80875 0.00289281 7.86582 0.00289921 8.0031Z",
                    fill: color
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_1728_38508",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: color
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Arrow_ArrowInCircle = (ArrowInCircle);
var ArrowInCircleSVG = styled_components_browser_esm/* default.svg.withConfig */.ZP.svg.withConfig({
    componentId: "sc-b8b17c69-0"
})(_templateObject(), function(param) {
    var direction = param.direction;
    return direction === common/* DIRECTION.TOP */.JR.TOP ? 0 : direction === common/* DIRECTION.BOTTOM */.JR.BOTTOM ? 180 : direction === common/* DIRECTION.LEFT */.JR.LEFT ? -90 : 90;
});

;// CONCATENATED MODULE: ./src/components/molecules/ScrollTopStickyButton/index.tsx

function ScrollTopStickyButton_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  margin: 0 auto;\n  left: 50%;\n  visibility: ",
        ";\n  opacity: ",
        ";\n  transform: translate(-50%, -50%);\n  top: calc(",
        " + 28px);\n  transition: all 0.5s ease-out;\n"
    ]);
    ScrollTopStickyButton_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 156px;\n  height: 32px;\n  border-radius: 16px;\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.16);\n\n  ",
        "\n\n  svg {\n    margin-left: 8px;\n  }\n\n  &:active {\n    background: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var ScrollTopStickyButton = function(param) {
    var minY = param.minY;
    var ref = (0,react.useState)(false), isVisible = ref[0], setIsVisible = ref[1];
    var ref1 = (0,react.useState)(0), lastScrollY = ref1[0], setLastScrollY = ref1[1];
    var ref2 = (0,react.useState)(0), innerHeight = ref2[0], setInnerHeight = ref2[1];
    var onScroll = function() {
        var scrollY = window.scrollY;
        if (window.scrollY <= innerHeight) {
            return setIsVisible(false);
        }
        scrollY > lastScrollY ? setIsVisible(false) : setIsVisible(true);
        setLastScrollY(scrollY);
    };
    var onScrollTop = function() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    (0,react.useLayoutEffect)(function() {
        window.addEventListener("scroll", onScroll);
        return function() {
            return window.removeEventListener("scroll", onScroll);
        };
    });
    (0,react.useEffect)(function() {
        if (!minY) {
            setInnerHeight(window.innerHeight * 2);
        }
    }, [
        minY
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollTopStickyButtonContainer, {
        isVisible: isVisible,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ScrollTopStickyButtonWrapper, {
            onClick: onScrollTop,
            children: [
                "상단으로 가기 ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Arrow_ArrowInCircle, {
                    direction: common/* DIRECTION.TOP */.JR.TOP
                })
            ]
        })
    });
};
/* harmony default export */ var molecules_ScrollTopStickyButton = (ScrollTopStickyButton);
var ScrollTopStickyButtonContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2d53a0b1-0"
})(ScrollTopStickyButton_templateObject(), function(param) {
    var isVisible = param.isVisible;
    return !isVisible && "hidden";
}, function(param) {
    var isVisible = param.isVisible;
    return !isVisible && 0;
}, function(param) {
    var theme = param.theme;
    return theme.size.appHeader.height;
});
var ScrollTopStickyButtonWrapper = (0,styled_components_browser_esm/* default */.ZP)(DefaultButton/* DefaultButtonStyled */.qY).withConfig({
    componentId: "sc-2d53a0b1-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI14SB, ";\n    color: ").concat(theme.color.white, ";\n    background: ").concat(theme.color.gray800, ";\n  ");
}, function(param) {
    var theme = param.theme;
    return theme.color.gray700;
});


/***/ }),

/***/ 14675:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75190);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89961);
/* harmony import */ var _components_atom_Skeleton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13971);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 24px;\n  width: 100%;\n  height: 120px;\n  margin-bottom: 16px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var HospitalSkeletonList = function(param) {
    var _size = param.size, size = _size === void 0 ? 8 : _size;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SkeletonWrapper, {
        children: Array.from({
            length: size
        }).map(function(_, i) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(HospitalSkeleton, {}, "skeleton_hospital_".concat(i));
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HospitalSkeletonList);
var HospitalSkeleton = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Card, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_atom_Skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                style: {
                    width: 55,
                    height: 18,
                    marginBottom: 2
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_atom_Skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                style: {
                    width: 200,
                    height: 24,
                    marginBottom: 6
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_atom_Skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                style: {
                    width: 300,
                    height: 22
                }
            })
        ]
    });
};
var Card = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].li.withConfig */ .ZP.li.withConfig({
    componentId: "sc-ddc2cfe4-0"
})(_templateObject());
var SkeletonWrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
    componentId: "sc-ddc2cfe4-1"
})(_templateObject1());


/***/ }),

/***/ 53137:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ry": function() { return /* binding */ REPORT_TYPE; }
/* harmony export */ });
/* unused harmony exports REPORT_KEY, QuickAnswerReportTextarea */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(22710);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75190);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(22970);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2784);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(89961);
/* harmony import */ var _components_atom_Form_TextareaMobile__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11742);
/* harmony import */ var _components_atom_buttons_StickyButton__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(91707);
/* harmony import */ var _components_molecules_AppContainer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87733);
/* harmony import */ var _components_molecules_AppHeader__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(93882);
/* harmony import */ var _hooks_community_mobile_community_gql_impl__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(42549);
/* harmony import */ var _hooks_qna_mobile_qna_gql_impl__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(4365);
/* harmony import */ var _hooks_useToast__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(17722);
/* harmony import */ var _utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(10712);
/* harmony import */ var doctornow_design_system__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(59950);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  padding: 0 20px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 16px 0 8px;\n\n  ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  visibility: ",
        ";\n  opacity: ",
        ";\n  transition: all 0.2s ease-in;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}













var REPORT_TYPE = {
    QUESTION: "question",
    ANSWER: "answer",
    BOARD_POST: "board_post",
    BOARD_COMMENT: "board_comment"
};
var REPORT_KEY = {
    SERVICES: "Service",
    PRIVACY: "Privacy",
    MARKETING: "Marketing",
    ABUSE: "Abuse",
    ETC: "Etc",
    LEWDNESS: "Lewdness",
    PROFILE: "Profile",
    DIGRESSION: "Digression"
};
var ReportMenu = [
    {
        id: REPORT_KEY.SERVICES,
        text: "서비스와 관련없는 내용"
    },
    {
        id: REPORT_KEY.PRIVACY,
        text: "개인정보 유출 위험"
    },
    {
        id: REPORT_KEY.MARKETING,
        text: "광고 또는 홍보 글"
    },
    {
        id: REPORT_KEY.ABUSE,
        text: "음란성, 욕설 등 부적절한 내용"
    },
    {
        id: REPORT_KEY.ETC,
        text: "기타"
    }, 
];
var ReportTemplate = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var targetId = router.query.targetId;
    var reportContentType = router.query.type;
    var reportType = router.query.report_type;
    var showToast = (0,_hooks_useToast__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)().showToast;
    var CommunityReportMenu = [
        {
            id: REPORT_KEY.ABUSE,
            text: "욕설, 폭언, 혐오, 발언"
        },
        {
            id: REPORT_KEY.LEWDNESS,
            text: "음란성, 선정성 글"
        },
        {
            id: REPORT_KEY.PRIVACY,
            text: "개인정보 노출"
        },
        {
            id: REPORT_KEY.MARKETING,
            text: "스팸, 광고성 글"
        },
        {
            id: reportType === "user" ? REPORT_KEY.PROFILE : REPORT_KEY.DIGRESSION,
            text: reportType === "user" ? "부적절한 닉네임과 프로필 사진" : "주제에서 벗어난 글"
        }, 
    ];
    var menus = reportContentType === REPORT_TYPE.BOARD_POST || reportContentType === REPORT_TYPE.BOARD_COMMENT ? CommunityReportMenu : ReportMenu;
    var message = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        if (reportType === "user") {
            if (reportContentType === REPORT_TYPE.ANSWER) {
                return "의료진을 신고했어요.";
            }
            return "사용자를 신고했어요.";
        }
        if (reportType === REPORT_TYPE.QUESTION || reportContentType === REPORT_TYPE.BOARD_POST) {
            return "게시글을 신고했어요.";
        }
        if (reportContentType === REPORT_TYPE.BOARD_COMMENT) {
            return "댓글을 신고했어요.";
        }
        return "답변을 신고했어요.";
    }, [
        reportType,
        reportContentType
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)({}), reason = ref[0], setReason = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(""), detailReason = ref1[0], setDetailReason = ref1[1];
    var onSuccess = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function() {
        showToast({
            message: message
        });
    }, [
        message,
        showToast
    ]);
    var onError = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function() {
        showToast({
            message: "일시적 오류가 발생했습니다. 잠시후 다시 시도해주세요."
        });
    }, [
        showToast
    ]);
    var ref2 = (0,_hooks_qna_mobile_qna_gql_impl__WEBPACK_IMPORTED_MODULE_9__/* .useSetReportQuestionMutation */ .DR)({
        onSuccess: onSuccess,
        onError: onError
    }), questionReportMutate = ref2.mutate;
    var ref3 = (0,_hooks_qna_mobile_qna_gql_impl__WEBPACK_IMPORTED_MODULE_9__/* .useSetReportAnswerMutation */ .Pi)({
        onSuccess: onSuccess,
        onError: onError
    }), answerReportMutate = ref3.mutate;
    var ref4 = (0,_hooks_community_mobile_community_gql_impl__WEBPACK_IMPORTED_MODULE_8__/* .useSetReportBoardPostMutation */ .g0)({
        onSuccess: onSuccess,
        onError: onError
    }), setReportBoardPostMutate = ref4.mutate;
    var ref5 = (0,_hooks_community_mobile_community_gql_impl__WEBPACK_IMPORTED_MODULE_8__/* .useSetReportBoardCommentMutation */ .lY)({
        onSuccess: onSuccess,
        onError: onError
    }), setReportBoardCommentMutate = ref5.mutate;
    var onChangeReason = function(reason) {
        setReason(reason);
    };
    var onChangeTextarea = function(event) {
        setDetailReason(event.target.value.replace(/^\s+/g, ""));
    };
    var checkDisabled = function() {
        if (reason.id === REPORT_KEY.ETC) {
            return detailReason.length === 0;
        }
        return !reason.text;
    };
    var onSubmitReport = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(function() {
        var submitReason;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_14__.__generator)(this, function(_state) {
            submitReason = reason.id === REPORT_KEY.ETC ? detailReason : reason.text;
            switch(reportContentType){
                case REPORT_TYPE.QUESTION:
                    {
                        questionReportMutate({
                            request: {
                                questionPid: targetId,
                                reason: submitReason
                            }
                        });
                        break;
                    }
                case REPORT_TYPE.ANSWER:
                    {
                        answerReportMutate({
                            request: {
                                answerPid: targetId,
                                reason: submitReason
                            }
                        });
                        break;
                    }
                case REPORT_TYPE.BOARD_POST:
                    {
                        setReportBoardPostMutate({
                            request: {
                                boardPostPid: targetId,
                                reason: submitReason
                            }
                        });
                        break;
                    }
                case REPORT_TYPE.BOARD_COMMENT:
                    {
                        setReportBoardCommentMutate({
                            request: {
                                boardCommentPid: targetId,
                                reason: submitReason
                            }
                        });
                        break;
                    }
            }
            setTimeout(function() {
                return (0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_11__/* .historyBack */ .$i)();
            }, 2000);
            return [
                2
            ];
        });
    }), [
        answerReportMutate,
        detailReason,
        targetId,
        questionReportMutate,
        reason.id,
        reason.text,
        reportContentType,
        setReportBoardPostMutate,
        setReportBoardCommentMutate, 
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_components_molecules_AppContainer__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_molecules_AppHeader__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                title: "신고하기",
                onClickBackButton: _utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_11__/* .historyBack */ .$i
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Wrapper, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Title, {
                        children: "이유를 알려주세요"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(doctornow_design_system__WEBPACK_IMPORTED_MODULE_12__/* .RadioGroup */ .Ee, {
                        value: reason.id,
                        onChange: function(value) {
                            var findReason = menus.find(function(item) {
                                return item.id === value;
                            });
                            if (findReason) {
                                onChangeReason(findReason);
                            }
                        },
                        className: "flex flex-col gap-3",
                        children: menus.map(function(item) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(doctornow_design_system__WEBPACK_IMPORTED_MODULE_12__/* .RadioItem */ .Rk, {
                                value: item.id,
                                children: item.text
                            }, item.id);
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(QuickAnswerReportTextarea, {
                        display: reason.id === REPORT_KEY.ETC,
                        id: "quickAnswerQuestionReport",
                        labelSpacing: "8px",
                        height: "144px",
                        label: " ",
                        placeholder: "내용을 작성해주세요.",
                        maxLength: 500,
                        value: detailReason,
                        showCharacterCount: true,
                        onChange: onChangeTextarea
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_atom_buttons_StickyButton__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_atom_buttons_StickyButton__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Button */ .Z.Button, {
                    disabled: checkDisabled(),
                    type: "button",
                    onClick: onSubmitReport,
                    text: "의견 전달하기"
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (ReportTemplate);
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-1b6a4fbc-0"
})(_templateObject());
var Title = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    componentId: "sc-1b6a4fbc-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI20SB, ";\n    color: ").concat(theme.color.gray700, ";\n  ");
});
var QuickAnswerReportTextarea = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)(_components_atom_Form_TextareaMobile__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-1b6a4fbc-2"
})(_templateObject2(), function(param) {
    var display = param.display;
    return display ? "visible" : "hidden";
}, function(param) {
    var display = param.display;
    return display ? 1 : 0;
});


/***/ }),

/***/ 96871:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75190);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89961);
/* harmony import */ var _components_atom_Skeleton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13971);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 24px;\n  display: flex;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: calc(100% - 96px);\n  margin-right: 20px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var MagazineItemSkeleton = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Left, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Row, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_atom_Skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                style: {
                                    width: 60,
                                    height: 18,
                                    marginRight: 8
                                }
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_atom_Skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                style: {
                                    width: 66,
                                    height: 18
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_atom_Skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        style: {
                            height: 48,
                            marginTop: 8,
                            marginBottom: 4
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_atom_Skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        style: {
                            height: 18,
                            marginBottom: 2
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_atom_Skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        style: {
                            width: "70%",
                            height: 18
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Right, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_atom_Skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        style: {
                            width: 96,
                            height: 72,
                            marginBottom: 4
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_atom_Skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        style: {
                            width: 96,
                            height: 28
                        }
                    })
                ]
            })
        ]
    });
};
var MagazineSkeleton = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        children: Array.from({
            length: 8
        }).map(function(_, i) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(MagazineItemSkeleton, {}, "skeleton_".concat(i));
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (MagazineSkeleton);
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-fdc826d3-0"
})(_templateObject());
var Left = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-fdc826d3-1"
})(_templateObject1());
var Row = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-fdc826d3-2"
})(_templateObject2());
var Right = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-fdc826d3-3"
})(_templateObject3());


/***/ }),

/***/ 57823:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62230);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85244);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98240);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75190);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89961);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  padding: 8px 0 6px;\n  z-index: 1;\n  white-space: nowrap;\n\n  ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 4px 8px;\n  border-radius: 8px;\n\n  ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var DNSlideTabItem = function(_param) {
    var label = _param.label, isActive = _param.isActive, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "label",
        "isActive"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledTabItem, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
        className: isActive ? "DNSlideTabItem_selected" : "DNSlideTabItem",
        isActive: isActive,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Label, {
            isActive: isActive,
            children: label
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (DNSlideTabItem);
var StyledTabItem = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-b5de5b68-0"
})(_templateObject(), function(param) {
    var theme = param.theme, isActive = param.isActive;
    return "\n    border-bottom: 2px solid ".concat(isActive ? "".concat(theme.color.gray800) : "transparent", "\n  ");
});
var Label = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-b5de5b68-1"
})(_templateObject1(), function(param) {
    var theme = param.theme, isActive = param.isActive;
    return "\n    ".concat(isActive ? theme.typography.UI15SB : theme.typography.UI15M, ";\n    color: ").concat(isActive ? theme.color.gray800 : theme.color.gray400, ";\n\n    &: active {\n      background: ").concat(theme.color.gray50, ";\n    }\n  ");
});


/***/ }),

/***/ 67788:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98240);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75190);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(89961);
/* harmony import */ var _designComponents_organisms_DNSlideTab_DNSlideTabItem__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57823);
/* harmony import */ var _utils_style__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76666);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  overflow-x: auto;\n  padding: 0 24px;\n  gap: 12px;\n\n  ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 1px;\n  width: 100%;\n  position: absolute;\n  bottom: 0;\n  ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var DNSlideTab = function(_param) {
    var value = _param.value, _group = _param.group, group = _group === void 0 ? false : _group, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "value",
        "group",
        "children"
    ]);
    var scrollRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (!value) return;
        if (!scrollRef.current) return;
        var children = Array.from(scrollRef.current.children);
        children.forEach(function(child) {
            if (child.classList.contains("DNSlideTabItem_selected")) {
                var ref = child.getBoundingClientRect(), left = ref.left, width = ref.width;
                var innerWidth = window.innerWidth;
                if (left + width / 2 !== innerWidth / 2) {
                    var ref1, ref2;
                    (ref1 = scrollRef.current) === null || ref1 === void 0 ? void 0 : ref1.scrollTo({
                        top: 0,
                        left: ((ref2 = scrollRef.current) === null || ref2 === void 0 ? void 0 : ref2.scrollLeft) + (left - innerWidth / 2 + width / 2),
                        behavior: "smooth"
                    });
                }
            }
        });
    }, [
        value
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        className: (0,_utils_style__WEBPACK_IMPORTED_MODULE_5__.cn)([
            "relative",
            props.className
        ]),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Wrapper, {
                ref: scrollRef,
                group: group,
                children: children
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BorderBottom, {})
        ]
    });
};
DNSlideTab.Item = _designComponents_organisms_DNSlideTab_DNSlideTabItem__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z;
/* harmony default export */ __webpack_exports__["Z"] = (DNSlideTab);
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-bf37eb69-0"
})(_templateObject(), function(param) {
    var group = param.group;
    return "\n    ".concat(group ? "\n          button {\n            flex: 1;\n            span {\n              width: 100%;\n            }\n          }" : "", ";\n  ");
});
var BorderBottom = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-bf37eb69-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return "\n    border-bottom: 1px solid ".concat(theme.color.gray100, ";\n  ");
});


/***/ }),

/***/ 77688:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _services_hospital_SearchHospitalService__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23144);
/* harmony import */ var _faceToFace_gql_impl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38245);


var useGetUserAddressByLocation = function(latitude, longitude) {
    var ref = (0,_faceToFace_gql_impl__WEBPACK_IMPORTED_MODULE_0__/* .useGetAddressByLocationQuery */ .hh)({
        longitude: longitude,
        latitude: latitude
    }, {
        enabled: !latitude || !longitude,
        select: _services_hospital_SearchHospitalService__WEBPACK_IMPORTED_MODULE_1__/* .SearchHospitalService.parseHospitalAddressByLocation */ .h.parseHospitalAddressByLocation
    }), data = ref.data, refetch = ref.refetch;
    return {
        data: data,
        refetch: refetch
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useGetUserAddressByLocation);


/***/ }),

/***/ 48115:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22710);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62230);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85244);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22970);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59403);
/* harmony import */ var _search_gql_impl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41872);






var useInfiniteSearchNonF2fDoctors = function(variables, queryOptions) {
    var ref;
    var ref1 = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useInfiniteQuery */ .N)(_search_gql_impl__WEBPACK_IMPORTED_MODULE_0__/* .useSearchNonF2fDoctorsQuery.getKey */ .Tl.getKey(variables), function(param) {
        var _pageParam = param.pageParam, pageParam = _pageParam === void 0 ? variables.request.page : _pageParam;
        return _search_gql_impl__WEBPACK_IMPORTED_MODULE_0__/* .useSearchNonF2fDoctorsQuery.fetcher */ .Tl.fetcher({
            request: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, variables.request), {
                page: pageParam ? pageParam : variables.request.page
            })
        })();
    }, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, queryOptions), {
        getNextPageParam: function(lastPage, allPages) {
            if (lastPage.searchNonF2fDoctors.items.length === variables.request.limit) {
                return allPages.length + 1;
            }
            return false;
        }
    })), data = ref1.data, hasNextPage = ref1.hasNextPage, isLoading = ref1.isLoading, fetchNextPage = ref1.fetchNextPage;
    var category = ((ref = data === null || data === void 0 ? void 0 : data.pages.find(function(page) {
        return !!page.searchNonF2fDoctors.medicalCategoryGraph;
    })) === null || ref === void 0 ? void 0 : ref.searchNonF2fDoctors.medicalCategoryGraph) || null;
    return {
        category: category,
        items: (data === null || data === void 0 ? void 0 : data.pages.map(function(page) {
            return page.searchNonF2fDoctors.items.map(parser);
        }).flat()) || [],
        hasNextPage: hasNextPage,
        fetchNextPage: fetchNextPage,
        isLoading: isLoading
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useInfiniteSearchNonF2fDoctors);
var parser = function(result) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, result);
};
useInfiniteSearchNonF2fDoctors.prefetchQuery = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(queryClient, variable) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        queryClient.prefetchInfiniteQuery(_search_gql_impl__WEBPACK_IMPORTED_MODULE_0__/* .useSearchNonF2fDoctorsQuery.getKey */ .Tl.getKey({
                            request: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, variable.request)
                        }), _search_gql_impl__WEBPACK_IMPORTED_MODULE_0__/* .useSearchNonF2fDoctorsQuery.fetcher */ .Tl.fetcher({
                            request: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, variable.request)
                        }))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function(queryClient, variable) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 97899:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10712);


/**
 * Back Event Handler Hook
 * @returns isBackEventTrigger: boolean,
 * @returns onPreventBackEvent: (isPrevent: boolean) => void;
 */ var useBackEventHandler = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isBackEventTrigger = ref[0], setIsBackEventTrigger = ref[1];
    /**
   * 뒤로가기 막고 해제 할 경우 앱으로 이벤트 전송
   * 뒤로가기 이벤트 막을경우 true, 해제할 경우 false
   */ var onPreventBackEvent = function(isPrevent) {
        if ((0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__/* .isWebView */ .vp)()) {
            (0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__/* .sendPostMessageToNative */ .T0)(_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__/* .NATIVE_POST_MESSAGE_TYPE.SET_PREVENT_BACK_EVENT */ .nn.SET_PREVENT_BACK_EVENT, {
                isPreventBackEvent: isPrevent
            });
        }
    };
    /**
   * 뒤로가기 이벤트 발생할 경우 앱에서 이벤트 받음
   * 뒤로가기 이벤트 발생 true
   * onPreventBackEvent(false) 호출시 false
   */ (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var handleEvent = function(event) {
            if (Object.keys(JSON.parse(event.data))) {
                var ref = JSON.parse(event.data), _isBackEventTrigger = ref.isBackEventTrigger, isBackEventTrigger = _isBackEventTrigger === void 0 ? false : _isBackEventTrigger;
                setIsBackEventTrigger(isBackEventTrigger);
            }
        };
        document.addEventListener("message", handleEvent);
        return function() {
            document.removeEventListener("message", handleEvent);
        };
    }, []);
    return {
        isBackEventTrigger: isBackEventTrigger,
        onPreventBackEvent: onPreventBackEvent
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useBackEventHandler);


/***/ }),

/***/ 35613:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62230);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85244);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98240);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10712);
/* harmony import */ var _utils_url__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74735);






var NavigatorType;
(function(NavigatorType) {
    NavigatorType["PushScreen"] = "PUSH_SCREEN";
    NavigatorType["ReplaceScreen"] = "REPLACE_SCREEN";
    NavigatorType["PopToTop"] = "POP_TO_TOP";
    NavigatorType["Back"] = "BACK";
    NavigatorType["JumpTo"] = "JUMP_TO";
    NavigatorType["Navigate"] = "NAVIGATE";
})(NavigatorType || (NavigatorType = {}));
var useNavigator = function() {
    var _ref = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)(), push = _ref.push, replace = _ref.replace, routerProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, [
        "push",
        "replace"
    ]);
    var query = routerProps.query;
    var pushScreen = function(param, options) {
        var params = param.params, url = param.url;
        if ((0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__/* .isWebView */ .vp)()) {
            return window.history.replaceState({}, "", "".concat((0,_utils_url__WEBPACK_IMPORTED_MODULE_2__/* .addQueryString */ .sC)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, query), {
                routeType: NavigatorType.PushScreen,
                nextUrl: "".concat(url).concat((0,_utils_url__WEBPACK_IMPORTED_MODULE_2__/* .addQueryString */ .sC)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, params)))
            }))));
        }
        if (options === null || options === void 0 ? void 0 : options.disabledWebRoute) {
            return;
        }
        return push("".concat(url).concat((0,_utils_url__WEBPACK_IMPORTED_MODULE_2__/* .addQueryString */ .sC)(params)));
    };
    var popToTopScreen = function(url, options) {
        if ((0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__/* .isWebView */ .vp)()) {
            return window.history.replaceState({}, "", "?routeType=".concat(NavigatorType.PopToTop));
        }
        if (!url) {
            return;
        }
        if (options === null || options === void 0 ? void 0 : options.disabledWebRoute) {
            return;
        }
        return push(url);
    };
    var jumpToScreen = function(param, options) {
        var tabName = param.tabName, params = param.params, url = param.url;
        if ((0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__/* .isWebView */ .vp)()) {
            return window.history.replaceState({}, "", "".concat((0,_utils_url__WEBPACK_IMPORTED_MODULE_2__/* .addQueryString */ .sC)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, query), {
                tabName: tabName,
                routeType: NavigatorType.JumpTo,
                nextUrl: "".concat(url).concat((0,_utils_url__WEBPACK_IMPORTED_MODULE_2__/* .addQueryString */ .sC)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, params)))
            }))));
        }
        if (options === null || options === void 0 ? void 0 : options.disabledWebRoute) {
            return;
        }
        return push("".concat(url).concat((0,_utils_url__WEBPACK_IMPORTED_MODULE_2__/* .addQueryString */ .sC)(params)));
    };
    var replaceScreen = function(param, options) {
        var params = param.params, url = param.url;
        if ((0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__/* .isWebView */ .vp)()) {
            return window.history.replaceState({}, "", "".concat((0,_utils_url__WEBPACK_IMPORTED_MODULE_2__/* .addQueryString */ .sC)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, query), {
                routeType: NavigatorType.ReplaceScreen,
                nextUrl: "".concat(url).concat((0,_utils_url__WEBPACK_IMPORTED_MODULE_2__/* .addQueryString */ .sC)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, params)))
            }))));
        }
        if (options === null || options === void 0 ? void 0 : options.disabledWebRoute) {
            return;
        }
        return replace("".concat(url).concat((0,_utils_url__WEBPACK_IMPORTED_MODULE_2__/* .addQueryString */ .sC)(params)));
    };
    var navigateScreen = function(param, options) {
        var params = param.params, url = param.url;
        if ((0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__/* .isWebView */ .vp)()) {
            return window.history.replaceState({}, "", "".concat((0,_utils_url__WEBPACK_IMPORTED_MODULE_2__/* .addQueryString */ .sC)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, query), {
                routeType: NavigatorType.Navigate,
                nextUrl: "".concat(url).concat((0,_utils_url__WEBPACK_IMPORTED_MODULE_2__/* .addQueryString */ .sC)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, params)))
            }))));
        }
        if (options === null || options === void 0 ? void 0 : options.disabledWebRoute) {
            return;
        }
        return replace("".concat(url).concat((0,_utils_url__WEBPACK_IMPORTED_MODULE_2__/* .addQueryString */ .sC)(params)));
    };
    var back = function() {
        if ((0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__/* .isWebView */ .vp)()) {
            return window.history.replaceState({}, "", (0,_utils_url__WEBPACK_IMPORTED_MODULE_2__/* .addQueryString */ .sC)({
                routeType: NavigatorType.Back
            }));
        }
        return window.history.back();
    };
    var pushAppScreen = function(param) {
        var screenName = param.screenName, params = param.params;
        return (0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__/* .sendPostMessageToNative */ .T0)(_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__/* .NATIVE_POST_MESSAGE_TYPE.MOVE_TO_PAGE */ .nn.MOVE_TO_PAGE, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            screenName: screenName
        }, params && {
            params: params
        }));
    };
    var jumpToAppScreen = function(param) {
        var tabName = param.tabName, screenName = param.screenName, params = param.params;
        return (0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__/* .sendPostMessageToNative */ .T0)(_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__/* .NATIVE_POST_MESSAGE_TYPE.MOVE_TO_TAB_HOME */ .nn.MOVE_TO_TAB_HOME, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            tabName: tabName,
            screenName: screenName
        }, params && {
            params: params
        }));
    };
    var replaceAppScreen = function(param) {
        var screenName = param.screenName, params = param.params;
        return (0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__/* .sendPostMessageToNative */ .T0)(_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__/* .NATIVE_POST_MESSAGE_TYPE.REPLACE_TO_PAGE */ .nn.REPLACE_TO_PAGE, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            screenName: screenName
        }, params && {
            params: params
        }));
    };
    var navigateAppScreen = function(param) {
        var screenName = param.screenName, params = param.params;
        return (0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__/* .sendPostMessageToNative */ .T0)(_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__/* .NATIVE_POST_MESSAGE_TYPE.NAVIGATE_TO_PAGE */ .nn.NAVIGATE_TO_PAGE, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            screenName: screenName
        }, params && {
            params: params
        }));
    };
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, routerProps), {
        query: query,
        push: push,
        pushScreen: pushScreen,
        popToTopScreen: popToTopScreen,
        jumpToScreen: jumpToScreen,
        replace: replace,
        replaceScreen: replaceScreen,
        navigateScreen: navigateScreen,
        pushAppScreen: pushAppScreen,
        jumpToAppScreen: jumpToAppScreen,
        replaceAppScreen: replaceAppScreen,
        navigateAppScreen: navigateAppScreen,
        back: back
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (useNavigator);


/***/ }),

/***/ 51591:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ry": function() { return /* binding */ REPORT_TYPE; },
/* harmony export */   "bA": function() { return /* binding */ ROLE_TYPE; }
/* harmony export */ });
/* unused harmony export modalType */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(22710);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(81541);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(22970);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(85945);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var _components_atom_icon_Report_QnaReport__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24903);
/* harmony import */ var _components_atom_icon_Report_UserBlock__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76815);
/* harmony import */ var _components_atom_icon_Report_UserReport__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68764);
/* harmony import */ var _components_atom_icon_Report_UserUnBlock__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(66875);
/* harmony import */ var _types_modal__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(74701);
/* harmony import */ var _qna_mobile_qna_gql_impl__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4365);
/* harmony import */ var _useModal__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(98266);
/* harmony import */ var _useToast__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(17722);















var REPORT_TYPE = {
    QUESTION: "question",
    ANSWER: "answer",
    BOARD_POST: "board_post",
    BOARD_POST_COMMENT: "board_post_comment"
};
var ROLE_TYPE = {
    USER: "user",
    DOCTOR: "doctor",
    AI: "AI"
};
var modalType = {
    setUserBlock: {
        title: function(target) {
            return "".concat(target, "를 차단할까요?");
        },
        body: function(isUser) {
            return isUser ? "차단한 사용자의 글이 더 이상 보이지 않아요." : "차단한 의료진의 답변을 볼 수 없어요.";
        },
        grantText: "차단",
        toastMessage: function(target) {
            return "".concat(target, "를 차단했어요.");
        }
    },
    resetUserBlock: {
        title: function(target, contentType) {
            return "".concat(target, "의 ").concat(contentType, "을 다시 볼까요?");
        },
        body: function(isUser) {
            return isUser ? "차단을 해제하면 사용자의 글을 볼 수 있어요." : "차단을 해제하면 답변을 볼 수 있어요.";
        },
        grantText: "차단 해제",
        toastMessage: "차단을 해제했어요."
    }
};
var useReportModal = function() {
    var queryClient = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_11__/* .useQueryClient */ .NL)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), showReportModal = ref[0], setShowReportModal = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(), reportData = ref1[0], setReportData = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(), reportItems = ref2[0], setReportItems = ref2[1];
    var ref3 = (0,_useModal__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(), showModal = ref3.showModal, closeModal = ref3.closeModal;
    var showToast = (0,_useToast__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)().showToast;
    var isUser = (reportData === null || reportData === void 0 ? void 0 : reportData.role) === ROLE_TYPE.USER;
    var isQuestion = (reportData === null || reportData === void 0 ? void 0 : reportData.targetType) === REPORT_TYPE.QUESTION;
    var isBlocked = reportData === null || reportData === void 0 ? void 0 : reportData.isBlocked;
    var targetRoleName = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return isUser ? "사용자" : "의료진";
    }, [
        isUser
    ]);
    var contentType = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return isUser ? "글" : "답변";
    }, [
        isUser
    ]);
    var ref4 = (0,_qna_mobile_qna_gql_impl__WEBPACK_IMPORTED_MODULE_8__/* .useSetBlockingAccountMutation */ .vB)({
        onError: function() {
            showToast({
                message: "요청에 실패했습니다."
            });
            onCloseReportModal();
        }
    }), blockMutate = ref4.mutate;
    var onCloseReportModal = function() {
        setShowReportModal(false);
        setReportData(undefined);
        setReportItems([]);
    };
    var onShowReportModal = function(data) {
        setReportData(data);
    };
    var onReportUser = function() {
        next_router__WEBPACK_IMPORTED_MODULE_1___default().push("/content/report?targetId=".concat(reportData === null || reportData === void 0 ? void 0 : reportData.targetId, "&type=").concat(reportData === null || reportData === void 0 ? void 0 : reportData.targetType, "&report_type=user"));
    };
    var onReportQna = function() {
        next_router__WEBPACK_IMPORTED_MODULE_1___default().push("/content/report?targetId=".concat(reportData === null || reportData === void 0 ? void 0 : reportData.targetId, "&type=").concat(reportData === null || reportData === void 0 ? void 0 : reportData.targetType, "&report_type=").concat(reportData === null || reportData === void 0 ? void 0 : reportData.targetType));
    };
    var onBlockMutate = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(function(_isBlocked) {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_13__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!reportData) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            blockMutate({
                                blockingAccountMutationRequest: {
                                    blockTargetRoleType: reportData === null || reportData === void 0 ? void 0 : reportData.role,
                                    blockTargetId: reportData === null || reportData === void 0 ? void 0 : reportData.roleId
                                }
                            }, {
                                onSuccess: function() {
                                    queryClient.invalidateQueries();
                                    showToast({
                                        message: _isBlocked ? modalType.resetUserBlock.toastMessage : modalType.setUserBlock.toastMessage(targetRoleName)
                                    });
                                    closeModal();
                                    onCloseReportModal();
                                }
                            })
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function onBlockMutate(_isBlocked) {
            return _ref.apply(this, arguments);
        };
    }();
    var onBlockUser = function() {
        onCloseReportModal();
        showModal({
            type: _types_modal__WEBPACK_IMPORTED_MODULE_7__/* .MODAL_TYPE.ALERT */ .f.ALERT,
            props: {
                title: isBlocked ? modalType.resetUserBlock.title(targetRoleName, contentType) : modalType.setUserBlock.title(targetRoleName),
                message: isBlocked ? modalType.resetUserBlock.body(isUser) : modalType.setUserBlock.body(isUser),
                buttons: [
                    {
                        label: "취소",
                        onClick: function() {
                            return closeModal();
                        }
                    },
                    {
                        type: isBlocked ? _types_modal__WEBPACK_IMPORTED_MODULE_7__/* .MODAL_BUTTON_TYPE.BOLD */ .J.BOLD : _types_modal__WEBPACK_IMPORTED_MODULE_7__/* .MODAL_BUTTON_TYPE.DANGER */ .J.DANGER,
                        label: isBlocked ? "차단 해제" : "차단",
                        onClick: function() {
                            return onBlockMutate(isBlocked);
                        }
                    }, 
                ]
            }
        });
    };
    var generateSelectList = function() {
        var selectItems = [];
        if ((reportData === null || reportData === void 0 ? void 0 : reportData.role) !== ROLE_TYPE.AI) {
            selectItems = [
                {
                    Icon: function() {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atom_icon_Report_UserReport__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {});
                    },
                    text: isUser ? "사용자 신고" : "의료진 신고",
                    onClick: onReportUser
                },
                {
                    Icon: function() {
                        return isBlocked ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atom_icon_Report_UserUnBlock__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atom_icon_Report_UserBlock__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {});
                    },
                    text: isBlocked ? "차단 해제하기" : isUser ? "사용자 차단" : "의료진 차단",
                    onClick: onBlockUser
                }, 
            ];
        }
        if (!isBlocked) selectItems = [
            {
                Icon: function() {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atom_icon_Report_QnaReport__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {});
                },
                text: isQuestion ? "게시글 신고" : "답변 신고",
                onClick: onReportQna
            }, 
        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(selectItems));
        setReportItems(selectItems);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (reportItems === null || reportItems === void 0 ? void 0 : reportItems.length) {
            return setShowReportModal(true);
        }
        setShowReportModal(false);
    }, [
        reportItems
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (reportData) {
            generateSelectList();
        }
    }, [
        reportData
    ]);
    return {
        showReportModal: showReportModal,
        onShowReportModal: onShowReportModal,
        onCloseReportModal: onCloseReportModal,
        reportData: reportData,
        reportItems: reportItems
    };
};
/* harmony default export */ __webpack_exports__["ZP"] = (useReportModal);


/***/ }),

/***/ 60685:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _hooks_useBackEventHandler__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97899);


var useWebViewBackEventHandler = function(props) {
    var ref = (0,_hooks_useBackEventHandler__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(), isBackEventTrigger = ref.isBackEventTrigger, onPreventBackEvent = ref.onPreventBackEvent;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        onPreventBackEvent(props.isBackEventTrigger);
    }, [
        props.isBackEventTrigger,
        onPreventBackEvent
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (isBackEventTrigger) {
            var ref;
            (ref = props.callback) === null || ref === void 0 ? void 0 : ref.call(props);
        }
    }, [
        isBackEventTrigger,
        props
    ]);
};
/* harmony default export */ __webpack_exports__["Z"] = (useWebViewBackEventHandler);


/***/ }),

/***/ 99690:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ pages_search; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(55351);
// EXTERNAL MODULE: ./src/components/layouts/DefaultLayout.tsx
var DefaultLayout = __webpack_require__(83651);
// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(75190);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
// EXTERNAL MODULE: ./src/components/atom/BreadCrumbs.tsx
var BreadCrumbs = __webpack_require__(27441);
// EXTERNAL MODULE: ./src/components/layouts/TemplateLayout.tsx
var TemplateLayout = __webpack_require__(75275);
// EXTERNAL MODULE: ./src/components/common/AdExchangeComponent.tsx + 1 modules
var AdExchangeComponent = __webpack_require__(72873);
;// CONCATENATED MODULE: ./src/components/templates/mobile/home/HomeSearchTemplate/components/HomeDiseaseSymptomSearch/components/SymptomResultSection/index.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-flex;\n  justify-content: space-between;\n  padding: 24px 24px 12px;\n  align-items: center;\n  ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 16px 0px;\n  margin-top: 16px;\n  align-self: stretch;\n  border-top: 1px solid ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var SymptomResultSection = function(param) {
    var title = param.title, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle, {
                children: title
            }),
            children
        ]
    });
};
var Result = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: children
    });
};
var MoreButton = function(param) {
    var onClick = param.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonWrapper, {
        onClick: onClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonText, {
            children: "더 보기"
        })
    });
};
SymptomResultSection.Result = Result;
SymptomResultSection.MoreButton = MoreButton;
/* harmony default export */ var components_SymptomResultSection = (SymptomResultSection);
var Wrapper = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-5198c6aa-0"
})(_templateObject());
var SectionTitle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-5198c6aa-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.typography.UI13M;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray600;
});
var ButtonWrapper = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-5198c6aa-2"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.color.gray50;
});
var ButtonText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5198c6aa-3"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.typography.UI17R;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray500;
});

// EXTERNAL MODULE: ./src/components/atom/icon/SmallDelete.tsx
var SmallDelete = __webpack_require__(70691);
// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(62230);
// EXTERNAL MODULE: ./src/components/molecules/Modal/SelectModal/ReportSelectModal/index.tsx
var ReportSelectModal = __webpack_require__(28879);
;// CONCATENATED MODULE: ./src/components/common/ClickEventLogWrapper.tsx

function ClickEventLogWrapper_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    ClickEventLogWrapper_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var ClickEventLoggerWrapper = function(param) {
    var children = param.children, onClickEventLog = param.onClickEventLog;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickEventLogWrapper_Wrapper, {
        role: "button",
        onClick: onClickEventLog,
        children: children
    });
};
/* harmony default export */ var ClickEventLogWrapper = (ClickEventLoggerWrapper);
var ClickEventLogWrapper_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fafe9513-0"
})(ClickEventLogWrapper_templateObject());

// EXTERNAL MODULE: ./src/components/common/InfiniteScroll/index.tsx + 1 modules
var InfiniteScroll = __webpack_require__(18163);
// EXTERNAL MODULE: ./src/components/common/LinkTag/index.tsx
var LinkTag = __webpack_require__(23889);
// EXTERNAL MODULE: ./src/components/hospital/HospitalListItem/HospitalListItem.tsx
var HospitalListItem = __webpack_require__(5066);
// EXTERNAL MODULE: ./src/components/templates/f2f/common/HospitalList/HospitalSkeletonList/index.tsx
var HospitalSkeletonList = __webpack_require__(14675);
// EXTERNAL MODULE: ./src/components/atom/buttons/DefaultButton.tsx
var DefaultButton = __webpack_require__(47641);
;// CONCATENATED MODULE: ./src/components/templates/mobile/home/HomeSearchTemplate/components/SearchResult/EmptySearchResult/index.tsx

function EmptySearchResult_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-grid;\n  width: 100%;\n  height: calc(100vh - 180px);\n  text-align: center;\n  align-items: center;\n"
    ]);
    EmptySearchResult_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function EmptySearchResult_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    EmptySearchResult_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function EmptySearchResult_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n\n  margin-top: 20px;\n"
    ]);
    EmptySearchResult_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function EmptySearchResult_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n\n  margin: 8px 0 20px;\n  white-space: pre-wrap;\n"
    ]);
    EmptySearchResult_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  justify-content: center;\n  display: flex;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 9px 20px;\n  border-radius: 8px;\n\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}



var EmptySearchResult = function(param) {
    var handleClickRequestButton = param.handleClickRequestButton;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(EmptySearchResult_Wrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyResultTitle, {
                    children: "검색 결과가 없어요"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyResultOffer, {
                    children: "다른 탭의 정보를 찾아보세요.\n꼭 필요한 정보가 있다면 알려주세요."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonSection, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                        onClick: handleClickRequestButton,
                        children: "정보 요청하기"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var SearchResult_EmptySearchResult = (EmptySearchResult);
var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2888e993-0"
})(EmptySearchResult_templateObject());
var EmptySearchResult_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2888e993-1"
})(EmptySearchResult_templateObject1());
var EmptyResultTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2888e993-2"
})(EmptySearchResult_templateObject2(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI20SB, ";\n    color: ").concat(theme.color.gray600, ";\n  ");
});
var EmptyResultOffer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2888e993-3"
})(EmptySearchResult_templateObject3(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI15R, "\n    color: ").concat(theme.color.gray400, ";\n  ");
});
var ButtonSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2888e993-4"
})(_templateObject4());
var Button = (0,styled_components_browser_esm/* default */.ZP)(DefaultButton/* DefaultButtonStyled */.qY).withConfig({
    componentId: "sc-2888e993-5"
})(_templateObject5(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI15M, ";\n    color: ").concat(theme.color.primary700, ";\n    background: ").concat(theme.color.primary100, ";\n  ");
});

// EXTERNAL MODULE: ./src/types/common.ts
var common = __webpack_require__(70138);
// EXTERNAL MODULE: ./src/types/hospital.ts
var types_hospital = __webpack_require__(24396);
// EXTERNAL MODULE: ./src/components/atom/icon/IconLocationPinMono.tsx
var IconLocationPinMono = __webpack_require__(94781);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(44376);
;// CONCATENATED MODULE: ./src/components/templates/mobile/home/HomeSearchTemplate/components/ResultSection/index.tsx

function ResultSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-bottom: 16px solid ",
        ";\n"
    ]);
    ResultSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ResultSection_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  padding: 24px 24px 12px;\n  align-items: center;\n  ",
        ";\n  color: ",
        ";\n"
    ]);
    ResultSection_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ResultSection_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 16px 0px;\n  align-self: stretch;\n  border-top: 1px solid ",
        ";\n"
    ]);
    ResultSection_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ResultSection_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  color: ",
        ";\n"
    ]);
    ResultSection_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ResultSection_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    ResultSection_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ResultSection_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding: 16px;\n  border-radius: 8px;\n  height: 48px;\n  display: flex;\n  align-items: center;\n  margin-top: ",
        ";\n  justify-content: space-between;\n  background-color: ",
        ";\n"
    ]);
    ResultSection_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  color: ",
        ";\n  display: flex;\n  align-items: center;\n\n  & > svg {\n    margin-right: 6px;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  color: ",
        ";\n  text-decoration: underline;\n  cursor: pointer;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}




var ResultSection = function(param) {
    var title = param.title, children = param.children, hasResultData = param.hasResultData;
    if (!hasResultData) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ResultSection_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ResultSection_SectionTitle, {
                children: title
            }),
            children
        ]
    });
};
var ResultSection_Result = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: children
    });
};
var ResultSection_MoreButton = function(param) {
    var onClick = param.onClick, style = param.style;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ResultSection_ButtonWrapper, {
        onClick: onClick,
        style: style,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResultSection_ButtonText, {
            children: "더보기"
        })
    });
};
var ResultWrapper = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ResultSectionWrapper, {
        children: children
    });
};
var ResultAddress = function(param) {
    var address = param.address, getCurrentLocation = param.getCurrentLocation, _marginTop = param.marginTop, marginTop = _marginTop === void 0 ? 12 : _marginTop;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AddressWrapper, {
        marginTop: marginTop,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Address, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconLocationPinMono/* default */.Z, {
                        size: 16,
                        fill: theme/* default.color.gray700 */.Z.color.gray700
                    }),
                    address
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Subtitle, {
                role: "button",
                onClick: getCurrentLocation,
                children: "현재 위치로 설정"
            })
        ]
    });
};
ResultSection.Result = ResultSection_Result;
ResultSection.MoreButton = ResultSection_MoreButton;
ResultSection.ResultWrapper = ResultWrapper;
ResultSection.ResultAddress = ResultAddress;
/* harmony default export */ var components_ResultSection = (ResultSection);
var ResultSection_Wrapper = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-7063fe21-0"
})(ResultSection_templateObject(), function(param) {
    var theme = param.theme;
    return theme.color.gray30;
});
var ResultSection_SectionTitle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-7063fe21-1"
})(ResultSection_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.typography.UI13M;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray500;
});
var ResultSection_ButtonWrapper = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-7063fe21-2"
})(ResultSection_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.color.gray50;
});
var ResultSection_ButtonText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7063fe21-3"
})(ResultSection_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.typography.UI17M;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray500;
});
var ResultSectionWrapper = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-7063fe21-4"
})(ResultSection_templateObject4());
var AddressWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7063fe21-5"
})(ResultSection_templateObject5(), function(param) {
    var marginTop = param.marginTop;
    return "".concat(marginTop, "px");
}, function(param) {
    var theme = param.theme;
    return theme.color.gray30;
});
var Address = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7063fe21-6"
})(_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.typography.UI14M;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray700;
});
var Subtitle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-7063fe21-7"
})(_templateObject7(), function(param) {
    var theme = param.theme;
    return theme.typography.UI14R;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray300;
});

;// CONCATENATED MODULE: ./src/components/templates/mobile/home/HomeSearchTemplate/components/SearchResult/Hospital/index.tsx

function Hospital_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  > *:not(:last-child) > div {\n    border-bottom-style: solid;\n    border-bottom-width: 1px;\n    border-bottom-color: ",
        ";\n  }\n"
    ]);
    Hospital_templateObject = function _templateObject() {
        return data;
    };
    return data;
}












var HospitalSearchResult = function(param) {
    var hospitalViewModel = param.hospitalViewModel, address = param.address, geolocationPermissionLoading = param.geolocationPermissionLoading, getCurrentLocation = param.getCurrentLocation;
    var ref, ref1, ref2;
    if (hospitalViewModel.isHospitalLoading || geolocationPermissionLoading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(HospitalSkeletonList/* default */.Z, {});
    }
    if (!((ref = hospitalViewModel.hospitalData) === null || ref === void 0 ? void 0 : ref.pages.length)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResult_EmptySearchResult, {
            handleClickRequestButton: hospitalViewModel.handleClickRequestButton
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ResultSection.ResultAddress, {
                address: address,
                getCurrentLocation: getCurrentLocation,
                marginTop: 0
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InfiniteScroll/* default */.Z, {
                isLoading: hospitalViewModel.isHospitalLoading,
                hasNextPage: hospitalViewModel.hasHospitalNextPage,
                fetchNextPage: hospitalViewModel.fetchHospitalNextPage,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HospitalResultWrapper, {
                    children: (ref1 = hospitalViewModel.hospitalData) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.pages) === null || ref2 === void 0 ? void 0 : ref2.map(function(hospital) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkTag/* default */.Z, {
                            onClickNavigateToScreen: function() {
                                return hospitalViewModel.onClickMoveNative(hospital.hospitalPublicId);
                            },
                            href: "".concat(common/* ROUTES.HOSPITAL.DETAIL.path */.Z6.HOSPITAL.DETAIL.path).concat(hospital.hospitalPublicId),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickEventLogWrapper, {
                                onClickEventLog: function() {
                                    return hospitalViewModel.onClickLogHospital(hospital.hospitalPublicId);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HospitalListItem/* default */.Z, {
                                    name: hospital.hospitalName,
                                    distance: hospital.hospitalDistance,
                                    rating: hospital.reviewScore,
                                    reviewTotalCount: hospital.reviewTotalCount,
                                    badges: hospital.hospitalBadges,
                                    imageUrl: hospital.hospitalRepresentativeImageUrl,
                                    address: hospital.hospitalAddress,
                                    status: hospital.hospitalOperationStatus,
                                    isBookable: hospital.isBookable,
                                    representativeDepartmentName: hospital.hospitalRepresentativeDepartmentName,
                                    hospitalPid: hospital.hospitalPublicId,
                                    doctorDetailPageHref: "".concat(common/* ROUTES.HOSPITAL.DETAIL.path */.Z6.HOSPITAL.DETAIL.path).concat(hospital.hospitalPublicId),
                                    onClickMoveToDoctorDetail: function() {
                                        hospitalViewModel.onClickMoveNative(hospital.hospitalPublicId);
                                    },
                                    hasNonF2fDoctors: !!hospital.doctors.find(function(doctor) {
                                        return doctor.contractType === types_hospital/* ContractType.All */.RJ.All;
                                    })
                                }, "event-".concat(hospital.hospitalPublicId))
                            })
                        }, "hospital_".concat(hospital.hospitalPublicId));
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Hospital = (HospitalSearchResult);
var HospitalResultWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-266116db-0"
})(Hospital_templateObject(), function(param) {
    var theme = param.theme;
    return theme.color.gray40;
});

// EXTERNAL MODULE: ./src/constants/zIndex.ts
var zIndex = __webpack_require__(31591);
// EXTERNAL MODULE: ./src/designComponents/organisms/DNSlideTab/index.tsx
var DNSlideTab = __webpack_require__(67788);
// EXTERNAL MODULE: ./src/hooks/useModal.tsx
var useModal = __webpack_require__(98266);
// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(81541);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/QueryClientProvider.mjs
var QueryClientProvider = __webpack_require__(85945);
;// CONCATENATED MODULE: ./src/components/atom/IconFrame.tsx


function IconFrame_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 50%;\n  ",
        "\n"
    ]);
    IconFrame_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var IconFrame = function(param) {
    var _size = param.size, size = _size === void 0 ? 32 : _size, _backgroundColor = param.backgroundColor, backgroundColor = _backgroundColor === void 0 ? theme/* default.color.yellow200 */.Z.color.yellow200 : _backgroundColor, children = param.children, containerStyle = param.containerStyle;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconFrame_Wrapper, {
        size: size,
        backgroundColor: backgroundColor,
        style: (0,_object_spread/* default */.Z)({}, containerStyle),
        children: children
    });
};
var IconFrame_Wrapper = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-8b5f4e38-0"
})(IconFrame_templateObject(), function(param) {
    var size = param.size, backgroundColor = param.backgroundColor;
    return "\n    background: ".concat(backgroundColor, ";\n    width: ").concat(size, "px;\n    height: ").concat(size, "px; \n  ");
});
/* harmony default export */ var atom_IconFrame = (IconFrame);

// EXTERNAL MODULE: ./src/components/atom/icon/ContentFile.tsx
var ContentFile = __webpack_require__(57849);
;// CONCATENATED MODULE: ./src/components/atom/icon/Landscape.tsx

var Landscape = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_2949_51149)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M14.2857 16C15.2325 16 16 15.2325 16 14.2857V1.71429C16 0.767512 15.2325 0 14.2857 0H1.71429C0.767512 0 0 0.767512 0 1.71429V14.2857C0 15.2325 0.767512 16 1.71429 16H14.2857Z",
                        fill: "#A9AEB1"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M11.2891 6.63086C12.3936 6.63086 13.289 5.73543 13.289 4.63086C13.289 3.52629 12.3936 2.63086 11.2891 2.63086C10.1845 2.63086 9.28906 3.52629 9.28906 4.63086C9.28906 5.73543 10.1845 6.63086 11.2891 6.63086Z",
                        fill: "#565C65"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M10.4638 16.0006C10.0852 13.8311 9.00254 11.8769 7.40897 10.4867C5.81541 9.09648 3.81459 8.36069 1.76355 8.41058C1.17179 8.40888 0.581246 8.46818 0 8.58768V14.2863C0 15.2326 0.766765 15.9998 1.7129 16.0006H1.71429H10.4638Z",
                        fill: "#565C65"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M10.084 11.3601C10.9791 12.6584 11.5919 14.16 11.8702 15.7547C11.8845 15.8364 11.8915 15.9186 11.8915 16.0003H14.2848C15.2316 16.0003 15.9991 15.2328 15.9991 14.286V11.0737C15.2308 10.9297 14.4475 10.857 13.6608 10.8574C12.4452 10.855 11.2388 11.0252 10.084 11.3601Z",
                        fill: "#565C65"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_2949_51149",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var icon_Landscape = (Landscape);

// EXTERNAL MODULE: ./src/components/atom/icon/MailChatBubbleTypingOval.tsx
var MailChatBubbleTypingOval = __webpack_require__(20053);
// EXTERNAL MODULE: ./src/components/atom/icon/Report/QnaReport.tsx
var QnaReport = __webpack_require__(24903);
// EXTERNAL MODULE: ./src/components/atom/icon/Report/UserBlock.tsx
var UserBlock = __webpack_require__(76815);
// EXTERNAL MODULE: ./src/components/atom/icon/Report/UserReport.tsx
var UserReport = __webpack_require__(68764);
;// CONCATENATED MODULE: ./src/components/atom/icon/UserBlockRemove.tsx

var UserBlockRemove = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_2949_51163)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M5.71429 6.85714C7.60783 6.85714 9.14286 5.32211 9.14286 3.42857C9.14286 1.53503 7.60783 0 5.71429 0C3.82074 0 2.28571 1.53503 2.28571 3.42857C2.28571 5.32211 3.82074 6.85714 5.71429 6.85714ZM5.71429 7.99997C6.23345 7.99997 6.73645 8.0692 7.21455 8.19894C6.45671 9.16801 6.00362 10.3902 6.00362 11.716C6.00362 12.6403 6.22312 13.5133 6.61282 14.2857H0.571429C0.255838 14.2857 0 14.0298 0 13.7143C0 10.5583 2.55838 7.99997 5.71429 7.99997Z",
                        fill: "#FF6B6B"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M14.285 11.7154C14.285 10.2964 13.1346 9.14593 11.7154 9.14593C11.319 9.14593 10.9435 9.23571 10.6082 9.39606L14.0349 12.8228C14.1953 12.4874 14.285 12.1119 14.285 11.7154ZM14.7994 14.6888C15.5424 13.9184 15.9993 12.8703 15.9993 11.7154C15.9993 9.34958 14.0814 7.43164 11.7154 7.43164C10.5609 7.43164 9.51305 7.88838 8.74267 8.63106C8.72261 8.64775 8.70315 8.66551 8.68433 8.68433C8.66551 8.70314 8.64775 8.72261 8.63106 8.74267C7.88839 9.51305 7.43164 10.5609 7.43164 11.7154C7.43164 14.0814 9.34959 15.9993 11.7154 15.9993C12.8703 15.9993 13.9184 15.5424 14.6888 14.7994C14.7087 14.7829 14.728 14.7653 14.7466 14.7466C14.7653 14.728 14.7829 14.7087 14.7994 14.6888ZM12.8228 14.0349L9.39606 10.6082C9.23572 10.9435 9.14593 11.319 9.14593 11.7154C9.14593 13.1346 10.2964 14.285 11.7154 14.285C12.1119 14.285 12.4874 14.1952 12.8228 14.0349Z",
                        fill: "#FF6B6B"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_2949_51163",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var icon_UserBlockRemove = (UserBlockRemove);

// EXTERNAL MODULE: ./src/components/templates/mobile/communication/Common/ReportTemplate/index.tsx
var ReportTemplate = __webpack_require__(53137);
// EXTERNAL MODULE: ./src/types/bff/gql-schema.ts
var gql_schema = __webpack_require__(72271);
// EXTERNAL MODULE: ./src/types/modal.ts
var types_modal = __webpack_require__(74701);
// EXTERNAL MODULE: ./src/utils/mobile/RNPlugins.tsx
var RNPlugins = __webpack_require__(10712);
// EXTERNAL MODULE: ./src/hooks/community/mobile/community.gql.impl.tsx
var community_gql_impl = __webpack_require__(42549);
// EXTERNAL MODULE: ./src/hooks/useCustomRouter.tsx
var useCustomRouter = __webpack_require__(77196);
// EXTERNAL MODULE: ./src/hooks/useScreenFocus.tsx
var useScreenFocus = __webpack_require__(50341);
// EXTERNAL MODULE: ./src/hooks/useToast.tsx
var useToast = __webpack_require__(17722);
;// CONCATENATED MODULE: ./src/hooks/usePostReportModal.tsx























var usePostReportModal = function() {
    var focused = (0,useScreenFocus/* default */.Z)();
    var queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    var moveToPage = (0,useCustomRouter/* default */.Z)().moveToPage;
    var showToast = (0,useToast/* default */.Z)().showToast;
    var ref = (0,useModal/* default */.Z)(), showModal = ref.showModal, closeModal = ref.closeModal;
    var ref1 = (0,react.useState)(false), showReportModal = ref1[0], setShowReportModal = ref1[1];
    var ref2 = (0,react.useState)(), reportData = ref2[0], setReportData = ref2[1];
    var ref3 = (0,react.useState)(), reportItems = ref3[0], setReportItems = ref3[1];
    var isPost = (reportData === null || reportData === void 0 ? void 0 : reportData.targetType) === ReportTemplate/* REPORT_TYPE.BOARD_POST */.Ry.BOARD_POST;
    var reportType = isPost ? "게시글" : "댓글";
    var ref4 = (0,community_gql_impl/* useDeleteBoardPostMutation */.Xj)(), deleteBoardPost = ref4.mutate;
    var ref5 = (0,community_gql_impl/* useDeleteBoardCommentMutation */.t_)(), deleteBoardComment = ref5.mutate;
    // Admin Blind post, comment, postAttachment
    var ref6 = (0,community_gql_impl/* useBlindBoardPostMutation */.oQ)(), blindBoardPost = ref6.mutate;
    var ref7 = (0,community_gql_impl/* useBlindBoardCommentMutation */.A_)(), blindBoardComment = ref7.mutate;
    var ref8 = (0,community_gql_impl/* useBlindBoardPostAttachmentMutation */.fK)(), blindBoardPostAttachment = ref8.mutate;
    var ref9 = (0,community_gql_impl/* useUpdateBlindBoardPostOnlyMutation */.Y3)(), onUpdateBlindBoardPostOnly = ref9.mutate;
    var ref10 = (0,community_gql_impl/* useUpdateBlindBoardCommentOnlyMutation */.zd)(), onUpdateBlindBoardCommentOnly = ref10.mutate;
    var onCloseReportModal = function() {
        setShowReportModal(false);
        setReportData(undefined);
        setReportItems([]);
    };
    var onShowReportModal = function(data) {
        setReportData(data);
    };
    var onReportPost = function(isReportUser) {
        if (reportData) {
            setShowReportModal(false);
            var report_type = isReportUser ? "user" : reportData === null || reportData === void 0 ? void 0 : reportData.targetType;
            moveToPage({
                webLink: "".concat(common/* ROUTES.COMMON.REPORT.path */.Z6.COMMON.REPORT.path, "?targetId=").concat(reportData === null || reportData === void 0 ? void 0 : reportData.targetId, "&type=").concat(reportData === null || reportData === void 0 ? void 0 : reportData.targetType, "&report_type=").concat(report_type),
                mobileScreenName: common/* ROUTES.COMMON.REPORT.appScreenName */.Z6.COMMON.REPORT.appScreenName,
                params: {
                    targetId: reportData.targetId,
                    type: reportData.targetType,
                    report_type: report_type
                }
            });
        }
    };
    var onError = function() {
        showToast({
            message: "요청에 실패했습니다."
        });
        onCloseReportModal();
    };
    var onSuccess = function() {
        showToast({
            message: "".concat(reportType, "을 삭제했어요")
        });
        if ((reportData === null || reportData === void 0 ? void 0 : reportData.isDetailPage) && isPost) {
            setTimeout(function() {
                return (0,RNPlugins/* historyBack */.$i)();
            }, 1600);
        }
        queryClient.invalidateQueries();
        closeModal();
    };
    var onDeletePost = function() {
        if (reportData) {
            deleteBoardPost({
                boardPostPid: reportData.targetId
            }, {
                onError: onError,
                onSuccess: onSuccess
            });
        }
    };
    var onDeleteComment = function() {
        if (reportData) {
            deleteBoardComment({
                boardCommentPid: reportData.targetId
            }, {
                onError: onError,
                onSuccess: onSuccess
            });
        }
    };
    var onSuccessMutationByAdmin = function(param) {
        var type = param.type, count = param.count, days = param.days;
        closeModal();
        if ((reportData === null || reportData === void 0 ? void 0 : reportData.isDetailPage) && type === "blindPost") {
            setTimeout(function() {
                return (0,RNPlugins/* historyBack */.$i)();
            }, 1600);
        }
        switch(type){
            case "blindPost":
            case "blindComment":
                {
                    var formattedType = type === "blindPost" ? "게시글" : "댓글";
                    return showToast({
                        message: "해당 ".concat(formattedType, " 삭제와 사용자의 커뮤니티 이용을 제한 했어요. (누적 ").concat(count, "회 ").concat(days, ")")
                    });
                }
            case "blindPostAttachment":
                {
                    return showToast({
                        message: "이미지를 숨김 처리했어요."
                    });
                }
        }
        queryClient.invalidateQueries();
    };
    var onSuccessMutationOnlyBlindByAdmin = function() {
        closeModal();
        if (isPost) {
            setTimeout(function() {
                return (0,RNPlugins/* historyBack */.$i)();
            }, 1600);
        }
        showToast({
            message: "해당 ".concat(isPost ? "게시글" : "댓글", "을 삭제했어요.")
        });
        queryClient.invalidateQueries();
    };
    var onDeletePostAndBannedByAdmin = function() {
        if (reportData) {
            blindBoardPost({
                boardPostPid: reportData.targetId
            }, {
                onError: onError,
                onSuccess: function(data) {
                    return onSuccessMutationByAdmin({
                        type: "blindPost",
                        count: data.blindBoardPost.userBlindedCount,
                        days: data.blindBoardPost.userBannedDayCountMessage
                    });
                }
            });
        }
    };
    var onDeleteCommentAndBannedByAdmin = function() {
        if (reportData) {
            blindBoardComment({
                boardCommentPid: reportData.targetId
            }, {
                onError: onError,
                onSuccess: function(data) {
                    return onSuccessMutationByAdmin({
                        type: "blindComment",
                        count: data.blindBoardComment.userBlindedCount,
                        days: data.blindBoardComment.userBannedDayCountMessage
                    });
                }
            });
        }
    };
    var onDeleteOnlyPostByAdmin = function() {
        if (reportData) {
            onUpdateBlindBoardPostOnly({
                boardPostPid: reportData.targetId
            }, {
                onError: onError,
                onSuccess: onSuccessMutationOnlyBlindByAdmin
            });
        }
    };
    var onDeleteOnlyCommentByAdmin = function() {
        if (reportData) {
            onUpdateBlindBoardCommentOnly({
                boardCommentPid: reportData.targetId
            }, {
                onError: onError,
                onSuccess: onSuccessMutationOnlyBlindByAdmin
            });
        }
    };
    var onBlindPostImageByAdmin = function() {
        if (reportData && reportData.attachmentTargetId) {
            blindBoardPostAttachment({
                boardPostAttachmentId: reportData.attachmentTargetId,
                blindType: gql_schema/* AttachmentBlindType.Blinded */.jzP.Blinded
            }, {
                onError: onError,
                onSuccess: function() {
                    return onSuccessMutationByAdmin({
                        type: "blindPostAttachment"
                    });
                }
            });
        }
    };
    var onShowDeleteModal = function() {
        setShowReportModal(false);
        showModal({
            type: types_modal/* MODAL_TYPE.ALERT */.f.ALERT,
            props: {
                title: "".concat(reportType, "을 삭제할까요?"),
                message: "삭제된 ".concat(reportType, "은 다시 복구할 수 없어요."),
                buttons: [
                    {
                        type: types_modal/* MODAL_BUTTON_TYPE.DEFAULT */.J.DEFAULT,
                        label: "취소",
                        onClick: closeModal
                    },
                    {
                        type: types_modal/* MODAL_BUTTON_TYPE.DANGER */.J.DANGER,
                        label: "삭제",
                        onClick: isPost ? onDeletePost : onDeleteComment
                    }, 
                ]
            }
        });
    };
    var onShowImageBlindModalByAdmin = function() {
        setShowReportModal(false);
        showModal({
            type: types_modal/* MODAL_TYPE.ALERT */.f.ALERT,
            props: {
                title: "이미지를 숨김 처리할까요?",
                message: "커뮤니티 정책에 위반한 이미지가 맞는지 한 번 더 확인해주세요.",
                buttons: [
                    {
                        type: types_modal/* MODAL_BUTTON_TYPE.DEFAULT */.J.DEFAULT,
                        label: "취소",
                        onClick: closeModal
                    },
                    {
                        type: types_modal/* MODAL_BUTTON_TYPE.DANGER */.J.DANGER,
                        label: "블라인드 처리",
                        onClick: onBlindPostImageByAdmin
                    }, 
                ]
            }
        });
    };
    var onShowDeleteAndBannedModalByAdmin = function() {
        setShowReportModal(false);
        showModal({
            type: types_modal/* MODAL_TYPE.ALERT */.f.ALERT,
            props: {
                title: "".concat(reportType, " 삭제 및 이용 제한 할까요?"),
                message: "커뮤니티 정책에 위반한 ".concat(reportType, "이 맞는지 한 번 더 확인해 주세요. 자동으로 이용 제한도 걸리게 돼요."),
                buttons: [
                    {
                        type: types_modal/* MODAL_BUTTON_TYPE.DEFAULT */.J.DEFAULT,
                        label: "취소",
                        onClick: closeModal
                    },
                    {
                        type: types_modal/* MODAL_BUTTON_TYPE.DANGER */.J.DANGER,
                        label: "삭제",
                        onClick: isPost ? onDeletePostAndBannedByAdmin : onDeleteCommentAndBannedByAdmin
                    }, 
                ]
            }
        });
    };
    var onShowOnlyDeleteModalByAdmin = function() {
        setShowReportModal(false);
        showModal({
            type: types_modal/* MODAL_TYPE.ALERT */.f.ALERT,
            props: {
                title: "해당 ".concat(reportType, "을 삭제할까요?"),
                message: "커뮤니티 정책에 위반한 ".concat(reportType, "이 맞는지 한 번 더 확인해 주세요."),
                buttons: [
                    {
                        type: types_modal/* MODAL_BUTTON_TYPE.DEFAULT */.J.DEFAULT,
                        label: "취소",
                        onClick: closeModal
                    },
                    {
                        type: types_modal/* MODAL_BUTTON_TYPE.DANGER */.J.DANGER,
                        label: "삭제",
                        onClick: isPost ? onDeleteOnlyPostByAdmin : onDeleteOnlyCommentByAdmin
                    }, 
                ]
            }
        });
    };
    var generateAdminSelectList = function() {
        var selectItems = [];
        if (isPost) {
            selectItems = [
                {
                    Icon: function() {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(atom_IconFrame, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentFile/* default */.Z, {
                                size: 16,
                                bodyColor: theme/* default.color.red500 */.Z.color.red500,
                                edgeColor: theme/* default.color.red300 */.Z.color.red300
                            })
                        });
                    },
                    text: "게시글 삭제",
                    onClick: onShowOnlyDeleteModalByAdmin
                },
                {
                    Icon: function() {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(atom_IconFrame, {
                            backgroundColor: theme/* default.color.red200 */.Z.color.red200,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_UserBlockRemove, {})
                        });
                    },
                    text: "게시글 삭제 (이용 제한 포함)",
                    onClick: onShowDeleteAndBannedModalByAdmin
                }, 
            ];
            if (reportData.attachmentTargetId) {
                selectItems = [
                    {
                        Icon: function() {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(atom_IconFrame, {
                                backgroundColor: theme/* default.color.gray100 */.Z.color.gray100,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_Landscape, {})
                            });
                        },
                        text: "이미지 블라인드",
                        onClick: onShowImageBlindModalByAdmin
                    }, 
                ].concat((0,_to_consumable_array/* default */.Z)(selectItems));
            }
        }
        if (!isPost) {
            selectItems = [
                {
                    Icon: function() {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(atom_IconFrame, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MailChatBubbleTypingOval/* default */.Z, {
                                color: theme/* default.color.red500 */.Z.color.red500
                            })
                        });
                    },
                    text: "댓글 삭제",
                    onClick: onShowOnlyDeleteModalByAdmin
                },
                {
                    Icon: function() {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(atom_IconFrame, {
                            backgroundColor: theme/* default.color.red200 */.Z.color.red200,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_UserBlockRemove, {})
                        });
                    },
                    text: "댓글 삭제 (이용 제한 포함)",
                    onClick: onShowDeleteAndBannedModalByAdmin
                }, 
            ];
        }
        setReportItems(selectItems);
    };
    var generateSelectList = function() {
        if (reportData === null || reportData === void 0 ? void 0 : reportData.isAdmin) {
            return generateAdminSelectList();
        }
        var selectItems = [
            {
                Icon: function() {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(QnaReport/* default */.Z, {});
                },
                text: isPost ? "게시글 신고" : "댓글 신고",
                onClick: function() {
                    return onReportPost(false);
                }
            },
            {
                Icon: function() {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(UserReport/* default */.Z, {});
                },
                text: "사용자 신고",
                onClick: function() {
                    return onReportPost(true);
                }
            }, 
        ];
        if (reportData === null || reportData === void 0 ? void 0 : reportData.isMine) {
            selectItems = [
                {
                    Icon: function() {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(UserBlock/* default */.Z, {});
                    },
                    text: "삭제하기",
                    onClick: onShowDeleteModal
                }, 
            ];
        }
        setReportItems(selectItems);
    };
    (0,react.useEffect)(function() {
        if (reportItems === null || reportItems === void 0 ? void 0 : reportItems.length) {
            return setShowReportModal(true);
        }
        setShowReportModal(false);
    }, [
        reportItems
    ]);
    (0,react.useEffect)(function() {
        if (reportData) {
            generateSelectList();
        }
    }, [
        reportData
    ]);
    (0,react.useEffect)(function() {
        if (!focused) {
            onCloseReportModal();
        }
    }, [
        focused
    ]);
    return {
        showReportModal: showReportModal,
        onShowReportModal: onShowReportModal,
        onCloseReportModal: onCloseReportModal,
        reportData: reportData,
        reportItems: reportItems
    };
};
/* harmony default export */ var hooks_usePostReportModal = (usePostReportModal);

// EXTERNAL MODULE: ./src/hooks/useReportModal.tsx
var useReportModal = __webpack_require__(51591);
// EXTERNAL MODULE: ./src/types/search.ts
var search = __webpack_require__(50728);
// EXTERNAL MODULE: ./src/components/atom/icon/Star.tsx
var Star = __webpack_require__(10211);
;// CONCATENATED MODULE: ./src/components/templates/mobile/home/HomeSearchTemplate/components/SearchResult/Doctor/Doctor.tsx

function Doctor_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  padding: 20px 24px;\n  align-items: center;\n  gap: 16px;\n  align-self: stretch;\n"
    ]);
    Doctor_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Doctor_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 72px;\n  height: 72px;\n  border-radius: 36px;\n  overflow: hidden;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    Doctor_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Doctor_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  background-position: center;\n  background-size: cover;\n"
    ]);
    Doctor_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Doctor_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  background: #5992ff66;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  ",
        ";\n"
    ]);
    Doctor_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Doctor_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  background: rgba(1, 1, 1, 0.5);\n  position: absolute;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  ",
        ";\n"
    ]);
    Doctor_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Doctor_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 8px;\n  flex: 1 0 0;\n"
    ]);
    Doctor_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function Doctor_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 4px;\n  align-self: stretch;\n"
    ]);
    Doctor_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function Doctor_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  align-self: stretch;\n"
    ]);
    Doctor_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  align-self: stretch;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  gap: 6px;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  height: 20px;\n  padding: 0px 4px;\n  justify-content: center;\n  align-items: center;\n  gap: 16px;\n  border-radius: 4px;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: row;\n  align-items: center;\n  display: flex;\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 1px;\n  height: 10px;\n  background-color: ",
        ";\n  margin: 0 6px;\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}




var DoctorBookingStatusTime = function(param) {
    var doctor = param.doctor;
    var _bookingInfo = doctor.bookingInfo, bookingAvailability = _bookingInfo.bookingAvailability, todaySchedule = _bookingInfo.todaySchedule, tomorrowSchedule = _bookingInfo.tomorrowSchedule, isBookable = _bookingInfo.isBookable;
    if (!isBookable) {
        return null;
    }
    switch(bookingAvailability){
        case gql_schema/* BookingAvailability.TodayBookable */.hlw.TodayBookable:
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BookingInfoWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TodayBookable, {
                        children: "오늘 예약"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorSchedule, {
                        children: todaySchedule
                    })
                ]
            });
        case gql_schema/* BookingAvailability.TomorrowBookable */.hlw.TomorrowBookable:
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BookingInfoWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TomorrowBookable, {
                        children: "내일 예약"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorSchedule, {
                        children: tomorrowSchedule
                    })
                ]
            });
        case gql_schema/* BookingAvailability.NotBookable */.hlw.NotBookable:
        default:
            return null;
    }
};
var formatReviewCount = function(count) {
    if (count >= 2000) return "2000+";
    if (count >= 1500) return "1500+";
    if (count >= 1000) return "1000+";
    if (count >= 500) return "500+";
    if (count >= 300) return "300+";
    if (count >= 200) return "200+";
    if (count >= 100) return "100+";
    if (count >= 50) return "50+";
    if (count >= 20) return "20+";
    if (count >= 10) return "10+";
    return String(count);
};
var Doctor = function(param) {
    var doctor = param.doctor, onClick = param.onClick;
    var ref, ref1;
    var isSpecialist = !!doctor.professionalDepartment;
    var isReadyForVideoRequest = doctor.readyForVideoCall;
    var hasTag = isSpecialist || isReadyForVideoRequest;
    var reviewAverage = (ref = Number(doctor === null || doctor === void 0 ? void 0 : doctor.reviewAverageRating)) === null || ref === void 0 ? void 0 : ref.toFixed(1);
    var hasProfileUrl = !!doctor.profileUrl;
    var isNotAvailable = doctor.bookingInfo.bookingAvailability === gql_schema/* BookingAvailability.NotBookable */.hlw.NotBookable || !doctor.bookingInfo.isBookable;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Doctor_Wrapper, {
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(NameAndReview, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DoctorAndHospitalName, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorName, {
                                        children: doctor.name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HospitalName, {
                                        children: doctor.hospitalV2.hospitalName
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StarAndReviewAndRating, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Star/* default */.Z, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ReviewAndRating, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AverageRating, {
                                                children: reviewAverage
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ReviewCount, {
                                                children: [
                                                    "(",
                                                    formatReviewCount(doctor.reviewCount),
                                                    ")"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorBookingStatusTime, {
                        doctor: doctor
                    }),
                    hasTag && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tags, {
                        children: [
                            isSpecialist && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProfessionalTag, {
                                children: [
                                    (ref1 = doctor.professionalDepartment) === null || ref1 === void 0 ? void 0 : ref1.name,
                                    "전문의"
                                ]
                            }),
                            isReadyForVideoRequest && /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoTag, {
                                children: "영상진료"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProfileImageWrapper, {
                children: [
                    hasProfileUrl ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileImage, {
                        style: {
                            backgroundImage: 'url("'.concat(doctor.profileUrl, '")')
                        }
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultProfileImage, {
                        children: doctor.name
                    }),
                    isNotAvailable && /*#__PURE__*/ (0,jsx_runtime.jsx)(ClosedOverlap, {
                        children: "예약 마감"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Doctor_Doctor = (Doctor);
var Doctor_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ceadc88e-0"
})(Doctor_templateObject());
var ProfileImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ceadc88e-1"
})(Doctor_templateObject1());
var ProfileImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ceadc88e-2"
})(Doctor_templateObject2());
var DefaultProfileImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ceadc88e-3"
})(Doctor_templateObject3(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI22SB, ";\n    color: ").concat(theme.color.white, ";\n  ");
});
var ClosedOverlap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ceadc88e-4"
})(Doctor_templateObject4(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI13SB, ";\n    color: ").concat(theme.color.white, ";\n  ");
});
var Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ceadc88e-5"
})(Doctor_templateObject5());
var NameAndReview = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ceadc88e-6"
})(Doctor_templateObject6());
var DoctorAndHospitalName = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ceadc88e-7"
})(Doctor_templateObject7());
var DoctorName = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ceadc88e-8"
})(_templateObject8(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI17SB, ";\n    color: ").concat(theme.color.gray600, ";\n  ");
});
var HospitalName = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ceadc88e-9"
})(_templateObject9(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI13R, ";\n    color: ").concat(theme.color.gray200, ";\n  ");
});
var StarAndReviewAndRating = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ceadc88e-10"
})(_templateObject10());
var ReviewAndRating = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ceadc88e-11"
})(_templateObject11());
var AverageRating = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ceadc88e-12"
})(_templateObject12(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI13M, ";\n    color: ").concat(theme.color.gray600, ";\n  ");
});
var ReviewCount = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ceadc88e-13"
})(_templateObject13(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI13M, ";\n    color: ").concat(theme.color.gray300, ";\n  ");
});
var Tags = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ceadc88e-14"
})(_templateObject14());
var Tag = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ceadc88e-15"
})(_templateObject15());
var VideoTag = (0,styled_components_browser_esm/* default */.ZP)(Tag).withConfig({
    componentId: "sc-ceadc88e-16"
})(_templateObject16(), function(param) {
    var theme = param.theme;
    return "\n    background: ".concat(theme.color.gray30, ";\n    ").concat(theme.typography.UI12M, ";\n    color: ").concat(theme.color.gray300, ";\n  ");
});
var ProfessionalTag = (0,styled_components_browser_esm/* default */.ZP)(Tag).withConfig({
    componentId: "sc-ceadc88e-17"
})(_templateObject17(), function(param) {
    var theme = param.theme;
    return "\n    background: ".concat(theme.color.blue100, ";\n    ").concat(theme.typography.UI12M, ";\n    color: ").concat(theme.color.blue600, ";\n  ");
});
var BookingInfoWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ceadc88e-18"
})(_templateObject18());
var BookingStatus = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ceadc88e-19"
})(_templateObject19(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI13SB, ";\n  ");
});
var TodayBookable = (0,styled_components_browser_esm/* default */.ZP)(BookingStatus).withConfig({
    componentId: "sc-ceadc88e-20"
})(_templateObject20(), function(param) {
    var theme = param.theme;
    return theme.color.green700;
});
var TomorrowBookable = (0,styled_components_browser_esm/* default */.ZP)(BookingStatus).withConfig({
    componentId: "sc-ceadc88e-21"
})(_templateObject21(), function(param) {
    var theme = param.theme;
    return theme.color.primary600;
});
var Divider = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ceadc88e-22"
})(_templateObject22(), function(param) {
    var theme = param.theme;
    return theme.color.gray100;
});
var DoctorSchedule = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ceadc88e-23"
})(_templateObject23(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI13R, ";\n    color: ").concat(theme.color.gray300, ";\n  ");
}); //
 // const PriceAndPoint = styled.div`
 //   display: flex;
 //   flex-direction: column;
 //   justify-content: flex-end;
 //   align-items: flex-start;
 //   align-self: stretch;
 // `;
 //
 // const PointRow = styled.div`
 //   display: flex;
 //   align-items: center;
 //   gap: 2px;
 // `;
 //
 // const PointDescription = styled.div`
 //   ${({ theme }) => `
 //     ${theme.typography.UI11R};
 //     color: ${theme.color.gray400};
 //   `}
 // `;
 //
 // const PointDiscountedPrice = styled.p`
 //   ${({ theme }) => `
 //     ${theme.typography.UI11R};
 //     color: ${theme.color.gray200};
 //   `}
 //   text-decoration: line-through;
 // `;
 //
 // const PriceRow = styled.div`
 //   display: flex;
 //   align-items: center;
 //   gap: 6px;
 // `;
 //
 // const PillPrice = styled.div`
 //   ${({ theme }) => `
 //     ${theme.typography.UI18SB};
 //     color: ${theme.color.gray700};
 //   `}
 // `;
 //
 // const PillNameAndUnit = styled.div`
 //   ${({ theme }) => `
 //     ${theme.typography.UI13M};
 //     color: ${theme.color.gray300};
 //   `}
 // `;

;// CONCATENATED MODULE: ./src/components/atom/icon/QuestionBox.tsx

var QuestionBox = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.5833 45.0348V38.375H23.9999L13.8265 46.5554C12.528 47.5995 10.5833 46.6877 10.5833 45.0348Z",
                fill: "#F1F3F6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "1",
                y: "1",
                width: "46",
                height: "37.375",
                rx: "6",
                fill: "#F1F3F6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M23.669 7.50884C22.6371 7.54995 21.6747 7.8002 20.7235 8.27478C18.6217 9.32333 17.1579 11.3339 16.827 13.6268C16.6838 14.6191 16.7373 15.2085 17.0136 15.6827C17.3123 16.1952 17.7835 16.5589 18.3395 16.7059C18.5038 16.7494 18.5665 16.7556 18.857 16.757C19.2407 16.7589 19.403 16.7318 19.6888 16.6181C20.2736 16.3856 20.7644 15.8447 20.9374 15.2424C20.9721 15.1213 20.9922 14.9863 21.0058 14.7813C21.0354 14.338 21.0612 14.1342 21.1127 13.9383C21.3946 12.8664 22.222 12.0608 23.3084 11.8004C24.6277 11.4841 26.0206 12.1126 26.6394 13.3033C26.8735 13.7536 26.9746 14.1661 26.9739 14.668C26.9729 15.464 26.6708 16.182 26.0993 16.7468C25.7176 17.1239 25.2771 17.3724 24.7384 17.5142C24.5358 17.5675 24.3543 17.5908 23.9704 17.6125C23.5951 17.6338 23.3565 17.6841 23.1218 17.7912C22.5695 18.0434 22.1134 18.5596 21.9505 19.1171C21.8753 19.3743 21.8609 19.6071 21.8609 20.5645C21.8609 21.7462 21.8828 21.926 22.0744 22.3142C22.2464 22.6626 22.5085 22.9568 22.8425 23.1765C23.0314 23.3007 23.2229 23.3839 23.4736 23.4506C23.6397 23.4948 23.6952 23.5 23.9995 23.5C24.3039 23.5 24.3594 23.4948 24.5255 23.4506C24.7762 23.3839 24.9677 23.3007 25.1566 23.1765C25.699 22.8198 26.0639 22.242 26.1121 21.6636L26.1244 21.5153L26.282 21.464C27.813 20.9656 29.1522 19.9477 30.06 18.5924C30.9244 17.3018 31.3466 15.706 31.2313 14.1648C31.1593 13.2015 30.9173 12.3214 30.4939 11.483C29.6288 9.77015 28.1541 8.49535 26.3132 7.8689C25.7444 7.67536 24.9849 7.53518 24.3981 7.51547C24.2377 7.51009 24.0802 7.50351 24.0482 7.50086C24.0161 7.49823 23.8455 7.50182 23.669 7.50884ZM23.4809 26.5108C22.5197 26.6199 21.7143 27.2604 21.3849 28.1778C21.2052 28.6782 21.205 29.3178 21.3846 29.8205C21.6705 30.6212 22.3214 31.2165 23.1367 31.423C24.1719 31.6852 25.2524 31.2641 25.8462 30.367C25.9537 30.2046 26.0447 30.0207 26.1166 29.8205C26.2938 29.327 26.2945 28.7217 26.1184 28.2093C25.8691 27.4839 25.2681 26.8837 24.5417 26.6347C24.229 26.5275 23.7876 26.476 23.4809 26.5108Z",
                fill: "#C6CACE"
            })
        ]
    });
};
/* harmony default export */ var icon_QuestionBox = (QuestionBox);

;// CONCATENATED MODULE: ./src/components/templates/mobile/home/HomeSearchTemplate/components/SearchResult/Doctor/DoctorResultEmpty.tsx

function DoctorResultEmpty_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-grid;\n  width: 100%;\n  height: calc(100vh - 168px);\n  text-align: center;\n  align-items: flex-start;\n"
    ]);
    DoctorResultEmpty_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function DoctorResultEmpty_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 80px 0 80px 0;\n"
    ]);
    DoctorResultEmpty_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function DoctorResultEmpty_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n\n  margin-top: 24px;\n  white-space: pre-wrap;\n"
    ]);
    DoctorResultEmpty_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function DoctorResultEmpty_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n\n  margin: 16px 0 20px 0;\n  white-space: pre-wrap;\n"
    ]);
    DoctorResultEmpty_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function DoctorResultEmpty_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  justify-content: center;\n  display: flex;\n"
    ]);
    DoctorResultEmpty_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function DoctorResultEmpty_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 200px;\n  height: 48px;\n  padding: 0px 20px;\n  border-radius: 8px;\n\n  ",
        "\n"
    ]);
    DoctorResultEmpty_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}




var DoctorResultEmpty = function(param) {
    var handleClickRequestButton = param.handleClickRequestButton;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorResultEmpty_Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DoctorResultEmpty_Wrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_QuestionBox, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorResultEmpty_EmptyResultTitle, {
                    children: "찾으시는 정보가\n없으신가요?"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorResultEmpty_EmptyResultOffer, {
                    children: "증상 / 과목을 선택하여\n진료 정보를 확인해보세요."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorResultEmpty_ButtonSection, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorResultEmpty_Button, {
                        onClick: handleClickRequestButton,
                        children: "증상/과목 전체 보기"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Doctor_DoctorResultEmpty = (DoctorResultEmpty);
var DoctorResultEmpty_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a421f9bf-0"
})(DoctorResultEmpty_templateObject());
var DoctorResultEmpty_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a421f9bf-1"
})(DoctorResultEmpty_templateObject1());
var DoctorResultEmpty_EmptyResultTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a421f9bf-2"
})(DoctorResultEmpty_templateObject2(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI20SB, ";\n    color: ").concat(theme.color.gray600, ";\n  ");
});
var DoctorResultEmpty_EmptyResultOffer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a421f9bf-3"
})(DoctorResultEmpty_templateObject3(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI15R, "\n    color: ").concat(theme.color.gray400, ";\n  ");
});
var DoctorResultEmpty_ButtonSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a421f9bf-4"
})(DoctorResultEmpty_templateObject4());
var DoctorResultEmpty_Button = (0,styled_components_browser_esm/* default */.ZP)(DefaultButton/* DefaultButtonStyled */.qY).withConfig({
    componentId: "sc-a421f9bf-5"
})(DoctorResultEmpty_templateObject5(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI16SB, ";\n    color: ").concat(theme.color.white, ";\n    background: ").concat(theme.color.primary600, ";\n  ");
});

// EXTERNAL MODULE: ./src/components/atom/Skeleton/index.tsx + 1 modules
var Skeleton = __webpack_require__(13971);
;// CONCATENATED MODULE: ./src/components/templates/mobile/home/HomeSearchTemplate/components/SearchResult/Doctor/DoctorSkeleton.tsx

function DoctorSkeleton_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 20px 24px;\n  display: flex;\n  width: 100%;\n"
    ]);
    DoctorSkeleton_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function DoctorSkeleton_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-right: 16px;\n"
    ]);
    DoctorSkeleton_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function DoctorSkeleton_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n"
    ]);
    DoctorSkeleton_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function DoctorSkeleton_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n"
    ]);
    DoctorSkeleton_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var DoctorItemSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DoctorSkeleton_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Left, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                    style: {
                        width: 56,
                        height: 56,
                        borderRadius: 100
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Right, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        style: {
                            width: "25%",
                            height: 20,
                            marginBottom: 4
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        style: {
                            width: "50%",
                            height: 18,
                            marginBottom: 4
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                style: {
                                    width: "20%",
                                    height: 18,
                                    marginRight: 6
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                style: {
                                    width: "20%",
                                    height: 18
                                }
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var DoctorSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: Array.from({
            length: 8
        }).map(function(_, i) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorItemSkeleton, {}, "skeleton_".concat(i));
        })
    });
};
/* harmony default export */ var Doctor_DoctorSkeleton = (DoctorSkeleton);
var DoctorSkeleton_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-637c70ec-0"
})(DoctorSkeleton_templateObject());
var Left = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-637c70ec-1"
})(DoctorSkeleton_templateObject1());
var Row = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-637c70ec-2"
})(DoctorSkeleton_templateObject2());
var Right = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-637c70ec-3"
})(DoctorSkeleton_templateObject3());

;// CONCATENATED MODULE: ./src/components/templates/mobile/home/HomeSearchTemplate/components/SearchResult/Doctor/index.tsx

function SearchResult_Doctor_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  > section > div > div:not(:last-child) {\n    border-bottom-width: 1px;\n    border-bottom-color: ",
        ";\n    border-bottom-style: solid;\n  }\n"
    ]);
    SearchResult_Doctor_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var DoctorSearchResult = function(param) {
    var viewModel = param.viewModel;
    var ref;
    if (viewModel.isLoading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Doctor_DoctorSkeleton, {});
    }
    if (!viewModel.doctors.length) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Doctor_DoctorResultEmpty, {
            handleClickRequestButton: viewModel.moveToCategoryListScreen
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResult_Doctor_Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfiniteScroll/* default */.Z, {
            isLoading: viewModel.isLoading,
            hasNextPage: viewModel.hasNextPage,
            fetchNextPage: viewModel.fetchNextPage,
            children: (ref = viewModel.doctors) === null || ref === void 0 ? void 0 : ref.map(function(doctor) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Doctor_Doctor, {
                    doctor: doctor,
                    onClick: function() {
                        return viewModel.onClickDoctor(doctor.publicId);
                    }
                }, doctor.id);
            })
        })
    });
};
/* harmony default export */ var SearchResult_Doctor = (DoctorSearchResult);
var SearchResult_Doctor_Wrapper = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-180c734d-0"
})(SearchResult_Doctor_templateObject(), function(param) {
    var theme = param.theme;
    return theme.color.gray40;
});

// EXTERNAL MODULE: ./src/components/common/ClickEventLogger.tsx
var ClickEventLogger = __webpack_require__(9558);
// EXTERNAL MODULE: ./src/components/atom/buttons/BoxButton.tsx
var BoxButton = __webpack_require__(36432);
// EXTERNAL MODULE: ./src/components/atom/icon/search/HelpQuestion.tsx
var HelpQuestion = __webpack_require__(74976);
;// CONCATENATED MODULE: ./src/components/templates/mobile/home/HomeSearchTemplate/components/EmptyResult/index.tsx

function EmptyResult_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-grid;\n  width: 100%;\n  height: calc(100vh - 180px);\n  text-align: center;\n  align-items: center;\n"
    ]);
    EmptyResult_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function EmptyResult_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    EmptyResult_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function EmptyResult_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  color: ",
        ";\n  margin-top: 20px;\n"
    ]);
    EmptyResult_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function EmptyResult_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  color: ",
        ";\n  margin: 8px 0 20px;\n"
    ]);
    EmptyResult_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function EmptyResult_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  justify-content: center;\n  display: flex;\n"
    ]);
    EmptyResult_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}




var EmptyResult = function(param) {
    var handleClickRequestButton = param.handleClickRequestButton;
    var handleButtonClick = function() {
        handleClickRequestButton("middle");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyResult_Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(EmptyResultWrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpQuestion/* default */.Z, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyResult_EmptyResultTitle, {
                    children: "지금 궁금한 내용은 뭐였나요?"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(EmptyResult_EmptyResultOffer, {
                    children: [
                        "필요한 정보를 알려주시면",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        "검색 결과 개선에 큰 도움이 돼요"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyResult_ButtonSection, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BoxButton/* default */.ZP, {
                        size: BoxButton/* BOX_BUTTON_SIZE.LARGE */.TY.LARGE,
                        color: BoxButton/* BOX_BUTTON_COLOR.PRIMARY */.po.PRIMARY,
                        onClick: handleButtonClick,
                        children: "정보 요청하기"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var components_EmptyResult = (EmptyResult);
var EmptyResult_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1ae0bd32-0"
})(EmptyResult_templateObject());
var EmptyResultWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1ae0bd32-1"
})(EmptyResult_templateObject1());
var EmptyResult_EmptyResultTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1ae0bd32-2"
})(EmptyResult_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.typography.UI20SB;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray600;
});
var EmptyResult_EmptyResultOffer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1ae0bd32-3"
})(EmptyResult_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.typography.UI15R;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray400;
});
var EmptyResult_ButtonSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1ae0bd32-4"
})(EmptyResult_templateObject4());

;// CONCATENATED MODULE: ./src/components/templates/mobile/home/HomeSearchTemplate/components/RequestInfoBox/index.tsx

function RequestInfoBox_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-grid;\n  width: 100%;\n  text-align: center;\n  align-items: center;\n  padding-top: 40px;\n  margin-bottom: 80px;\n"
    ]);
    RequestInfoBox_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function RequestInfoBox_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  color: ",
        ";\n  margin-top: 20px;\n"
    ]);
    RequestInfoBox_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function RequestInfoBox_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  color: ",
        ";\n  margin: 8px 0 20px;\n"
    ]);
    RequestInfoBox_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function RequestInfoBox_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  justify-content: center;\n  display: flex;\n"
    ]);
    RequestInfoBox_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var RequestInfoBox = function(param) {
    var handleClickRequestButton = param.handleClickRequestButton;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RequestInfoBox_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RequestInfoBox_EmptyResultTitle, {
                children: "찾으시는 정보가 없나요?"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RequestInfoBox_EmptyResultOffer, {
                children: "정보를 알려주시면 빠르게 개선할게요"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RequestInfoBox_ButtonSection, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BoxButton/* default */.ZP, {
                    size: BoxButton/* BOX_BUTTON_SIZE.MEDIUM */.TY.MEDIUM,
                    color: BoxButton/* BOX_BUTTON_COLOR.SECONDARY */.po.SECONDARY,
                    onClick: handleClickRequestButton,
                    children: "정보 요청하기"
                })
            })
        ]
    });
};
/* harmony default export */ var components_RequestInfoBox = (RequestInfoBox);
var RequestInfoBox_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-91bc28c9-0"
})(RequestInfoBox_templateObject());
var RequestInfoBox_EmptyResultTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-91bc28c9-1"
})(RequestInfoBox_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.typography.UI20SB;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray600;
});
var RequestInfoBox_EmptyResultOffer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-91bc28c9-2"
})(RequestInfoBox_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.typography.UI15R;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray400;
});
var RequestInfoBox_ButtonSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-91bc28c9-3"
})(RequestInfoBox_templateObject3());

// EXTERNAL MODULE: ./src/components/atom/text/DefaultText.tsx
var DefaultText = __webpack_require__(40202);
// EXTERNAL MODULE: ./src/utils/format.ts
var format = __webpack_require__(4611);
;// CONCATENATED MODULE: ./src/components/templates/mobile/home/HomeSearchTemplate/components/SearchMagazineItem/index.tsx

function SearchMagazineItem_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 24px;\n  display: flex;\n\n  &:active {\n    background: ",
        ";\n  }\n"
    ]);
    SearchMagazineItem_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SearchMagazineItem_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-right: 20px;\n  width: calc(100% - 116px);\n"
    ]);
    SearchMagazineItem_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SearchMagazineItem_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 8px;\n  * {\n    &:nth-child(1) {\n      ",
        ";\n      color: ",
        ";\n    }\n    &:nth-child(3) {\n      ",
        ";\n      color: ",
        ";\n    }\n  }\n\n  svg {\n    margin: 0 8px;\n  }\n\n  time {\n    visibility: hidden;\n  }\n"
    ]);
    SearchMagazineItem_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SearchMagazineItem_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  ",
        ";\n  color: ",
        ";\n  margin-bottom: 4px;\n"
    ]);
    SearchMagazineItem_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function SearchMagazineItem_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  ",
        ";\n  color: ",
        ";\n"
    ]);
    SearchMagazineItem_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function SearchMagazineItem_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  position: relative;\n  border: 1px solid ",
        ";\n  border-radius: 8px;\n  overflow: hidden;\n  margin-top: 4px;\n"
    ]);
    SearchMagazineItem_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function SearchMagazineItem_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 94px;\n  height: 70px;\n  object-fit: cover;\n"
    ]);
    SearchMagazineItem_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function SearchMagazineItem_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  color: ",
        ";\n  background: ",
        ";\n  padding: 5px 0;\n  text-align: center;\n  border-radius: 4px;\n  margin-top: 4px;\n"
    ]);
    SearchMagazineItem_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function SearchMagazineItem_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    SearchMagazineItem_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}





var SearchMagazineItem = function(param) {
    var magazine = param.magazine, containerStyle = param.containerStyle, onClickMagazine = param.onClickMagazine;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchMagazineItem_Wrapper, {
        onClick: onClickMagazine,
        style: containerStyle,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchMagazineItem_Left, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Category, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: magazine.createdDate
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("time", {
                                dateTime: (0,format/* absoluteTime */.wE)(magazine.createdAt)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                        children: magazine.mobileTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Description, {
                        children: magazine.mobileDescription
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchMagazineItem_Right, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Img, {
                            src: magazine.titleImageUrl
                        })
                    }),
                    magazine.author && /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorColumn, {
                        children: "의사 칼럼"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_SearchMagazineItem = (SearchMagazineItem);
var SearchMagazineItem_Wrapper = styled_components_browser_esm/* default.article.withConfig */.ZP.article.withConfig({
    componentId: "sc-781d2246-0"
})(SearchMagazineItem_templateObject(), function(param) {
    var _$theme = param.theme;
    return _$theme.color.gray30;
});
var SearchMagazineItem_Left = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-781d2246-1"
})(SearchMagazineItem_templateObject1());
var Category = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-781d2246-2"
})(SearchMagazineItem_templateObject2(), theme/* default.typography.UI12M */.Z.typography.UI12M, theme/* default.color.primary500 */.Z.color.primary500, theme/* default.typography.UI12M */.Z.typography.UI12M, theme/* default.color.gray400 */.Z.color.gray400);
var Title = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    componentId: "sc-781d2246-3"
})(SearchMagazineItem_templateObject3(), DefaultText/* EllipsisTextStyle */.Ew, theme/* default.typography.UI16SB */.Z.typography.UI16SB, theme/* default.color.gray700 */.Z.color.gray700);
var Description = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-781d2246-4"
})(SearchMagazineItem_templateObject4(), DefaultText/* EllipsisTextStyle */.Ew, theme/* default.typography.UI14R */.Z.typography.UI14R, theme/* default.color.gray500 */.Z.color.gray500);
var ImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-781d2246-5"
})(SearchMagazineItem_templateObject5(), theme/* default.color.gray200 */.Z.color.gray200);
var Img = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-781d2246-6"
})(SearchMagazineItem_templateObject6());
var DoctorColumn = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-781d2246-7"
})(SearchMagazineItem_templateObject7(), theme/* default.typography.UI12M */.Z.typography.UI12M, theme/* default.color.blue500 */.Z.color.blue500, theme/* default.color.blue100 */.Z.color.blue100);
var SearchMagazineItem_Right = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-781d2246-8"
})(SearchMagazineItem_templateObject8());

// EXTERNAL MODULE: ./src/assets/lottie/loading-dot-ongoing.json
var loading_dot_ongoing = __webpack_require__(65196);
// EXTERNAL MODULE: ./src/assets/lottie/loading-dot-wait.json
var loading_dot_wait = __webpack_require__(28989);
// EXTERNAL MODULE: ./src/components/atom/CustomLottieIcon.tsx
var CustomLottieIcon = __webpack_require__(84655);
// EXTERNAL MODULE: ./src/components/atom/icon/DefaultDoctorProfile.tsx
var DefaultDoctorProfile = __webpack_require__(78764);
// EXTERNAL MODULE: ./src/components/molecules/LazyImage.tsx + 1 modules
var LazyImage = __webpack_require__(52883);
// EXTERNAL MODULE: ./src/components/molecules/QuestionList/QuestionItem/index.tsx + 1 modules
var QuestionItem = __webpack_require__(38427);
// EXTERNAL MODULE: ./src/components/molecules/QuestionList/QuestionItem/BlockQuestion/index.tsx + 1 modules
var BlockQuestion = __webpack_require__(95843);
;// CONCATENATED MODULE: ./src/components/templates/mobile/home/HomeSearchTemplate/components/SearchQuestionItem/index.tsx
/* eslint-disable @typescript-eslint/no-explicit-any */ 
function SearchQuestionItem_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n"
    ]);
    SearchQuestionItem_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SearchQuestionItem_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n\n  ",
        ";\n\n  & > div {\n    margin-right: 8px;\n  }\n"
    ]);
    SearchQuestionItem_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SearchQuestionItem_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  position: relative;\n  margin-right: 8px;\n"
    ]);
    SearchQuestionItem_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SearchQuestionItem_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  img {\n    border: 2px solid white;\n  }\n\n  ",
        ";\n"
    ]);
    SearchQuestionItem_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}












var SearchQuestionItem = function(param) {
    var questionCard = param.questionCard, onClickQuestion = param.onClickQuestion, itemStyle = param.itemStyle;
    var _question = questionCard.question, questionPid = _question.questionPid, isBlockedByMe = _question.isBlockedByMe;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionWrapper, {
        onClick: function() {
            !isBlockedByMe && onClickQuestion(questionPid);
        },
        style: itemStyle,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: isBlockedByMe ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockQuestion/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionItem/* default */.Z, {
                isPaidQuestion: false,
                questionCard: questionCard,
                onClickQuestion: function() {
                    return onClickQuestion(questionPid);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionItem/* default.BottomLeft */.Z.BottomLeft, {
                    children: questionCard.answeredStatus === gql_schema/* QuestionAnsweredStatus.Answered */.G26.Answered ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(QuestionBottomAnswerStatus, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionDoctorImageWrapper, {
                                children: questionCard.answererProfileImageUrls.slice(0, 5).map(function(image, key) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionDoctorImage, {
                                        imageKey: key,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyImage/* default */.ZP, {
                                            width: 28,
                                            height: 28,
                                            objectFit: "cover",
                                            loader: /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultDoctorProfile/* default */.Z, {}),
                                            src: image,
                                            alt: "답변한 의사 프로필 이미지"
                                        })
                                    }, "answered-doctor-".concat(key));
                                })
                            }),
                            questionCard.answererCount,
                            "개의 답변"
                        ]
                    }) : questionCard.question.status !== gql_schema/* QuestionStatus.AwaitingBasicAnswer */.xVd.AwaitingBasicAnswer ? // 답변 중 / 답변 확인 중
                    // 목록
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(QuestionBottomAnswerStatus, {
                        fontColor: questionCard.answeredStatus === gql_schema/* QuestionAnsweredStatus.Answering */.G26.Answering ? theme/* default.color.primary500 */.Z.color.primary500 : theme/* default.color.blue500 */.Z.color.blue500,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLottieIcon/* default */.Z, {
                                width: 24,
                                height: 24,
                                animationData: questionCard.answeredStatus === gql_schema/* QuestionAnsweredStatus.Answering */.G26.Answering ? loading_dot_ongoing : loading_dot_wait,
                                style: {
                                    marginRight: 8
                                }
                            }),
                            questionCard.answeredStatusText
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                })
            }, questionPid)
        })
    });
};
/* harmony default export */ var components_SearchQuestionItem = (SearchQuestionItem);
var QuestionWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a9b65d4f-0"
})(SearchQuestionItem_templateObject(), function(param) {
    var theme = param.theme;
    return "\n    background: ".concat(theme.color.white, ";\n    ");
});
var QuestionBottomAnswerStatus = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a9b65d4f-1"
})(SearchQuestionItem_templateObject1(), function(param) {
    var theme = param.theme, fontColor = param.fontColor;
    return "\n    ".concat(theme.typography.UI14SB, ";\n    color: ").concat(fontColor !== null && fontColor !== void 0 ? fontColor : theme.color.gray700, ";\n  ");
});
var QuestionDoctorImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a9b65d4f-2"
})(SearchQuestionItem_templateObject2());
var QuestionDoctorImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a9b65d4f-3"
})(SearchQuestionItem_templateObject3(), function(param) {
    var imageKey = param.imageKey;
    return "\n    margin-left: -".concat(imageKey ? 8 : 0, "px;\n    z-index: ").concat(5 - imageKey, ";\n  ");
});

;// CONCATENATED MODULE: ./src/components/templates/mobile/home/HomeSearchTemplate/components/index.ts






// EXTERNAL MODULE: ./src/entities/medicine-dictionary/ui/MedicineDictionary.tsx
var MedicineDictionary = __webpack_require__(7265);
// EXTERNAL MODULE: ./src/components/atom/MaterialIcon.tsx
var MaterialIcon = __webpack_require__(17986);
;// CONCATENATED MODULE: ./src/components/templates/mobile/home/HomeSearchTemplate/components/SearchResult/component/DietInjectionFeatureSnippet.tsx


var DietInjectionFeatureSnippet = function(param) {
    var navigateDietInjectionScreen = param.navigateDietInjectionScreen;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex justify-between gap-[16px] py-[16px]",
        onClick: navigateDietInjectionScreen,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center gap-[16px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        alt: "dietInjectionSnippetIcon",
                        src: "/images/search/dietInjectionSnippetIcon.png",
                        className: "h-[40px] w-[40px]"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col gap-[2px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "typography-ui-17sb text-gray-600",
                                children: "다이어트 주사 받기"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "typography-ui-13r text-gray-400",
                                children: "진료비, 약 값 비교부터 예약까지 한 번에"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                name: "keyboard_arrow_right"
            })
        ]
    });
};
/* harmony default export */ var component_DietInjectionFeatureSnippet = (DietInjectionFeatureSnippet);

;// CONCATENATED MODULE: ./src/components/templates/mobile/home/HomeSearchTemplate/components/SearchResult/component/EmergencyContraceptiveFeatureSnippet.tsx


var EmergencyContraceptiveFeatureSnippet = function(param) {
    var navigateToEmergencyContraceptiveScreen = param.navigateToEmergencyContraceptiveScreen;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex justify-between gap-[16px] py-[16px]",
        onClick: navigateToEmergencyContraceptiveScreen,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center gap-[16px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        alt: "dietInjectionSnippetIcon",
                        src: "/images/search/emergencyContraceptiveSnippetIcon.png",
                        className: "h-[40px] w-[40px]"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col gap-[2px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "typography-ui-17sb text-gray-600",
                                children: "사후피임약 진료 예약"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "typography-ui-13r text-gray-400",
                                children: "지금 문 연 병원 확인하고 예약까지 한 번에"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                name: "keyboard_arrow_right"
            })
        ]
    });
};
/* harmony default export */ var component_EmergencyContraceptiveFeatureSnippet = (EmergencyContraceptiveFeatureSnippet);

;// CONCATENATED MODULE: ./src/components/templates/mobile/home/HomeSearchTemplate/components/SearchResult/component/FindPharmacyFeatureSnippet.tsx


var FindPharmacyFeatureSnippet = function(param) {
    var navigateToFindPharmacyScreen = param.navigateToFindPharmacyScreen;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex justify-between gap-[16px] py-[16px]",
        onClick: navigateToFindPharmacyScreen,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center gap-[16px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        alt: "dietInjectionSnippetIcon",
                        src: "/images/search/findPharmacySnippetIcon.png",
                        className: "h-[40px] w-[40px]"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col gap-[2px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "typography-ui-17sb text-gray-600",
                                children: "약국 찾기"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "typography-ui-13r text-gray-400",
                                children: "가까운 약국 찾기부터 약 값 비교까지"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                name: "keyboard_arrow_right"
            })
        ]
    });
};
/* harmony default export */ var component_FindPharmacyFeatureSnippet = (FindPharmacyFeatureSnippet);

;// CONCATENATED MODULE: ./src/components/templates/mobile/home/HomeSearchTemplate/components/SearchResult/component/FeatureByKeyword.tsx





var FeatureByKeyword = function(param) {
    var features = param.features, navigateToFindPharmacyScreen = param.navigateToFindPharmacyScreen, navigateDietInjectionScreen = param.navigateDietInjectionScreen, navigateToEmergencyContraceptiveScreen = param.navigateToEmergencyContraceptiveScreen;
    if (!features) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "border-0 border-b-[16px] border-b-gray-30 border-solid p-[28px_24px_24px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "typography-ui-13m mb-[12px] text-gray-500",
                children: "연관 기능"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: features.map(function(feature) {
                    switch(feature){
                        case search/* EGeneralSearchFeatureType.FindPharmacy */.$p.FindPharmacy:
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(component_FindPharmacyFeatureSnippet, {
                                navigateToFindPharmacyScreen: navigateToFindPharmacyScreen
                            }, feature);
                        case search/* EGeneralSearchFeatureType.EmergencyContraceptive */.$p.EmergencyContraceptive:
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(component_EmergencyContraceptiveFeatureSnippet, {
                                navigateToEmergencyContraceptiveScreen: navigateToEmergencyContraceptiveScreen
                            }, feature);
                        case search/* EGeneralSearchFeatureType.DietInjection */.$p.DietInjection:
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(component_DietInjectionFeatureSnippet, {
                                navigateDietInjectionScreen: navigateDietInjectionScreen
                            }, feature);
                        default:
                            return null;
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var component_FeatureByKeyword = (FeatureByKeyword);

;// CONCATENATED MODULE: ./src/components/templates/mobile/home/HomeSearchTemplate/components/SearchResult/component/IntegratedSearchResultSkeleton.tsx


var IntegratedSearchResultSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "border-0 border-b-[16px] border-b-gray-30 border-solid p-[28px_24px_24px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        className: "mb-[8px] h-[18px] w-[100px]"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        className: "mb-[5px] h-[30px] w-[150px]"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        className: "mb-[8px] h-[30px] w-[230px]"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        className: "mb-[5px] h-[20px] w-[300px]"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        className: "mb-[5px] h-[20px] w-[200px]"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "border-0 border-b-[16px] border-b-gray-30 border-solid bg-gray-40",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mb-[1px] bg-white p-[28px_24px_24px] pb-[16px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                className: "mb-[16px] h-[18px] w-[70px]"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex justify-between gap-[16px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col gap-[2px]",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                className: "h-[18px] w-[70px]"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                className: "h-[24px] w-[140px]"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                className: "mb-[11px] h-[18px] w-[160px]"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex gap-[8px]",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                        className: "h-[20px] w-[60px]"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                        className: "h-[20px] w-[35px]"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                        className: "h-[20px] w-[45px]"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                        className: "h-[120px] w-[120px]"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mb-[1px] bg-white p-[28px_24px_24px] pb-[16px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                className: "mb-[16px] h-[18px] w-[70px]"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex justify-between gap-[16px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col gap-[2px]",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                className: "h-[18px] w-[70px]"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                className: "h-[24px] w-[140px]"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                className: "mb-[11px] h-[18px] w-[160px]"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex gap-[8px]",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                        className: "h-[20px] w-[60px]"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                        className: "h-[20px] w-[35px]"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                        className: "h-[20px] w-[45px]"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                        className: "h-[120px] w-[120px]"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bg-white p-[28px_24px_24px] pb-[16px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                className: "mb-[16px] h-[18px] w-[70px]"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex justify-between gap-[16px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col gap-[2px]",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                className: "h-[18px] w-[70px]"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                className: "h-[24px] w-[140px]"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                className: "mb-[11px] h-[18px] w-[160px]"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex gap-[8px]",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                        className: "h-[20px] w-[60px]"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                        className: "h-[20px] w-[35px]"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                        className: "h-[20px] w-[45px]"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                        className: "h-[120px] w-[120px]"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var component_IntegratedSearchResultSkeleton = (IntegratedSearchResultSkeleton);

;// CONCATENATED MODULE: ./src/components/atom/icon/search/SnippetIcon.tsx

var SnippetIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "104",
        height: "18",
        viewBox: "0 0 104 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M4.16667 2.5C2.97067 2.5 2 3.47067 2 4.66667V13.3333C2 14.5293 2.97067 15.5 4.16667 15.5H8.5C12.088 15.5 15 12.588 15 9C15 5.412 12.088 2.5 8.5 2.5H4.16667ZM6.87067 6.91133C6.87067 6.27 7.39067 5.75 8.032 5.75C8.67333 5.75 9.19333 6.27 9.19333 6.91133V7.856H10.1207C10.762 7.856 11.282 8.376 11.282 9.01733C11.282 9.65867 10.762 10.1787 10.1207 10.1787H9.19333V11.0887C9.19333 11.73 8.67333 12.25 8.032 12.25C7.39067 12.25 6.87067 11.73 6.87067 11.0887V10.1787H5.94333C5.302 10.1787 4.782 9.65867 4.782 9.01733C4.782 8.376 5.302 7.856 5.94333 7.856H6.87067V6.91133Z",
                fill: "#F76707"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.618 6.392V10.662C20.618 12.02 21.164 12.65 22.144 12.65C23.138 12.65 23.684 12.02 23.684 10.662V6.392C23.684 5.048 23.138 4.404 22.144 4.404C21.164 4.404 20.618 5.048 20.618 6.392ZM18.84 10.662V6.392C18.84 3.998 20.156 2.696 22.144 2.696C24.16 2.696 25.476 3.998 25.476 6.392V10.662C25.476 13.042 24.16 14.33 22.144 14.33C20.156 14.33 18.84 13.042 18.84 10.662ZM27.576 14.036V3.34C27.576 2.878 27.968 2.5 28.5 2.5C29.06 2.5 29.424 2.878 29.424 3.34V14.036C29.424 14.498 29.06 14.876 28.5 14.876C27.968 14.876 27.576 14.498 27.576 14.036ZM38.2495 5.286H40.1815V3.34C40.1815 2.878 40.5735 2.5 41.1055 2.5C41.6655 2.5 42.0295 2.878 42.0295 3.34V9.528C42.0295 9.99 41.6655 10.368 41.1055 10.368C40.5735 10.368 40.1815 9.99 40.1815 9.528V6.994H38.2495C37.7875 6.994 37.4095 6.686 37.4095 6.14C37.4095 5.594 37.7875 5.286 38.2495 5.286ZM35.2255 4.46H32.2435C31.8095 4.46 31.4315 4.194 31.4315 3.648C31.4315 3.116 31.8095 2.836 32.2435 2.836H35.4075C37.0035 2.836 37.7595 3.634 37.3395 5.314C36.7935 7.484 34.6655 9.192 32.1315 9.724C31.7115 9.808 31.2635 9.696 31.0955 9.206C30.9275 8.702 31.2355 8.31 31.6275 8.212C33.6015 7.736 35.1275 6.518 35.5195 4.866C35.5895 4.6 35.4775 4.46 35.2255 4.46ZM41.3015 14.596C39.7615 14.218 37.9415 13.238 36.7515 12.146C35.6875 13.392 34.1195 14.358 32.5935 14.652C32.1875 14.736 31.7395 14.554 31.5855 14.05C31.4315 13.56 31.7395 13.168 32.1315 13.056C33.9795 12.538 35.4775 11.32 36.1635 9.78C36.3175 9.444 36.7375 9.262 37.2555 9.43C37.7875 9.598 37.9835 10.116 37.8435 10.438C37.7875 10.564 37.7175 10.704 37.6615 10.816C38.6975 11.81 40.2655 12.636 41.7355 13.014C42.1275 13.112 42.4355 13.504 42.2955 13.994C42.1555 14.498 41.7075 14.694 41.3015 14.596ZM52.5209 10.83V3.34C52.5209 2.878 52.9269 2.5 53.4589 2.5C54.0189 2.5 54.3829 2.878 54.3829 3.34V5.958H55.2509C55.7129 5.958 56.0909 6.28 56.0909 6.84C56.0909 7.4 55.7129 7.722 55.2509 7.722H54.3829V10.83C54.3829 11.292 54.0189 11.67 53.4589 11.67C52.9269 11.67 52.5209 11.292 52.5209 10.83ZM46.5289 14.666C45.0309 14.666 44.4429 14.064 44.4429 12.762V11.32C44.4429 10.858 44.8349 10.48 45.3669 10.48C45.9269 10.48 46.2909 10.858 46.2909 11.32V12.552C46.2909 12.832 46.4309 12.972 46.7389 12.972H53.9629C54.4109 12.972 54.7749 13.266 54.7749 13.812C54.7749 14.358 54.4109 14.666 53.9629 14.666H46.5289ZM44.1769 8.114V4.334C44.1769 3.256 44.6249 2.836 45.7729 2.836H48.9649C50.1129 2.836 50.5609 3.256 50.5609 4.334V8.114C50.5609 9.192 50.1129 9.612 48.9649 9.612H45.7729C44.6249 9.612 44.1769 9.192 44.1769 8.114ZM48.7829 7.792V4.656C48.7829 4.474 48.6989 4.39 48.5169 4.39H46.2209C46.0389 4.39 45.9549 4.474 45.9549 4.656V7.792C45.9549 7.974 46.0389 8.058 46.2209 8.058H48.5169C48.6989 8.058 48.7829 7.974 48.7829 7.792ZM60.5893 5.636C60.5893 6.49 61.2053 7.064 62.0593 7.064C62.9133 7.064 63.5573 6.49 63.5573 5.636C63.5573 4.782 62.9133 4.208 62.0593 4.208C61.2053 4.208 60.5893 4.782 60.5893 5.636ZM58.7553 5.636C58.7553 3.886 60.1553 2.64 62.0593 2.64C63.9773 2.64 65.3913 3.886 65.3913 5.636C65.3913 7.372 63.9773 8.618 62.0593 8.618C60.1553 8.618 58.7553 7.372 58.7553 5.636ZM67.4213 7.904V3.34C67.4213 2.878 67.8273 2.5 68.3593 2.5C68.9193 2.5 69.2833 2.878 69.2833 3.34V4.838H70.1513C70.6133 4.838 70.9913 5.146 70.9913 5.706C70.9913 6.266 70.6133 6.588 70.1513 6.588H69.2833V7.904C69.2833 8.366 68.9193 8.744 68.3593 8.744C67.8273 8.744 67.4213 8.366 67.4213 7.904ZM60.0713 10.494C59.6513 10.494 59.3433 10.228 59.3433 9.794C59.3433 9.346 59.6373 9.08 60.0713 9.08H67.7293C68.7513 9.08 69.2833 9.542 69.2833 10.452V11.222C69.2833 12.132 68.7513 12.594 67.7293 12.594H61.4713C61.2753 12.594 61.1913 12.692 61.1913 12.846V13.084C61.1913 13.238 61.2893 13.322 61.4573 13.322H68.9473C69.3813 13.322 69.6753 13.588 69.6753 14.036C69.6753 14.47 69.3673 14.736 68.9473 14.736H60.8973C59.8753 14.736 59.3433 14.274 59.3433 13.364V12.594C59.3433 11.684 59.8753 11.222 60.8973 11.222H67.1413C67.3373 11.222 67.4213 11.124 67.4213 10.97V10.732C67.4213 10.578 67.3233 10.494 67.1553 10.494H60.0713ZM74.1608 14.666C72.6628 14.666 72.0748 14.064 72.0748 12.762V11.39C72.0748 10.928 72.4668 10.55 72.9988 10.55C73.5588 10.55 73.9368 10.928 73.9368 11.39V12.552C73.9368 12.832 74.0768 12.972 74.3848 12.972H81.7348C82.1828 12.972 82.5468 13.266 82.5468 13.812C82.5468 14.358 82.1828 14.666 81.7348 14.666H74.1608ZM71.6828 8.114V4.334C71.6828 3.256 72.1308 2.836 73.2788 2.836H76.2748C77.4228 2.836 77.8708 3.256 77.8708 4.334V8.114C77.8708 9.192 77.4228 9.612 76.2748 9.612H73.2788C72.1308 9.612 71.6828 9.192 71.6828 8.114ZM76.0928 7.792V4.656C76.0928 4.474 76.0088 4.39 75.8268 4.39H73.7268C73.5448 4.39 73.4608 4.474 73.4608 4.656V7.792C73.4608 7.974 73.5448 8.058 73.7268 8.058H75.8268C76.0088 8.058 76.0928 7.974 76.0928 7.792ZM79.0188 3.928H80.2928V3.34C80.2928 2.878 80.6848 2.5 81.2168 2.5C81.7768 2.5 82.1408 2.878 82.1408 3.34V10.76C82.1408 11.222 81.7768 11.6 81.2168 11.6C80.6848 11.6 80.2928 11.222 80.2928 10.76V8.506H79.0188C78.5988 8.506 78.1928 8.226 78.1928 7.68C78.1928 7.134 78.5848 6.854 79.0188 6.854H80.2928V5.58H79.0188C78.5988 5.58 78.1928 5.3 78.1928 4.754C78.1928 4.208 78.5848 3.928 79.0188 3.928ZM94.9552 4.446H92.5052C92.0712 4.446 91.7072 4.194 91.7072 3.662C91.7072 3.144 92.0712 2.836 92.5052 2.836H95.3892C96.6072 2.836 97.1112 3.326 97.1112 4.446V5.538C97.1112 5.986 96.7332 6.308 96.1872 6.308C95.6692 6.308 95.2492 5.986 95.2492 5.538V4.768C95.2492 4.544 95.1512 4.446 94.9552 4.446ZM91.3152 4.446V5.566C91.3152 5.986 90.9652 6.308 90.4192 6.308C89.9012 6.308 89.5232 5.986 89.5232 5.566V4.768C89.5232 4.544 89.4252 4.446 89.2292 4.446H87.3112C86.8772 4.446 86.5132 4.194 86.5132 3.662C86.5132 3.144 86.8772 2.836 87.3112 2.836H89.5932C90.8112 2.836 91.3152 3.326 91.3152 4.446ZM86.7512 6.616H97.0692C97.4892 6.616 97.8392 6.896 97.8392 7.4C97.8392 7.904 97.4892 8.142 97.0692 8.142H86.7512C86.3312 8.142 85.9812 7.904 85.9812 7.4C85.9812 6.896 86.3312 6.616 86.7512 6.616ZM96.3692 12.482H88.5712V12.972C88.5712 13.126 88.6692 13.21 88.8372 13.21H96.5652C97.0132 13.21 97.3072 13.476 97.3072 13.938C97.3072 14.386 96.9992 14.666 96.5652 14.666H88.2632C87.2412 14.666 86.7092 14.204 86.7092 13.294V10.228C86.7092 9.318 87.2412 8.856 88.2632 8.856H96.3692C96.8032 8.856 97.1112 9.136 97.1112 9.584C97.1112 10.046 96.8172 10.312 96.3692 10.312H88.8372C88.6692 10.312 88.5712 10.396 88.5712 10.55V11.026H96.3692C96.8032 11.026 97.1112 11.306 97.1112 11.754C97.1112 12.216 96.8172 12.482 96.3692 12.482ZM101.191 13.476C101.191 14.106 100.659 14.666 99.9867 14.666C99.3287 14.666 98.7827 14.106 98.7827 13.476C98.7827 12.846 99.3287 12.3 99.9867 12.3C100.659 12.3 101.191 12.846 101.191 13.476ZM99.0627 10.242V3.13C99.0627 2.668 99.4547 2.304 99.9867 2.304C100.547 2.304 100.911 2.668 100.911 3.13V10.242C100.911 10.704 100.547 11.068 99.9867 11.068C99.4547 11.068 99.0627 10.704 99.0627 10.242Z",
                fill: "#F76707"
            })
        ]
    });
};
/* harmony default export */ var search_SnippetIcon = (SnippetIcon);

;// CONCATENATED MODULE: ./src/components/templates/mobile/home/HomeSearchTemplate/components/SearchResult/component/DeliveryGuideSnippet.tsx


var DeliveryGuideSnippet = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "border-0 border-b-[16px] border-b-gray-30 border-solid p-[28px_20px]",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "px-[4px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col gap-[8px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(search_SnippetIcon, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "typography-ui-24b whitespace-pre text-gray-900",
                        children: [
                            "앱으로 처방전 보내고,",
                            "\n",
                            "약국에서 ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-primary-700",
                                children: "방문 수령"
                            }),
                            "하면 돼요!"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "typography-ui-15r text-gray-400",
                        children: "아래에 해당하는 분만 약 배달 받을 수 있어요."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "typography-ui-13m flex flex-col gap-[8px] pt-[8px] text-gray-400",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "flex items-center gap-[8px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "w-[12px]",
                                        children: "•"
                                    }),
                                    "섬, 벽지 거주자"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "flex items-center gap-[8px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "w-[12px]",
                                        children: "•"
                                    }),
                                    "65세 이상 장기요양등급자"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "flex items-center gap-[8px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "w-[12px]",
                                        children: "•"
                                    }),
                                    "등록 장애인"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "flex items-center gap-[8px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "w-[12px]",
                                        children: "•"
                                    }),
                                    "희귀질환자 및 감염병 확진자 (1급, 2급)"
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var component_DeliveryGuideSnippet = (DeliveryGuideSnippet);

;// CONCATENATED MODULE: ./src/components/templates/mobile/home/HomeSearchTemplate/components/SearchResult/component/FaceToFaceDiagnosisSnippet.tsx


var FaceToFaceDiagnosisSnippet = function(param) {
    var keyword = param.keyword;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "border-0 border-b-[16px] border-b-gray-30 border-solid p-[28px_20px]",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "px-[4px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col gap-[8px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(search_SnippetIcon, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "typography-ui-24b whitespace-pre text-gray-900",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-primary-700",
                                children: keyword
                            }),
                            " 진료,",
                            "\n",
                            "병원 방문이 필요해요!"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "typography-ui-15r whitespace-pre text-gray-400",
                        children: [
                            "비대면 처방이 어려운 의약품이 처방될 수 있어",
                            "\n",
                            "병원 방문을 통한 대면 진료가 필요해요."
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var component_FaceToFaceDiagnosisSnippet = (FaceToFaceDiagnosisSnippet);

;// CONCATENATED MODULE: ./src/components/templates/mobile/home/HomeSearchTemplate/components/SearchResult/component/FaceToFacePrescriptionSnippet.tsx


var FaceToFacePrescriptionSnippet = function(param) {
    var keyword = param.keyword;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "border-0 border-b-[16px] border-b-gray-30 border-solid p-[28px_20px]",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "px-[4px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col gap-[8px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(search_SnippetIcon, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "typography-ui-24b whitespace-pre text-gray-900",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-primary-700",
                                children: keyword
                            }),
                            " 처방,",
                            "\n",
                            "병원 방문이 필요해요!"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "typography-ui-15r whitespace-pre text-gray-400",
                        children: [
                            "비대면 처방이 어려운 의약품이 처방될 수 있어",
                            "\n",
                            "병원 방문을 통한 대면 진료가 필요해요."
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var component_FaceToFacePrescriptionSnippet = (FaceToFacePrescriptionSnippet);

;// CONCATENATED MODULE: ./src/components/templates/mobile/home/HomeSearchTemplate/components/SearchResult/component/NonFaceToFaceDiagnosisSnippet.tsx


var NonFaceToFaceDiagnosisSnippet = function(param) {
    var keyword = param.keyword, navigateToDoctorList = param.navigateToDoctorList;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "border-0 border-b-[16px] border-b-gray-30 border-solid p-[28px_20px]",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "px-[4px]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mb-[24px] flex flex-col gap-[8px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(search_SnippetIcon, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: "typography-ui-24b whitespace-pre text-gray-900",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-primary-700",
                                    children: keyword
                                }),
                                " 진료,",
                                "\n",
                                "비대면으로 가능해요!"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "typography-ui-15r text-gray-400",
                            children: "언제 어디서든 편하게 진료 받을 수 있어요."
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: "typography-ui-17sb h-[48px] w-full rounded-[12px] bg-primary-600 text-white",
                    onClick: navigateToDoctorList,
                    children: "비대면 진료 받으러 가기"
                })
            ]
        })
    });
};
/* harmony default export */ var component_NonFaceToFaceDiagnosisSnippet = (NonFaceToFaceDiagnosisSnippet);

;// CONCATENATED MODULE: ./src/components/templates/mobile/home/HomeSearchTemplate/components/SearchResult/component/NonFaceToFacePrescriptionSnippet.tsx


var NonFaceToFacePrescriptionSnippet = function(param) {
    var keyword = param.keyword, navigateToDoctorList = param.navigateToDoctorList;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "border-0 border-b-[16px] border-b-gray-30 border-solid p-[28px_20px]",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "px-[4px]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mb-[24px] flex flex-col gap-[8px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(search_SnippetIcon, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: "typography-ui-24b whitespace-pre text-gray-900",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-primary-700",
                                    children: keyword
                                }),
                                " 처방,",
                                "\n",
                                "비대면으로 가능해요!"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "typography-ui-15r text-gray-400",
                            children: "언제 어디서든 편하게 진료 받을 수 있어요."
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: "typography-ui-17sb h-[48px] w-full rounded-[12px] bg-primary-600 text-white",
                    onClick: navigateToDoctorList,
                    children: "비대면 진료 받으러 가기"
                })
            ]
        })
    });
};
/* harmony default export */ var component_NonFaceToFacePrescriptionSnippet = (NonFaceToFacePrescriptionSnippet);

;// CONCATENATED MODULE: ./src/components/templates/mobile/home/HomeSearchTemplate/components/SearchResult/component/SnippetByKeyword.tsx







var SnippetByKeyword = function(param) {
    var keyword = param.keyword, snippet = param.snippet, navigateToDoctorList = param.navigateToDoctorList;
    if (!snippet) return null;
    switch(snippet){
        case search/* EGeneralSearchSnippetType.NonFaceToFaceDiagnosis */.Dp.NonFaceToFaceDiagnosis:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(component_NonFaceToFaceDiagnosisSnippet, {
                keyword: keyword,
                navigateToDoctorList: function() {
                    return navigateToDoctorList(snippet);
                }
            });
        case search/* EGeneralSearchSnippetType.NonFaceToFacePrescription */.Dp.NonFaceToFacePrescription:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(component_NonFaceToFacePrescriptionSnippet, {
                keyword: keyword,
                navigateToDoctorList: function() {
                    return navigateToDoctorList(snippet);
                }
            });
        case search/* EGeneralSearchSnippetType.FaceToFaceDiagnosis */.Dp.FaceToFaceDiagnosis:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(component_FaceToFaceDiagnosisSnippet, {
                keyword: keyword
            });
        case search/* EGeneralSearchSnippetType.FaceToFacePrescription */.Dp.FaceToFacePrescription:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(component_FaceToFacePrescriptionSnippet, {
                keyword: keyword
            });
        case search/* EGeneralSearchSnippetType.DeliveryGuide */.Dp.DeliveryGuide:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(component_DeliveryGuideSnippet, {});
        default:
            return null;
    }
};
/* harmony default export */ var component_SnippetByKeyword = (SnippetByKeyword);

;// CONCATENATED MODULE: ./src/components/templates/mobile/home/HomeSearchTemplate/components/SearchResult/Integrated/index.tsx

function Integrated_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  > div:not(:last-child) {\n    border-bottom-width: 1px;\n    border-bottom-color: ",
        ";\n    border-bottom-style: solid;\n  }\n"
    ]);
    Integrated_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Integrated_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  > *:not(:last-child) > div {\n    border-bottom-style: solid;\n    border-bottom-width: 1px;\n    border-bottom-color: ",
        ";\n  }\n"
    ]);
    Integrated_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


















var getSearchResultTemplateItemStyle = function(isLast) {
    return {
        margin: "24px 24px 0px",
        padding: "0px 0px 24px",
        borderBottom: isLast ? "none" : "1px solid ".concat(theme/* default.color.gray40 */.Z.color.gray40)
    };
};
var IntegratedSearchResult = function(param) {
    var viewModel = param.viewModel, doctorViewModel = param.doctorViewModel;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15;
    var ref16 = (0,useReportModal/* default */.ZP)(), showReportModal = ref16.showReportModal, onCloseReportModal = ref16.onCloseReportModal, reportItems = ref16.reportItems;
    if (viewModel.isIntegratedSearchLoading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(component_IntegratedSearchResultSkeleton, {});
    }
    if (viewModel.hasNoData) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_EmptyResult, {
            handleClickRequestButton: viewModel.handleClickRequestButton
        });
    }
    var ref17;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_SnippetByKeyword, {
                keyword: (ref17 = (ref = viewModel.generalSearchMetaByKeyword) === null || ref === void 0 ? void 0 : ref.keyword) !== null && ref17 !== void 0 ? ref17 : "",
                snippet: (ref1 = viewModel.generalSearchMetaByKeyword) === null || ref1 === void 0 ? void 0 : ref1.snippet,
                navigateToDoctorList: viewModel.navigateToDoctorList
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_FeatureByKeyword, {
                features: (ref2 = viewModel.generalSearchMetaByKeyword) === null || ref2 === void 0 ? void 0 : ref2.features,
                navigateToFindPharmacyScreen: viewModel.navigateToFindPharmacyScreen,
                navigateDietInjectionScreen: viewModel.navigateDietInjectionScreen,
                navigateToEmergencyContraceptiveScreen: viewModel.navigateToEmergencyContraceptiveScreen
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_ResultSection, {
                title: "비대면 진료",
                hasResultData: !!viewModel.doctors.length,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ResultSection.Result, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorResultWrapper, {
                            children: (ref3 = viewModel.doctors) === null || ref3 === void 0 ? void 0 : ref3.map(function(doctor) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Doctor_Doctor, {
                                    onClick: function() {
                                        return doctorViewModel.onClickDoctor(doctor.publicId);
                                    },
                                    doctor: doctor
                                }, "search-result-doctor-".concat(doctor.id));
                            })
                        })
                    }),
                    viewModel.hasMoreDoctors && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ResultSection.MoreButton, {
                        style: {
                            marginTop: 0
                        },
                        onClick: function() {
                            return viewModel.onChangeTabByMoreData(search/* EIntegratedSearchTabType.Doctor */.DD.Doctor);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_ResultSection, {
                title: "가까운 병원 찾기",
                hasResultData: !!((ref4 = viewModel.keywordSearchHospital) === null || ref4 === void 0 ? void 0 : ref4.elements.length),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ResultSection.ResultAddress, {
                        address: viewModel.getHeaderAddress(),
                        getCurrentLocation: viewModel.requestGeolocationPermission
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ResultSection.ResultWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Integrated_HospitalResultWrapper, {
                            children: (ref5 = viewModel.keywordSearchHospital) === null || ref5 === void 0 ? void 0 : ref5.elements.map(function(hospital) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkTag/* default */.Z, {
                                    onClickNavigateToScreen: function() {
                                        return viewModel.goToAppHospital(hospital.hospitalPublicId);
                                    },
                                    href: "".concat(common/* ROUTES.HOSPITAL.DETAIL.path */.Z6.HOSPITAL.DETAIL.path).concat(hospital.hospitalPublicId),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickEventLogger/* default */.Z, {
                                        pageName: "user_web_search",
                                        eventName: "search_item_click",
                                        payload: {
                                            keyword: viewModel.keyword,
                                            hospital_id: hospital.hospitalPublicId,
                                            tab: search/* EIntegratedSearchTabType.All */.DD.All,
                                            result_section: search/* EIntegratedSearchTabType.Hospital */.DD.Hospital
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HospitalListItem/* default */.Z, {
                                            name: hospital.hospitalName,
                                            distance: hospital.hospitalDistance,
                                            rating: hospital.reviewScore,
                                            reviewTotalCount: hospital.reviewTotalCount,
                                            badges: hospital.hospitalBadges,
                                            imageUrl: hospital.hospitalRepresentativeImageUrl,
                                            address: hospital.hospitalAddress,
                                            status: hospital.hospitalOperationStatus,
                                            isBookable: hospital.isBookable,
                                            representativeDepartmentName: hospital.hospitalRepresentativeDepartmentName,
                                            hospitalPid: hospital.hospitalPublicId,
                                            doctorDetailPageHref: "".concat(common/* ROUTES.HOSPITAL.DETAIL.path */.Z6.HOSPITAL.DETAIL.path).concat(hospital.hospitalPublicId),
                                            onClickMoveToDoctorDetail: function() {
                                                viewModel.goToAppHospital(hospital.hospitalPublicId);
                                            },
                                            hasNonF2fDoctors: !!hospital.doctors.find(function(doctor) {
                                                return doctor.contractType !== types_hospital/* ContractType.FaceToFace */.RJ.FaceToFace;
                                            })
                                        })
                                    })
                                }, "search_hospital_".concat(hospital.hospitalPublicId));
                            })
                        })
                    }),
                    ((ref6 = viewModel.keywordSearchHospital) === null || ref6 === void 0 ? void 0 : ref6.hasMore) && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ResultSection.MoreButton, {
                        style: {
                            marginTop: 0
                        },
                        onClick: function() {
                            return viewModel.onChangeTabByMoreData(search/* EIntegratedSearchTabType.Hospital */.DD.Hospital);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_ResultSection, {
                title: "실시간 의료상담",
                hasResultData: !!((ref7 = viewModel.keywordSearchQna) === null || ref7 === void 0 ? void 0 : ref7.elements.length),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ResultSection.Result, {
                        children: (ref8 = viewModel.keywordSearchQna) === null || ref8 === void 0 ? void 0 : ref8.elements.map(function(question) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SearchQuestionItem, {
                                questionCard: question,
                                onClickQuestion: viewModel.handleClickQuestion
                            }, question.question.questionPid);
                        })
                    }),
                    ((ref9 = viewModel.keywordSearchQna) === null || ref9 === void 0 ? void 0 : ref9.hasMore) && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ResultSection.MoreButton, {
                        onClick: function() {
                            return viewModel.onChangeTabByMoreData(search/* EIntegratedSearchTabType.Qna */.DD.Qna);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_ResultSection, {
                title: "건강 매거진",
                hasResultData: !!((ref10 = viewModel.keywordSearchMagazine) === null || ref10 === void 0 ? void 0 : ref10.elements.length),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ResultSection.Result, {
                        children: (ref11 = viewModel.keywordSearchMagazine) === null || ref11 === void 0 ? void 0 : ref11.elements.map(function(magazine, index) {
                            var ref;
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(components_SearchMagazineItem, {
                                magazine: magazine,
                                onClickMagazine: function() {
                                    return viewModel.handleClickMagazine(magazine);
                                },
                                pageName: "mobile_web_search",
                                containerStyle: getSearchResultTemplateItemStyle(viewModel.keywordSearchMagazine ? index === ((ref = viewModel.keywordSearchMagazine) === null || ref === void 0 ? void 0 : ref.elements.length) - 1 : false)
                            }, magazine.magazinePid);
                        })
                    }),
                    ((ref12 = viewModel.keywordSearchMagazine) === null || ref12 === void 0 ? void 0 : ref12.hasMore) && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ResultSection.MoreButton, {
                        onClick: function() {
                            return viewModel.onChangeTabByMoreData(search/* EIntegratedSearchTabType.Magazine */.DD.Magazine);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_ResultSection, {
                title: "의약품 사전",
                hasResultData: !!((ref13 = viewModel.keywordSearchMedicineDictionary) === null || ref13 === void 0 ? void 0 : ref13.elements.length),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ResultSection.Result, {
                        children: (ref14 = viewModel.keywordSearchMedicineDictionary) === null || ref14 === void 0 ? void 0 : ref14.elements.map(function(medicineDictionary, index, array) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex flex-col gap-[12px] p-[24px]",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkTag/* default */.Z, {
                                            href: "".concat(common/* ROUTES.MEDICINE_DICTIONARY.DETAIL.path */.Z6.MEDICINE_DICTIONARY.DETAIL.path, "/").concat(medicineDictionary.getPublicId()),
                                            onClickNavigateToScreen: viewModel.handleClickMedicineDictionary(medicineDictionary),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MedicineDictionary/* default */.Z, {
                                                title: medicineDictionary.getBasicInfoName(),
                                                description: medicineDictionary.getPharmaceuticalEffectLiteracy(),
                                                summary: medicineDictionary.getWholeSummary(),
                                                image: medicineDictionary.getRepresentativeImage(),
                                                imageAlt: medicineDictionary.getSimplifiedName()
                                            })
                                        })
                                    }, medicineDictionary.getPublicId()),
                                    index !== array.length - 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "h-[1px] w-full bg-gray-40"
                                    })
                                ]
                            }, medicineDictionary.getPublicId());
                        })
                    }),
                    ((ref15 = viewModel.keywordSearchMedicineDictionary) === null || ref15 === void 0 ? void 0 : ref15.hasMore) && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ResultSection.MoreButton, {
                        onClick: function() {
                            return viewModel.onChangeTabByMoreData(search/* EIntegratedSearchTabType.MedicineDictionary */.DD.MedicineDictionary);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_RequestInfoBox, {
                handleClickRequestButton: function() {
                    return viewModel.handleClickRequestButton(search/* ERequestButtonType.BOTTOM */.E.BOTTOM);
                }
            }),
            reportItems && /*#__PURE__*/ (0,jsx_runtime.jsx)(ReportSelectModal/* default */.Z, {
                isVisible: showReportModal,
                onClose: onCloseReportModal,
                selectList: reportItems
            })
        ]
    });
};
/* harmony default export */ var Integrated = (IntegratedSearchResult);
var DoctorResultWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b74b6ba-0"
})(Integrated_templateObject(), function(param) {
    var theme = param.theme;
    return theme.color.gray40;
});
var Integrated_HospitalResultWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b74b6ba-1"
})(Integrated_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.color.gray40;
});

// EXTERNAL MODULE: ./src/components/common/communication/magazine/ListMagazineLine.tsx + 2 modules
var ListMagazineLine = __webpack_require__(79476);
// EXTERNAL MODULE: ./src/components/templates/mobile/communication/Magazine/MagazineMobileTemplate/MagazineSkeleton/index.tsx
var MagazineSkeleton = __webpack_require__(96871);
;// CONCATENATED MODULE: ./src/components/templates/mobile/home/HomeSearchTemplate/components/SearchResult/Magazine/index.tsx

function Magazine_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    Magazine_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Magazine_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-grid;\n  width: 100%;\n  height: ",
        ";\n  text-align: center;\n  align-items: center;\n"
    ]);
    Magazine_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Magazine_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  color: ",
        ";\n  margin-top: 20px;\n"
    ]);
    Magazine_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Magazine_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  color: ",
        ";\n  margin: 8px 0 16px;\n"
    ]);
    Magazine_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}










var MagazineSearchResult = function(param) {
    var viewModel = param.viewModel;
    var ref, ref1, ref2;
    if (viewModel.isMagazinesLoading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(MagazineSkeleton/* default */.Z, {});
    }
    if (!((ref = viewModel.magazinesData) === null || ref === void 0 ? void 0 : ref.pages.length)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResult_EmptySearchResult, {
            handleClickRequestButton: viewModel.handleClickRequestButton
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Magazine_Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfiniteScroll/* default */.Z, {
            isLoading: viewModel.isMagazinesLoading,
            hasNextPage: viewModel.hasMagazinesNextPage,
            fetchNextPage: viewModel.fetchMagazinesNextPage,
            children: (ref1 = viewModel.magazinesData) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.pages) === null || ref2 === void 0 ? void 0 : ref2.map(function(magazine) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkTag/* default */.Z, {
                    onClickNavigateToScreen: function() {
                        return viewModel.onClickMoveNative(magazine.magazinePid);
                    },
                    href: "".concat(common/* ROUTES.MAGAZINE.DETAIL.path */.Z6.MAGAZINE.DETAIL.path, "/").concat(magazine.magazinePid),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickEventLogWrapper, {
                        onClickEventLog: function() {
                            return viewModel.onClickLogMagazine(magazine.magazinePid);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListMagazineLine/* default */.Z, {
                            magazine: {
                                title: magazine.title,
                                mobileTitle: magazine.title,
                                image: magazine.titleImageUrl,
                                date: magazine.createdDate,
                                magazinePid: magazine.magazinePid,
                                description: magazine.description,
                                mobileDescription: magazine.mobileDescription
                            }
                        })
                    })
                }, "Magazine_".concat(magazine.magazinePid));
            })
        })
    });
};
/* harmony default export */ var Magazine = (MagazineSearchResult);
var Magazine_Wrapper = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-3b6b613c-0"
})(Magazine_templateObject());
var Magazine_EmptyResultWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3b6b613c-1"
})(Magazine_templateObject1(), function(param) {
    var theme = param.theme;
    return "calc(100vh - ".concat(theme.size.appHeader.height, ")");
});
var Magazine_EmptyResultTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3b6b613c-2"
})(Magazine_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.typography.UI20SB;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray700;
});
var Magazine_EmptyResultOffer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3b6b613c-3"
})(Magazine_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.typography.UI14M;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray400;
});

// EXTERNAL MODULE: ./src/entities/medicine-dictionary/util/index.ts
var util = __webpack_require__(68534);
;// CONCATENATED MODULE: ./src/components/templates/mobile/home/HomeSearchTemplate/components/SearchResult/MedicineDictionarySearchResult/index.tsx









var MedicineDictionarySearchResult = function(param) {
    var medicineDictionaryViewModel = param.medicineDictionaryViewModel;
    if (medicineDictionaryViewModel.isMedicineDictionariesLoading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(HospitalSkeletonList/* default */.Z, {});
    }
    if (!medicineDictionaryViewModel.medicineDictionaries.length) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResult_EmptySearchResult, {
            handleClickRequestButton: medicineDictionaryViewModel.handleClickRequestButton
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfiniteScroll/* default */.Z, {
            rootMargin: "0px 0px 0px 100px",
            isLoading: medicineDictionaryViewModel.isMedicineDictionariesLoading,
            hasNextPage: medicineDictionaryViewModel.hasMedicineDictionariesNextPage,
            fetchNextPage: medicineDictionaryViewModel.fetchMedicineDictionariesNextPage,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "[&>*:not(:last-child)>div]:border-gray-200 [&>*:not(:last-child)>div]:border-b",
                children: medicineDictionaryViewModel.medicineDictionaries.map(function(medicineDictionary, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickEventLogWrapper, {
                        onClickEventLog: function() {
                            return medicineDictionaryViewModel.onClickLogMedicineDictionary(medicineDictionary.getPublicId());
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex flex-col gap-[12px] p-[24px]",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkTag/* default */.Z, {
                                        href: (0,util/* createMedicineDictionaryDetailUrlWithKeyword */.pT)(medicineDictionary.getPublicId(), medicineDictionaryViewModel.keyword),
                                        onClickNavigateToScreen: medicineDictionaryViewModel.onClickMedicineDictionary(medicineDictionary.getPublicId()),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MedicineDictionary/* default */.Z, {
                                            title: medicineDictionary.getBasicInfoName(),
                                            description: medicineDictionary.getPharmaceuticalEffectLiteracy(),
                                            summary: medicineDictionary.getWholeSummary(),
                                            image: medicineDictionary.getRepresentativeImage(),
                                            imageAlt: medicineDictionary.getSimplifiedName()
                                        })
                                    })
                                }),
                                index !== medicineDictionaryViewModel.medicineDictionaries.length - 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "h-[1px] w-full bg-gray-40"
                                })
                            ]
                        })
                    }, "medicineDictionary_".concat(medicineDictionary.getPublicId()));
                })
            })
        })
    });
};
/* harmony default export */ var SearchResult_MedicineDictionarySearchResult = (MedicineDictionarySearchResult);

// EXTERNAL MODULE: ./src/components/molecules/ScrollTopStickyButton/index.tsx + 1 modules
var ScrollTopStickyButton = __webpack_require__(79771);
;// CONCATENATED MODULE: ./src/components/templates/mobile/home/HomeSearchTemplate/components/SearchResult/Qna/index.tsx

function Qna_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  ",
        ";\n  & > div {\n    margin-right: 8px;\n  }\n"
    ]);
    Qna_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Qna_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  position: relative;\n  margin-right: 8px;\n"
    ]);
    Qna_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Qna_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  img {\n    border: 2px solid white;\n  }\n  ",
        ";\n"
    ]);
    Qna_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}














var QnaSearchResult = function(param) {
    var viewModel = param.viewModel;
    var ref, ref1, ref2;
    if (!((ref = viewModel.searchedQnaData) === null || ref === void 0 ? void 0 : (ref1 = ref.pages) === null || ref1 === void 0 ? void 0 : ref1.length)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResult_EmptySearchResult, {
            handleClickRequestButton: viewModel.handleClickRequestButton
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InfiniteScroll/* default */.Z, {
                rootMargin: "0px 0px 0px 100px",
                isLoading: viewModel.isSearchedQnaLoading,
                hasNextPage: viewModel.hasSearchedQnaNextPage,
                fetchNextPage: viewModel.fetchSearchedQnaNextPage,
                children: (ref2 = viewModel.searchedQnaData) === null || ref2 === void 0 ? void 0 : ref2.pages.map(function(question) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionItem/* default */.Z, {
                        isPaidQuestion: false,
                        questionCard: question,
                        onClickQuestion: viewModel.onClickQuestion,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionItem/* default.BottomLeft */.Z.BottomLeft, {
                            children: question.answeredStatus === search/* EQuestionAnsweredStatus.Answered */.qv.Answered ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Qna_QuestionBottomAnswerStatus, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Qna_QuestionDoctorImageWrapper, {
                                        children: question.answererProfileImageUrls.slice(0, 5).map(function(image, key) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Qna_QuestionDoctorImage, {
                                                imageKey: key,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyImage/* default */.ZP, {
                                                    width: 28,
                                                    height: 28,
                                                    objectFit: "cover",
                                                    loader: /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultDoctorProfile/* default */.Z, {}),
                                                    src: image,
                                                    alt: "답변한 의사 프로필 이미지"
                                                })
                                            }, "answered-doctor-".concat(key));
                                        })
                                    }),
                                    question.answererCount,
                                    "개의 답변"
                                ]
                            }) : question.question.status !== gql_schema/* QuestionStatus.AwaitingBasicAnswer */.xVd.AwaitingBasicAnswer ? // 답변 중 / 답변 확인 중
                            // 목록
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Qna_QuestionBottomAnswerStatus, {
                                fontColor: question.answeredStatus === search/* EQuestionAnsweredStatus.Answering */.qv.Answering ? theme/* default.color.primary500 */.Z.color.primary500 : theme/* default.color.blue500 */.Z.color.blue500,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLottieIcon/* default */.Z, {
                                        width: 24,
                                        height: 24,
                                        animationData: question.answeredStatus === search/* EQuestionAnsweredStatus.Answering */.qv.Answering ? loading_dot_ongoing : loading_dot_wait,
                                        style: {
                                            marginRight: 8
                                        }
                                    }),
                                    question.answeredStatusText
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                        })
                    }, question.question.questionPid);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollTopStickyButton/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var Qna = (QnaSearchResult);
var Qna_QuestionBottomAnswerStatus = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-adc7fb66-0"
})(Qna_templateObject(), function(param) {
    var theme = param.theme, fontColor = param.fontColor;
    return "\n    ".concat(theme.typography.UI14SB, ";\n    color: ").concat(fontColor !== null && fontColor !== void 0 ? fontColor : theme.color.gray700, ";\n  ");
});
var Qna_QuestionDoctorImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-adc7fb66-1"
})(Qna_templateObject1());
var Qna_QuestionDoctorImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-adc7fb66-2"
})(Qna_templateObject2(), function(param) {
    var imageKey = param.imageKey;
    return "\n    margin-left: -".concat(imageKey ? 8 : 0, "px;\n    z-index: ").concat(5 - imageKey, ";\n  ");
});

;// CONCATENATED MODULE: ./src/components/templates/mobile/home/HomeSearchTemplate/components/SearchResult/index.tsx


function SearchResult_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  z-index: ",
        ";\n  ",
        ";\n"
    ]);
    SearchResult_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
















var DIRECT_SEARCH_KEYWORD_TYPE = {
    RECENT: "recent"
};
var SearchResult = function(param) {
    var viewModel = param.viewModel, qnaViewModel = param.qnaViewModel, magazineViewModel = param.magazineViewModel, doctorViewModel = param.doctorViewModel, medicineDictionaryViewModel = param.medicineDictionaryViewModel, isMobileWeb = param.isMobileWeb, hospitalViewModel = param.hospitalViewModel;
    var showModal = (0,useModal/* default */.Z)().showModal;
    var ref = (0,useReportModal/* default */.ZP)(), showReportModal = ref.showReportModal, onCloseReportModal = ref.onCloseReportModal, reportItems = ref.reportItems;
    var ref1 = hooks_usePostReportModal(), showPostReportModal = ref1.showReportModal, onClosePostReportModal = ref1.onCloseReportModal, reportPostData = ref1.reportData, reportPostItems = ref1.reportItems;
    (0,react.useEffect)(function() {
        if (!viewModel.modal.isOpen) {
            return;
        }
        showModal((0,_object_spread/* default */.Z)({}, viewModel.modal.info));
    }, [
        viewModel.modal
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StickyWrapper, {
                isMobileWeb: isMobileWeb,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DNSlideTab/* default */.Z, {
                    value: viewModel.selectedTabValue,
                    children: viewModel.INTEGRATED_SEARCH_RESULT_TABS.map(function(tab) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(DNSlideTab/* default.Item */.Z.Item, {
                            label: tab.label,
                            isActive: tab.value === viewModel.selectedTabValue,
                            onClick: function() {
                                return viewModel.onClickTabItem(tab);
                            }
                        }, tab.key);
                    })
                })
            }),
            viewModel.selectedTabValue === search/* EIntegratedSearchTabType.All */.DD.All && /*#__PURE__*/ (0,jsx_runtime.jsx)(Integrated, {
                viewModel: viewModel,
                doctorViewModel: doctorViewModel
            }),
            viewModel.selectedTabValue === search/* EIntegratedSearchTabType.Qna */.DD.Qna && /*#__PURE__*/ (0,jsx_runtime.jsx)(Qna, {
                viewModel: qnaViewModel
            }),
            viewModel.selectedTabValue === search/* EIntegratedSearchTabType.Magazine */.DD.Magazine && /*#__PURE__*/ (0,jsx_runtime.jsx)(Magazine, {
                viewModel: magazineViewModel
            }),
            viewModel.selectedTabValue === search/* EIntegratedSearchTabType.Doctor */.DD.Doctor && /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResult_Doctor, {
                viewModel: doctorViewModel
            }),
            viewModel.selectedTabValue === search/* EIntegratedSearchTabType.Hospital */.DD.Hospital && /*#__PURE__*/ (0,jsx_runtime.jsx)(Hospital, {
                hospitalViewModel: hospitalViewModel,
                address: viewModel.getHeaderAddress(),
                getCurrentLocation: viewModel.requestGeolocationPermission,
                geolocationPermissionLoading: viewModel.geolocationPermissionLoading
            }),
            viewModel.selectedTabValue === search/* EIntegratedSearchTabType.MedicineDictionary */.DD.MedicineDictionary && /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResult_MedicineDictionarySearchResult, {
                medicineDictionaryViewModel: medicineDictionaryViewModel
            }),
            reportItems && /*#__PURE__*/ (0,jsx_runtime.jsx)(ReportSelectModal/* default */.Z, {
                isVisible: showReportModal,
                onClose: onCloseReportModal,
                selectList: reportItems
            }),
            reportPostItems && /*#__PURE__*/ (0,jsx_runtime.jsx)(ReportSelectModal/* default */.Z, {
                isVisible: showPostReportModal,
                onClose: onClosePostReportModal,
                selectList: reportPostItems,
                title: (reportPostData === null || reportPostData === void 0 ? void 0 : reportPostData.isMine) ? "게시글 관리" : "신고하기"
            })
        ]
    });
};
/* harmony default export */ var components_SearchResult = (SearchResult);
var StickyWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a6944831-0"
})(SearchResult_templateObject(), zIndex/* zIndex.TabSticky */.W.TabSticky, function(param) {
    var theme = param.theme, isMobileWeb = param.isMobileWeb;
    return "\n    position: sticky;\n    top: ".concat(isMobileWeb ? theme.size.mobileWebHeader.height + theme.size.headerSearchBar.height : theme.size.headerSearchBar.height, "px;\n    background: ").concat(theme.color.white, ";\n  ");
});

;// CONCATENATED MODULE: ./src/components/templates/mobile/home/HomeSearchTemplate/components/RecentKeyword/index.tsx

function RecentKeyword_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          border-bottom: 8px solid ",
        ";"
    ]);
    RecentKeyword_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function RecentKeyword_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-bottom: 16px;\n  ",
        ";\n"
    ]);
    RecentKeyword_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function RecentKeyword_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n"
    ]);
    RecentKeyword_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function RecentKeyword_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 24px;\n  align-items: center;\n  ",
        ";\n  color: ",
        ";\n"
    ]);
    RecentKeyword_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function RecentKeyword_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 24px;\n  align-items: center;\n  ",
        ";\n  color: ",
        ";\n"
    ]);
    RecentKeyword_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function RecentKeyword_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  padding: 0 24px 16px;\n  flex-wrap: wrap;\n  gap: 8px;\n\n  > * {\n    margin-right: 0;\n  }\n"
    ]);
    RecentKeyword_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function RecentKeyword_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  color: ",
        ";\n  display: inline-flex;\n  align-items: center;\n  justify-contents: center;\n  background: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: 40px;\n  padding: 8px 15px;\n  height: 38px;\n\n  & > div {\n    font-weight: 500;\n    font-size: 15px;\n    color: ",
        ";\n  }\n\n  & > button {\n    border: none;\n    z-index: 2;\n    padding: 0;\n    margin-left: 4px;\n  }\n"
    ]);
    RecentKeyword_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}






var RecentKeyWord = function(param) {
    var recentKeywordViewData = param.recentKeywordViewData, onSearchDirectKeyword = param.onSearchDirectKeyword, onDeleteItemRecentKeyword = param.onDeleteItemRecentKeyword, onDeleteAllRecentKeyword = param.onDeleteAllRecentKeyword, hasAdExchage = param.hasAdExchage;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: !!recentKeywordViewData.length && /*#__PURE__*/ (0,jsx_runtime.jsxs)(RecentKeyword_Wrapper, {
            hasAdExchage: hasAdExchage,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(RecentKeywordTopList, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RecentKeywordTitle, {
                            children: "최근 검색어"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RecentKeywordAllRemove, {
                            onClick: onDeleteAllRecentKeyword,
                            children: "전체 삭제"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(RecentKeywordItemList, {
                    children: recentKeywordViewData.map(function(keyword) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RecentKeywordItem, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    role: "presentation",
                                    onClick: function() {
                                        return onSearchDirectKeyword(keyword, DIRECT_SEARCH_KEYWORD_TYPE.RECENT);
                                    },
                                    children: keyword
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    onClick: function() {
                                        return onDeleteItemRecentKeyword(keyword);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SmallDelete/* default */.Z, {
                                        color: theme/* default.color.gray600 */.Z.color.gray600,
                                        size: 16
                                    })
                                })
                            ]
                        }, keyword);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var RecentKeyword = (RecentKeyWord);
var RecentKeyword_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-40cec335-0"
})(RecentKeyword_templateObject1(), function(param) {
    var hasAdExchage = param.hasAdExchage, theme = param.theme;
    return hasAdExchage ? "" : (0,styled_components_browser_esm/* css */.iv)(RecentKeyword_templateObject(), theme.color.gray30);
});
var RecentKeywordTopList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-40cec335-1"
})(RecentKeyword_templateObject2());
var RecentKeywordTitle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-40cec335-2"
})(RecentKeyword_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.typography.UI13M;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray600;
});
var RecentKeywordAllRemove = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-40cec335-3"
})(RecentKeyword_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.typography.UI13M;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray400;
});
var RecentKeywordItemList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-40cec335-4"
})(RecentKeyword_templateObject5());
var RecentKeywordItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-40cec335-5"
})(RecentKeyword_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.typography.UI13M;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray600;
}, function(param) {
    var theme = param.theme;
    return theme.color.white;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray100;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray700;
});

// EXTERNAL MODULE: ./src/utils/style.ts
var style = __webpack_require__(76666);
;// CONCATENATED MODULE: ./src/components/templates/mobile/home/HomeSearchTemplate/components/HomeDiseaseSymptomSearch/index.tsx

function HomeDiseaseSymptomSearch_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  padding: 0 24px 16px;\n  margin: 0;\n"
    ]);
    HomeDiseaseSymptomSearch_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function HomeDiseaseSymptomSearch_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: none;\n  width: 100%;\n  padding: 8px 0;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n"
    ]);
    HomeDiseaseSymptomSearch_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function HomeDiseaseSymptomSearch_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  ",
        ";\n  display: flex;\n  text-align: left;\n  width: 20px;\n  height: 20px;\n  align-items: center;\n"
    ]);
    HomeDiseaseSymptomSearch_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function HomeDiseaseSymptomSearch_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  ",
        ";\n  display: inline-flex;\n  align-items: center;\n  height: 30px;\n  margin-left: 8px;\n  text-align: left;\n"
    ]);
    HomeDiseaseSymptomSearch_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}







var HomeDiseaseSymptomSearch = function(props) {
    var entryType = props.entryType, popularSymptomList = props.popularSymptomList, handleSymptomKeywordClick = props.handleSymptomKeywordClick, handleSearchDirectKeyword = props.handleSearchDirectKeyword, handleDeleteItemRecentKeyword = props.handleDeleteItemRecentKeyword, handleDeleteAllRecentKeyword = props.handleDeleteAllRecentKeyword, recentKeywordViewData = props.recentKeywordViewData, bannerAdExchange = props.bannerAdExchange, client = props.client, onImpressionAdLog = props.onImpressionAdLog;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "flex flex-col gap-[16px] bg-white",
        children: [
            entryType !== "symptom" && recentKeywordViewData.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(RecentKeyword, {
                onSearchDirectKeyword: handleSearchDirectKeyword,
                recentKeywordViewData: recentKeywordViewData,
                onDeleteItemRecentKeyword: handleDeleteItemRecentKeyword,
                onDeleteAllRecentKeyword: handleDeleteAllRecentKeyword,
                hasAdExchage: !!bannerAdExchange
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AdExchangeComponent/* default */.Z, {
                fallback: null,
                bannerAdExchange: bannerAdExchange,
                onImpressionLog: onImpressionAdLog,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AdExchangeComponent/* default.Content */.Z.Content, {
                    className: "px-[24px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AdExchangeComponent/* default.ImageAd */.Z.ImageAd, {
                            className: (0,style.cn)("w-full rounded-[8px]", {
                                "aspect-[720/80]": !client.isMobile,
                                "aspect-[312/80]": client.isMobile
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AdExchangeComponent/* default.DeliberatedCode */.Z.DeliberatedCode, {})
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SymptomResultSection, {
                title: "인기 검색어",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SymptomResultSection.Result, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PopularSearchSymptomKeywordContainer, {
                        children: popularSymptomList.map(function(symptom, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PopularSearchSymptomKeyword, {
                                onClick: function() {
                                    return handleSymptomKeywordClick(symptom.symptomName);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PopularSearchSymptomKeywordIndex, {
                                        children: index + 1
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PopularSearchSymptomKeywordContent, {
                                        children: symptom.symptomName
                                    })
                                ]
                            }, symptom.symptomPublicId);
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var components_HomeDiseaseSymptomSearch = (HomeDiseaseSymptomSearch);
var PopularSearchSymptomKeywordContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4425c73-0"
})(HomeDiseaseSymptomSearch_templateObject());
var PopularSearchSymptomKeyword = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-4425c73-1"
})(HomeDiseaseSymptomSearch_templateObject1());
var PopularSearchSymptomKeywordIndex = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-4425c73-2"
})(HomeDiseaseSymptomSearch_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.color.primary700;
}, function(param) {
    var theme = param.theme;
    return theme.typography.UI15SB;
});
var PopularSearchSymptomKeywordContent = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-4425c73-3"
})(HomeDiseaseSymptomSearch_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.color.gray700;
}, function(param) {
    var theme = param.theme;
    return theme.typography.UI17SB;
});

// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(98240);
// EXTERNAL MODULE: ./src/designComponents/organisms/DNSearchBar/index.tsx
var DNSearchBar = __webpack_require__(52477);
;// CONCATENATED MODULE: ./src/designComponents/molecules/DNSearchHeader/index.tsx



function DNSearchHeader_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  align-items: center;\n  padding-right: 24px;\n  padding-bottom: 6px;\n  \n  ",
        ";\n"
    ]);
    DNSearchHeader_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function DNSearchHeader_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0 16px;\n  padding: 2px;\n  border-radius: 8px;\n\n  ",
        ";\n"
    ]);
    DNSearchHeader_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var DNSearchHeader = function(_param) {
    var _onClickBackButton = _param.onClickBackButton, onClickBackButton = _onClickBackButton === void 0 ? RNPlugins/* historyBack */.$i : _onClickBackButton, props = (0,_object_without_properties/* default */.Z)(_param, [
        "onClickBackButton"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchBarWrapper, {
        id: "appHeader",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWrapper, {
                onClick: onClickBackButton,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                    name: "arrow_back_ios_new"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DNSearchBar/* default */.Z, (0,_object_spread/* default */.Z)({}, props))
        ]
    });
};
/* harmony default export */ var molecules_DNSearchHeader = (DNSearchHeader);
var SearchBarWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-79958c65-0"
})(DNSearchHeader_templateObject(), function(param) {
    var theme = param.theme;
    return "\n    padding-top: ".concat(theme.client.isWebView && theme.client.isAndroid ? "12px" : "6px", ";\n    height: ").concat(theme.client.isWebView && theme.client.isAndroid ? "66px" : theme.size.appHeader.height, ";\n    background: ").concat(theme.color.white, ";\n  ");
});
var IconWrapper = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-79958c65-1"
})(DNSearchHeader_templateObject1(), function(param) {
    var theme = param.theme;
    return "\n    &: hover {\n      background: ".concat(theme.color.gray30, ";\n    };\n    &: active {\n      background: ").concat(theme.color.gray50, ";\n    }\n  ");
});

// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(22710);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ./src/hooks/Cuj/useAppInstallRequiredModal.tsx + 2 modules
var useAppInstallRequiredModal = __webpack_require__(28578);
// EXTERNAL MODULE: ./src/hooks/search/useInfiniteSearchNonF2fDoctors.ts
var useInfiniteSearchNonF2fDoctors = __webpack_require__(48115);
// EXTERNAL MODULE: ./src/services/doctor/DiagnosisCategoryService.ts
var DiagnosisCategoryService = __webpack_require__(33310);
// EXTERNAL MODULE: ./src/utils/logger/index.ts
var utils_logger = __webpack_require__(78287);
;// CONCATENATED MODULE: ./src/hooks/search/doctor/useSearchDoctorViewModel.tsx














var useSearchDoctorViewModel = function(param) {
    var homeSearchCategory = param.homeSearchCategory, keyword = param.keyword, tab = param.tab;
    var ref = (0,useModal/* default */.Z)(), showModal = ref.showModal, closeModal = ref.closeModal;
    var ref1 = (0,useAppInstallRequiredModal/* default */.Z)(), showAppInstallModal = ref1.showModal;
    var ref2 = (0,useCustomRouter/* default */.Z)(), moveToPage = ref2.moveToPage, pageName = ref2.pageName;
    var ref3 = (0,useInfiniteSearchNonF2fDoctors/* default */.Z)({
        request: {
            keyword: keyword,
            sortType: gql_schema/* DoctorSortType.Random */.tt_.Random,
            page: 1,
            limit: 10,
            doctorType: gql_schema/* DoctorType.Doctor */.J42.Doctor,
            telemedicineEligibleTargetType: gql_schema/* TelemedicineEligibleTargetType.NightAndHolidayOnly */.H7r.NightAndHolidayOnly
        }
    }, {
        enabled: search/* EIntegratedSearchTabType.Doctor */.DD.Doctor === tab && !!keyword
    }), items = ref3.items, category = ref3.category, hasNextPage = ref3.hasNextPage, isLoading = ref3.isLoading, fetchNextPage = ref3.fetchNextPage;
    var onClickDoctor = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(doctorId) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                (0,utils_logger/* coreLogger */.cl)({
                    eventName: "search_item_click",
                    pageName: pageName,
                    payload: {
                        keyword: keyword,
                        content_id: doctorId,
                        tab: search/* EIntegratedSearchTabType.Doctor */.DD.Doctor
                    }
                });
                if ((0,RNPlugins/* isWebView */.vp)()) {
                    (0,RNPlugins/* sendPostMessageToNative */.T0)(RNPlugins/* NATIVE_POST_MESSAGE_TYPE.MOVE_TO_DOCTOR_DETAIL_PAGE_AFTER_DIAGNOSIS_TARGET_CHECK */.nn.MOVE_TO_DOCTOR_DETAIL_PAGE_AFTER_DIAGNOSIS_TARGET_CHECK, (0,_object_spread/* default */.Z)({
                        doctorId: doctorId
                    }, search/* EIntegratedSearchTabType.Doctor */.DD.Doctor === tab ? category && {
                        categoryId: Number(category.id),
                        type: category.category === gql_schema/* MedicalCategoryType.Treatment */.WkB.Treatment ? DiagnosisCategoryService/* EDeprecatedCategoryType.Symptom */.W8.Symptom : DiagnosisCategoryService/* EDeprecatedCategoryType.Subject */.W8.Subject
                    } : homeSearchCategory && {
                        type: homeSearchCategory.category === gql_schema/* MedicalCategoryType.Treatment */.WkB.Treatment ? DiagnosisCategoryService/* EDeprecatedCategoryType.Symptom */.W8.Symptom : DiagnosisCategoryService/* EDeprecatedCategoryType.Subject */.W8.Subject,
                        categoryId: Number(homeSearchCategory.id)
                    }));
                    return [
                        2
                    ];
                }
                showModal({
                    type: types_modal/* MODAL_TYPE.ALERT */.f.ALERT,
                    props: {
                        title: "비대면 진료는 앱에서 할 수 있어요",
                        message: "닥터나우 앱을 다운로드하고 사용해보세요",
                        buttons: [
                            {
                                type: types_modal/* MODAL_BUTTON_TYPE.DEFAULT */.J.DEFAULT,
                                label: "닫기",
                                onClick: function() {
                                    return closeModal();
                                }
                            },
                            {
                                type: types_modal/* MODAL_BUTTON_TYPE.PRIMARY */.J.PRIMARY,
                                label: "다운로드",
                                onClick: function() {
                                    (0,utils_logger/* coreLogger */.cl)({
                                        eventName: "search_doctor_item_click",
                                        pageName: pageName,
                                        payload: {
                                            content_id: doctorId,
                                            result_section: search/* EIntegratedSearchTabType.Doctor */.DD.Doctor,
                                            tab: search/* EIntegratedSearchTabType.Doctor */.DD.Doctor
                                        }
                                    });
                                    window.open("https://abr.ge/gtlbg3");
                                    closeModal();
                                }
                            }
                        ],
                        onClickOverlay: closeModal
                    }
                });
                return [
                    2
                ];
            });
        });
        return function onClickDoctor(doctorId) {
            return _ref.apply(this, arguments);
        };
    }();
    var moveToCategoryListScreen = function() {
        if ((0,RNPlugins/* isWebView */.vp)()) {
            (0,RNPlugins/* sendPostMessageToNative */.T0)(RNPlugins/* NATIVE_POST_MESSAGE_TYPE.MOVE_TO_CATEGORY_SELECT */.nn.MOVE_TO_CATEGORY_SELECT);
            return;
        }
        showAppInstallModal({
            title: "비대면 진료는 앱에서 확인할 수 있어요.",
            body: "진료 뿐만 아니라\n약 처방, 의료진 상담까지 가능해요!",
            installButtonText: "지금 설치하기",
            closeButtonText: "닫기"
        });
    };
    var handleClickRequestButton = function() {
        (0,utils_logger/* coreLogger */.cl)({
            eventName: "request_additional_info_click",
            pageName: pageName,
            payload: {
                position: search/* ERequestButtonType.BOTTOM */.E.BOTTOM,
                keyword: keyword,
                section_name: "integrate_search_doctor"
            }
        });
        moveToPage({
            webLink: "".concat(common/* ROUTES.SEARCH */.Z6.SEARCH(keyword.replaceAll(" ", "+")).REQUEST_INFO.path),
            mobileScreenName: common/* ROUTES.SEARCH */.Z6.SEARCH(keyword.replaceAll(" ", "+")).REQUEST_INFO.appScreenName,
            params: {
                keyword: keyword
            }
        });
    };
    return {
        doctors: items,
        hasNextPage: !!hasNextPage,
        isLoading: isLoading,
        fetchNextPage: fetchNextPage,
        onClickDoctor: onClickDoctor,
        handleClickRequestButton: handleClickRequestButton,
        moveToCategoryListScreen: moveToCategoryListScreen,
        keyword: keyword
    };
};
/* harmony default export */ var doctor_useSearchDoctorViewModel = (useSearchDoctorViewModel);

// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(85244);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useInfiniteQuery.mjs + 1 modules
var useInfiniteQuery = __webpack_require__(59403);
// EXTERNAL MODULE: ./src/hooks/search/search.gql.impl.tsx
var search_gql_impl = __webpack_require__(41872);
;// CONCATENATED MODULE: ./src/hooks/search/hospital/useGetKeywordSearchHospitalInfiniteQuery.ts




var useGetKeywordSearchHospitalInfiniteQuery = function(variables, queryOptions) {
    return (0,useInfiniteQuery/* useInfiniteQuery */.N)([
        "getDiseaseKeywordSearchedHospitalInfoWithReviewSummaryCursorPage",
        variables
    ], function(param) {
        var pageParam = param.pageParam;
        return search_gql_impl/* useGetDiseaseKeywordSearchedHospitalInfoWithReviewSummaryCursorPageQuery.fetcher */.PJ.fetcher({
            request: (0,_object_spread/* default */.Z)({}, variables.request, pageParam)
        })();
    }, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, queryOptions), {
        getNextPageParam: function(lastPage) {
            var size = variables.request.size;
            if (lastPage.diseaseKeywordSearchedHospitalInfoWithReviewSummaryCursorPage.elements.length < size) {
                return undefined;
            }
            return {
                pivot: lastPage.diseaseKeywordSearchedHospitalInfoWithReviewSummaryCursorPage.pivot,
                pivotScore: lastPage.diseaseKeywordSearchedHospitalInfoWithReviewSummaryCursorPage.pivotScore
            };
        }
    }));
};
/* harmony default export */ var hospital_useGetKeywordSearchHospitalInfiniteQuery = (useGetKeywordSearchHospitalInfiniteQuery);

;// CONCATENATED MODULE: ./src/hooks/search/hospital/useGetKeywordSearchHospitalInfinite.ts





var HOSPITAL_SIZE = 50;
var parseSearchResultHospitalVo = function(data) {
    if (data) {
        return data.flatMap(function(page) {
            return page.diseaseKeywordSearchedHospitalInfoWithReviewSummaryCursorPage.elements;
        }).map(function(hospital) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, hospital), {
                hospitalTotalCount: 0,
                hospitalRepresentativeDepartmentName: (hospital === null || hospital === void 0 ? void 0 : hospital.hospitalRepresentativeDepartmentName) || "",
                reviewScore: (0,format/* getReviewScore */.ds)(hospital.reviewAverageRating),
                reviewCount: (0,format/* getFormattedReviewTotalCount */.G9)(hospital.reviewTotalCount),
                hospitalOperationStatus: (0,format/* getDiagnosisStateOfOperatingStatus */.PT)(hospital.hospitalOperationStatus),
                doctors: hospital.doctors.filter(function(doctor) {
                    return !!doctor;
                })
            });
        });
    }
    return [];
};
var useGetKeywordSearchHospitalInfinite = function(param) {
    var keyword = param.keyword, latitude = param.latitude, longitude = param.longitude, _size = param.size, size = _size === void 0 ? HOSPITAL_SIZE : _size, _enabled = param.enabled, enabled = _enabled === void 0 ? true : _enabled;
    var ref = hospital_useGetKeywordSearchHospitalInfiniteQuery({
        request: {
            keyword: keyword,
            size: size,
            sortType: gql_schema/* HospitalSortType.Distance */.BBh.Distance,
            geoPoint: {
                latitude: latitude,
                longitude: longitude
            }
        }
    }, {
        select: function(data) {
            return {
                pages: parseSearchResultHospitalVo(data.pages),
                pageParams: data.pageParams
            };
        },
        enabled: enabled && !!keyword && keyword.length > 0 && !!latitude && !!longitude
    }), hospitalData = ref.data, isHospitalLoading = ref.isLoading, hasHospitalNextPage = ref.hasNextPage, fetchHospitalNextPage = ref.fetchNextPage;
    return {
        hospitalData: hospitalData,
        isHospitalLoading: isHospitalLoading,
        hasHospitalNextPage: hasHospitalNextPage,
        fetchHospitalNextPage: fetchHospitalNextPage
    };
};
/* harmony default export */ var hospital_useGetKeywordSearchHospitalInfinite = (useGetKeywordSearchHospitalInfinite);

;// CONCATENATED MODULE: ./src/hooks/search/hospital/useSearchHospitalViewModel.ts






var useTotalSearchHospitalViewModel = function(param) {
    var keyword = param.keyword, tab = param.tab, latitude = param.latitude, longitude = param.longitude;
    var ref = (0,useCustomRouter/* default */.Z)(), pageName = ref.pageName, moveToPage = ref.moveToPage;
    var ref1 = hospital_useGetKeywordSearchHospitalInfinite({
        keyword: keyword,
        enabled: tab === search/* EIntegratedSearchTabType.Hospital */.DD.Hospital,
        latitude: latitude,
        longitude: longitude
    }), hospitalData = ref1.hospitalData, isHospitalLoading = ref1.isHospitalLoading, hasHospitalNextPage = ref1.hasHospitalNextPage, fetchHospitalNextPage = ref1.fetchHospitalNextPage;
    var handleClickRequestButton = function() {
        (0,utils_logger/* coreLogger */.cl)({
            eventName: "request_additional_info_click",
            pageName: pageName,
            payload: {
                position: search/* ERequestButtonType.BOTTOM */.E.BOTTOM,
                keyword: keyword,
                section_name: "integrate_search_hospital"
            }
        });
        moveToPage({
            webLink: "".concat(common/* ROUTES.SEARCH */.Z6.SEARCH(keyword.replaceAll(" ", "+")).REQUEST_INFO.path),
            mobileScreenName: common/* ROUTES.SEARCH */.Z6.SEARCH(keyword.replaceAll(" ", "+")).REQUEST_INFO.appScreenName,
            params: {
                keyword: keyword
            }
        });
    };
    var onClickMoveNative = function(hospitalPid) {
        if ((0,RNPlugins/* isWebView */.vp)()) {
            (0,RNPlugins/* sendPostMessageToNative */.T0)(RNPlugins/* NATIVE_POST_MESSAGE_TYPE.MOVE_TO_PAGE */.nn.MOVE_TO_PAGE, {
                screenName: common/* ROUTES.HOSPITAL.DETAIL.appScreenName */.Z6.HOSPITAL.DETAIL.appScreenName,
                params: {
                    hospitalPid: hospitalPid
                }
            });
        }
    };
    var onClickLogHospital = function(hospitalPid) {
        (0,utils_logger/* coreLogger */.cl)({
            eventName: "search_item_click",
            pageName: pageName,
            payload: {
                keyword: keyword,
                content_id: hospitalPid,
                tab: search/* EIntegratedSearchTabType.Hospital */.DD.Hospital
            }
        });
    };
    return {
        hospitalData: hospitalData,
        isHospitalLoading: isHospitalLoading,
        hasHospitalNextPage: hasHospitalNextPage,
        fetchHospitalNextPage: fetchHospitalNextPage,
        handleClickRequestButton: handleClickRequestButton,
        onClickMoveNative: onClickMoveNative,
        onClickLogHospital: onClickLogHospital
    };
};
/* harmony default export */ var useSearchHospitalViewModel = (useTotalSearchHospitalViewModel);

// EXTERNAL MODULE: ./src/hooks/search/magazine/useGetKeywordSearchMagazineInfinite.ts + 1 modules
var useGetKeywordSearchMagazineInfinite = __webpack_require__(58104);
;// CONCATENATED MODULE: ./src/hooks/search/magazine/useSearchMagazineViewModel.ts





var useSearchMagazineViewModel = function(param) {
    var keyword = param.keyword, tab = param.tab;
    var ref = (0,useCustomRouter/* default */.Z)(), pageName = ref.pageName, moveToPage = ref.moveToPage;
    var ref1 = (0,useGetKeywordSearchMagazineInfinite/* default */.Z)({
        keyword: keyword,
        enabled: tab === search/* EIntegratedSearchTabType.Magazine */.DD.Magazine
    }), magazinesData = ref1.magazinesData, isMagazinesLoading = ref1.isMagazinesLoading, hasMagazinesNextPage = ref1.hasMagazinesNextPage, fetchMagazinesNextPage = ref1.fetchMagazinesNextPage;
    var onClickMoveNative = function(magazinePid) {
        moveToPage({
            webLink: "".concat(common/* ROUTES.MAGAZINE.DETAIL.path */.Z6.MAGAZINE.DETAIL.path, "/").concat(magazinePid),
            mobileScreenName: common/* ROUTES.MAGAZINE.DETAIL.appScreenName */.Z6.MAGAZINE.DETAIL.appScreenName,
            params: {
                id: magazinePid
            }
        });
    };
    var onClickLogMagazine = function(magazinePid) {
        (0,utils_logger/* coreLogger */.cl)({
            pageName: pageName,
            eventName: "search_item_click",
            payload: {
                keyword: keyword,
                content_id: magazinePid,
                tab: search/* EIntegratedSearchTabType.Magazine */.DD.Magazine
            }
        });
    };
    var handleClickRequestButton = function() {
        (0,utils_logger/* coreLogger */.cl)({
            eventName: "request_additional_info_click",
            pageName: pageName,
            payload: {
                position: search/* ERequestButtonType.BOTTOM */.E.BOTTOM,
                keyword: keyword,
                section_name: "integrate_search_magazine"
            }
        });
        moveToPage({
            webLink: "".concat(common/* ROUTES.SEARCH */.Z6.SEARCH(keyword.replaceAll(" ", "+")).REQUEST_INFO.path),
            mobileScreenName: common/* ROUTES.SEARCH */.Z6.SEARCH(keyword.replaceAll(" ", "+")).REQUEST_INFO.appScreenName,
            params: {
                keyword: keyword
            }
        });
    };
    return {
        magazinesData: magazinesData,
        isMagazinesLoading: isMagazinesLoading,
        hasMagazinesNextPage: hasMagazinesNextPage,
        fetchMagazinesNextPage: fetchMagazinesNextPage,
        onClickMoveNative: onClickMoveNative,
        onClickLogMagazine: onClickLogMagazine,
        handleClickRequestButton: handleClickRequestButton
    };
};
/* harmony default export */ var magazine_useSearchMagazineViewModel = (useSearchMagazineViewModel);

// EXTERNAL MODULE: ./node_modules/recoil/es/index.js
var es = __webpack_require__(4480);
// EXTERNAL MODULE: ./src/hooks/useAuthModal.tsx
var useAuthModal = __webpack_require__(71213);
// EXTERNAL MODULE: ./src/recoil/atoms/common/auth.ts
var auth = __webpack_require__(4415);
// EXTERNAL MODULE: ./src/hooks/search/qna/useGetKeywordQuestionCardInfinite.ts + 1 modules
var useGetKeywordQuestionCardInfinite = __webpack_require__(66127);
;// CONCATENATED MODULE: ./src/hooks/search/qna/useSearchQuestionViewModel.ts









var useSearchQuestionViewModel = function(param) {
    var keyword = param.keyword, tab = param.tab;
    var ref = (0,useCustomRouter/* default */.Z)(), moveToPage = ref.moveToPage, pageName = ref.pageName;
    var token = (0,es.useRecoilValue)(auth/* tokenState */.J1);
    var setShowAuthModal = (0,useAuthModal/* default */.Z)().setShowAuthModal;
    var ref1 = (0,useReportModal/* default */.ZP)(), showReportModal = ref1.showReportModal, onShowReportModal = ref1.onShowReportModal, onCloseReportModal = ref1.onCloseReportModal, reportItems = ref1.reportItems;
    var ref2 = (0,useGetKeywordQuestionCardInfinite/* default */.Z)({
        keyword: keyword,
        enabled: tab === search/* EIntegratedSearchTabType.Qna */.DD.Qna
    }), searchedQnaData = ref2.searchedQnaData, isSearchedQnaLoading = ref2.isSearchedQnaLoading, hasSearchedQnaNextPage = ref2.hasSearchedQnaNextPage, fetchSearchedQnaNextPage = ref2.fetchSearchedQnaNextPage;
    // 질문 클릭 -> 상세페이지 이동
    var onClickQuestion = function(param) {
        var sectionName = param.sectionName, questionId = param.questionId;
        moveToPage({
            webLink: "".concat(common/* ROUTES.QNA.DETAIL.path */.Z6.QNA.DETAIL.path, "/").concat(questionId),
            mobileScreenName: common/* ROUTES.QNA.DETAIL.appScreenName */.Z6.QNA.DETAIL.appScreenName,
            params: {
                questionId: questionId
            }
        });
        (0,utils_logger/* coreLogger */.cl)({
            eventName: "search_item_click",
            pageName: pageName,
            payload: {
                keyword: keyword,
                content_id: questionId,
                tab: search/* EIntegratedSearchTabType.Qna */.DD.Qna,
                sectionName: sectionName !== null && sectionName !== void 0 ? sectionName : ""
            }
        });
    };
    // 질문 신고하기
    var onShowModal = function(e, data) {
        e.stopPropagation();
        if (!token) {
            // 로그인 정보가 없는 경우
            setShowAuthModal(true);
            return;
        }
        onShowReportModal(data);
    };
    var handleClickRequestButton = function() {
        (0,utils_logger/* coreLogger */.cl)({
            eventName: "request_additional_info_click",
            pageName: pageName,
            payload: {
                position: search/* ERequestButtonType.BOTTOM */.E.BOTTOM,
                keyword: keyword,
                section_name: "integrate_search_qna"
            }
        });
        moveToPage({
            webLink: "".concat(common/* ROUTES.SEARCH */.Z6.SEARCH(keyword.replaceAll(" ", "+")).REQUEST_INFO.path),
            mobileScreenName: common/* ROUTES.SEARCH */.Z6.SEARCH(keyword.replaceAll(" ", "+")).REQUEST_INFO.appScreenName,
            params: {
                keyword: keyword
            }
        });
    };
    return {
        searchedQnaData: searchedQnaData,
        isSearchedQnaLoading: isSearchedQnaLoading,
        hasSearchedQnaNextPage: hasSearchedQnaNextPage,
        fetchSearchedQnaNextPage: fetchSearchedQnaNextPage,
        onClickQuestion: onClickQuestion,
        onShowModal: onShowModal,
        pageName: pageName,
        showReportModal: showReportModal,
        onCloseReportModal: onCloseReportModal,
        reportItems: reportItems,
        handleClickRequestButton: handleClickRequestButton
    };
};
/* harmony default export */ var qna_useSearchQuestionViewModel = (useSearchQuestionViewModel);

// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(22386);
// EXTERNAL MODULE: ../../node_modules/lodash/toNumber.js
var toNumber = __webpack_require__(7642);
var toNumber_default = /*#__PURE__*/__webpack_require__.n(toNumber);
// EXTERNAL MODULE: ./src/hooks/auth/useSetAuthOnScreenFocus.tsx
var useSetAuthOnScreenFocus = __webpack_require__(95392);
// EXTERNAL MODULE: ./src/hooks/hospital/search/useGetUserAddressByLocation.ts
var useGetUserAddressByLocation = __webpack_require__(77688);
;// CONCATENATED MODULE: ./src/hooks/search/useGetKeywordIntegratedSearchHospital.ts





var KEYWORD_SEARCH_SIZE = 4;
var parseKeywordIntegratedSearchHospital = function(data) {
    return {
        hasMore: data.diseaseKeywordSearchedHospitalInfoWithReviewSummaryCursorPage.elements.length > 3,
        elements: data.diseaseKeywordSearchedHospitalInfoWithReviewSummaryCursorPage.elements.slice(0, 3).map(function(hospital) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, hospital), {
                hospitalTotalCount: 0,
                hospitalRepresentativeDepartmentName: (hospital === null || hospital === void 0 ? void 0 : hospital.hospitalRepresentativeDepartmentName) || "",
                reviewScore: (0,format/* getReviewScore */.ds)(hospital.reviewAverageRating),
                reviewCount: (0,format/* getFormattedReviewTotalCount */.G9)(hospital.reviewTotalCount),
                hospitalOperationStatus: (0,format/* getDiagnosisStateOfOperatingStatus */.PT)(hospital.hospitalOperationStatus),
                doctors: hospital.doctors.filter(function(doctor) {
                    return !!doctor;
                })
            });
        })
    };
};
var useGetKeywordIntegratedSearchHospital = function(keyword, latitude, longitude) {
    var ref = (0,search_gql_impl/* useGetDiseaseKeywordSearchedHospitalInfoWithReviewSummaryCursorPageQuery */.PJ)({
        request: {
            keyword: keyword,
            size: KEYWORD_SEARCH_SIZE,
            sortType: gql_schema/* HospitalSortType.Distance */.BBh.Distance,
            geoPoint: {
                latitude: latitude,
                longitude: longitude
            }
        }
    }, {
        select: parseKeywordIntegratedSearchHospital,
        enabled: keyword.length > 1
    }), keywordSearchHospital = ref.data, isKeywordSearchHospitalLoading = ref.isLoading;
    return {
        keywordSearchHospital: keywordSearchHospital,
        isKeywordSearchHospitalLoading: isKeywordSearchHospitalLoading
    };
};
/* harmony default export */ var search_useGetKeywordIntegratedSearchHospital = (useGetKeywordIntegratedSearchHospital);

;// CONCATENATED MODULE: ./src/hooks/search/useGetPopularKeywordsForDiseaseSymptomSearch.ts

var parseGetPopularSymptomsVo = function(popularSymptomDto) {
    var ref;
    var getPopularSymptoms = (ref = popularSymptomDto === null || popularSymptomDto === void 0 ? void 0 : popularSymptomDto.getPopularSymptoms) !== null && ref !== void 0 ? ref : [];
    var popularSymptomList = getPopularSymptoms.map(function(symptom) {
        if (!symptom) {
            return {
                symptomName: "",
                symptomPublicId: ""
            };
        }
        return {
            symptomName: symptom.name,
            symptomPublicId: symptom.publicId
        };
    });
    return {
        popularSymptomList: popularSymptomList
    };
};
var useGetPopularKeywordsForDiseaseSymptomSearch = function() {
    var ref = (0,search_gql_impl/* useGetPopularKeywordsQuery */.pn)(), data = ref.data, isLoading = ref.isLoading;
    var popularSymptomList = parseGetPopularSymptomsVo(data).popularSymptomList;
    return {
        popularSymptomList: popularSymptomList,
        isLoading: isLoading
    };
};
/* harmony default export */ var search_useGetPopularKeywordsForDiseaseSymptomSearch = (useGetPopularKeywordsForDiseaseSymptomSearch);

// EXTERNAL MODULE: ./node_modules/recoil-persist/dist/index.js
var dist = __webpack_require__(6983);
;// CONCATENATED MODULE: ./src/recoil/atoms/search/index.ts


var persistAtom = (0,dist/* recoilPersist */.J)().persistAtom;
var recentHomeSearchKeywordListState = (0,es.atom)({
    key: "recentHomeSearchKeywordListState",
    default: [],
    effects_UNSTABLE: [
        persistAtom
    ]
});
// button을 보지 않기를 원하는 경우
var isPreventStickyButtonOpenState = (0,es.atom)({
    key: "isPreventStickyButtonOpenState",
    default: false,
    effects_UNSTABLE: [
        persistAtom
    ]
});

// EXTERNAL MODULE: ./src/services/hospital/SearchHospitalService.ts
var SearchHospitalService = __webpack_require__(23144);
// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(95210);
;// CONCATENATED MODULE: ./src/services/search/HomeSearchService.ts




var HomeSearchService = /*#__PURE__*/ function() {
    "use strict";
    function HomeSearchService() {
        (0,_class_call_check/* default */.Z)(this, HomeSearchService);
    }
    HomeSearchService.parseDoctorSearchResult = function parseDoctorSearchResult(data) {
        if (data) {
            return this.doctorSearchResultParser({
                getDoctorsByKeyword: {
                    elements: data.flatMap(function(page) {
                        return page.getDoctorsByKeyword.elements;
                    }),
                    pivot: data[data.length - 1].getDoctorsByKeyword.pivot
                }
            });
        }
        return [];
    };
    HomeSearchService.doctorSearchResultParser = function doctorSearchResultParser(data) {
        return data.getDoctorsByKeyword.elements.map(function(doctor) {
            var ref;
            var _professionalDepartmentName, ref1;
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, doctor), {
                doctorId: Number(doctor.id),
                profileUrl: doctor.profileUrl,
                doctorName: doctor.doctorName,
                hospitalName: doctor.hospitalName,
                reviewCount: Number(doctor.reviewCount),
                reviewAverageRating: doctor.reviewAverageRating,
                isAbsent: doctor.isAbsent,
                maxWaitingCount: doctor.maxWaitingCount,
                readyForVideoCall: doctor.readyForVideoCall,
                professionalDepartment: {
                    doctorId: Number(doctor.id),
                    professionalDepartmentId: Number(doctor.professionalDepartment.professionalDepartmentId),
                    professionalDepartmentName: (_professionalDepartmentName = doctor.professionalDepartment.professionalDepartmentName) !== null && _professionalDepartmentName !== void 0 ? _professionalDepartmentName : ""
                },
                diagnosisCount: {
                    doctorId: Number(doctor.id),
                    count: Number((ref1 = (ref = doctor.diagnosisCount) === null || ref === void 0 ? void 0 : ref.count) !== null && ref1 !== void 0 ? ref1 : 0)
                }
            });
        });
    };
    HomeSearchService.getNewKeywordList = function getNewKeywordList(originalKeywordList, keyword) {
        var keywordIdx = originalKeywordList.indexOf(keyword);
        if (keywordIdx !== -1) {
            originalKeywordList.splice(keywordIdx, 1);
        }
        originalKeywordList.unshift(keyword);
        if (originalKeywordList.length > 5) {
            originalKeywordList = originalKeywordList.slice(0, 5);
        }
        return (0,_to_consumable_array/* default */.Z)(originalKeywordList);
    };
    return HomeSearchService;
}();

// EXTERNAL MODULE: ./src/utils/url.ts
var url = __webpack_require__(74735);
;// CONCATENATED MODULE: ./src/constants/logs/search/index.ts
var SearchLoggerEventName;
(function(SearchLoggerEventName) {
    SearchLoggerEventName["NonFaceToFaceDiagnosisClickInSnippet"] = "non_face_to_face_diagnosis_click_in_snippet";
    SearchLoggerEventName["NonFaceToFacePrescriptionClickInSnippet"] = "non_face_to_face_prescription_click_in_snippet";
    SearchLoggerEventName["FindPharmacyClickInSnippetFeature"] = "find_pharmacy_click_in_snippet_feature";
    SearchLoggerEventName["EmergencyContraceptiveClickInSnippetFeature"] = "emergency_contraceptive_click_in_snippet_feature";
    SearchLoggerEventName["DietInjectionClickInSnippetFeature"] = "diet_injection_click_in_snippet_feature";
})(SearchLoggerEventName || (SearchLoggerEventName = {}));

// EXTERNAL MODULE: ./src/hooks/ad/useAdBanner.ts + 3 modules
var useAdBanner = __webpack_require__(28844);
// EXTERNAL MODULE: ./src/models/ad/list.ts
var list = __webpack_require__(70847);
// EXTERNAL MODULE: ./src/utils/airbridge.ts
var airbridge = __webpack_require__(89776);
// EXTERNAL MODULE: ./src/hooks/useLogger.ts
var useLogger = __webpack_require__(8202);
// EXTERNAL MODULE: ./src/hooks/useNavigator.ts
var useNavigator = __webpack_require__(35613);
// EXTERNAL MODULE: ./src/hooks/useWebViewBackEventHandler.ts
var useWebViewBackEventHandler = __webpack_require__(60685);
;// CONCATENATED MODULE: ./src/hooks/search/useGeneralSearchMetaByKeyword.ts



var parseGeneralSearchSnippetType = function(type) {
    switch(type){
        case gql_schema/* GeneralSearchSnippetType.DeliveryGuide */.iz1.DeliveryGuide:
            return search/* EGeneralSearchSnippetType.DeliveryGuide */.Dp.DeliveryGuide;
        case gql_schema/* GeneralSearchSnippetType.FaceToFaceDiagnosis */.iz1.FaceToFaceDiagnosis:
            return search/* EGeneralSearchSnippetType.FaceToFaceDiagnosis */.Dp.FaceToFaceDiagnosis;
        case gql_schema/* GeneralSearchSnippetType.FaceToFacePrescription */.iz1.FaceToFacePrescription:
            return search/* EGeneralSearchSnippetType.FaceToFacePrescription */.Dp.FaceToFacePrescription;
        case gql_schema/* GeneralSearchSnippetType.NonFaceToFaceDiagnosis */.iz1.NonFaceToFaceDiagnosis:
            return search/* EGeneralSearchSnippetType.NonFaceToFaceDiagnosis */.Dp.NonFaceToFaceDiagnosis;
        case gql_schema/* GeneralSearchSnippetType.NonFaceToFacePrescription */.iz1.NonFaceToFacePrescription:
            return search/* EGeneralSearchSnippetType.NonFaceToFacePrescription */.Dp.NonFaceToFacePrescription;
        default:
            return undefined;
    }
};
var parseGeneralSearchFeatureType = function(type) {
    switch(type){
        case gql_schema/* GeneralSearchFeatureType.DietInjection */.Qpf.DietInjection:
            return search/* EGeneralSearchFeatureType.DietInjection */.$p.DietInjection;
        case gql_schema/* GeneralSearchFeatureType.EmergencyContraceptive */.Qpf.EmergencyContraceptive:
            return search/* EGeneralSearchFeatureType.EmergencyContraceptive */.$p.EmergencyContraceptive;
        case gql_schema/* GeneralSearchFeatureType.FindPharmacy */.Qpf.FindPharmacy:
            return search/* EGeneralSearchFeatureType.FindPharmacy */.$p.FindPharmacy;
    }
};
var parseGeneralSearchMetaByKeyword = function(keyword) {
    return function(data) {
        var ref, ref1;
        return {
            keyword: keyword,
            snippet: parseGeneralSearchSnippetType((ref = data.generalSearchMetaByKeyword) === null || ref === void 0 ? void 0 : ref.snippet),
            features: ((ref1 = data.generalSearchMetaByKeyword) === null || ref1 === void 0 ? void 0 : ref1.features) ? data.generalSearchMetaByKeyword.features.map(function(type) {
                return parseGeneralSearchFeatureType(type);
            }) : undefined
        };
    };
};
var useGeneralSearchMetaByKeyword = function(param) {
    var keyword = param.keyword;
    var data = (0,search_gql_impl/* useGeneralSearchMetaByKeywordQuery */.mo)({
        keyword: keyword
    }, {
        enabled: keyword.length > 1,
        select: parseGeneralSearchMetaByKeyword(keyword)
    }).data;
    return {
        generalSearchMetaByKeyword: data
    };
};
/* harmony default export */ var search_useGeneralSearchMetaByKeyword = (useGeneralSearchMetaByKeyword);

// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
;// CONCATENATED MODULE: ./src/hooks/search/useGetKeywordIntegratedSearchMagazine.ts






var useGetKeywordIntegratedSearchMagazine_KEYWORD_SEARCH_SIZE = 4;
var parseAuthorType = function(authorType) {
    switch(authorType){
        case gql_schema/* AuthorType.Doctor */.Tqb.Doctor:
            return search/* EAuthorType.Doctor */.nc.Doctor;
        case gql_schema/* AuthorType.Nurse */.Tqb.Nurse:
            return search/* EAuthorType.Nurse */.nc.Nurse;
        case gql_schema/* AuthorType.Ai */.Tqb.Ai:
            return search/* EAuthorType.Ai */.nc.Ai;
        case gql_schema/* AuthorType.GeneralEditor */.Tqb.GeneralEditor:
            return search/* EAuthorType.GeneralEditor */.nc.GeneralEditor;
        case gql_schema/* AuthorType.MedicalProfessionalEditor */.Tqb.MedicalProfessionalEditor:
            return search/* EAuthorType.MedicalProfessionalEditor */.nc.MedicalProfessionalEditor;
    }
};
var parseKeywordIntegratedSearchMagazineVo = function(data) {
    return {
        hasMore: data.keywordSearchMagazineCursorPage.elements.length > 3,
        elements: data.keywordSearchMagazineCursorPage.elements.slice(0, 3).map(function(magazine) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, magazine), {
                author: magazine.author ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, magazine.author), {
                    authorType: parseAuthorType(magazine.author.authorType)
                }) : undefined,
                bottomButtonType: magazine.bottomButtonType,
                createdDate: "".concat(dayjs_min_default()(magazine.createdAt).format("YYYY.MM.DD"))
            });
        })
    };
};
var useGetKeywordIntegratedSearchMagazine = function(keyword) {
    var ref = (0,search_gql_impl/* useGetKeywordSearchMagazineQuery */.FX)({
        request: {
            keyword: keyword,
            size: useGetKeywordIntegratedSearchMagazine_KEYWORD_SEARCH_SIZE
        }
    }, {
        select: parseKeywordIntegratedSearchMagazineVo,
        enabled: keyword.length > 1
    }), keywordSearchMagazine = ref.data, isKeywordSearchMagazineLoading = ref.isLoading;
    return {
        keywordSearchMagazine: keywordSearchMagazine,
        isKeywordSearchMagazineLoading: isKeywordSearchMagazineLoading
    };
};
/* harmony default export */ var search_useGetKeywordIntegratedSearchMagazine = (useGetKeywordIntegratedSearchMagazine);

// EXTERNAL MODULE: ./src/hooks/search/useGetKeywordIntegratedSearchMedicineDictionary.ts
var useGetKeywordIntegratedSearchMedicineDictionary = __webpack_require__(28909);
;// CONCATENATED MODULE: ./src/hooks/search/useGetKeywordIntegratedSearchQna.ts






var useGetKeywordIntegratedSearchQna_KEYWORD_SEARCH_SIZE = 4;
var questionAnsweredStatusEnumParser = function(questionAnsweredStatus) {
    switch(questionAnsweredStatus){
        case gql_schema/* QuestionAnsweredStatus.Answered */.G26.Answered:
            return search/* EQuestionAnsweredStatus.Answered */.qv.Answered;
        case gql_schema/* QuestionAnsweredStatus.Answering */.G26.Answering:
            return search/* EQuestionAnsweredStatus.Answering */.qv.Answering;
        case gql_schema/* QuestionAnsweredStatus.Checking */.G26.Checking:
            return search/* EQuestionAnsweredStatus.Checking */.qv.Checking;
    }
};
var accessibleTypeEnumParser = function(accessibleType) {
    switch(accessibleType){
        case gql_schema/* QuestionAccessibleType.All */.MF8.All:
            return search/* EQuestionAccessibleType.All */.Bf.All;
        case gql_schema/* QuestionAccessibleType.DoctorsAndMe */.MF8.DoctorsAndMe:
            return search/* EQuestionAccessibleType.DoctorsAndMe */.Bf.DoctorsAndMe;
        case gql_schema/* QuestionAccessibleType.Me */.MF8.Me:
            return search/* EQuestionAccessibleType.Me */.Bf.Me;
    }
};
var parseKeywordIntegratedSearchQnaVo = function(data) {
    return {
        hasMore: data.keywordSearchQuestionCardCursorPage.elements.length > 3,
        elements: data.keywordSearchQuestionCardCursorPage.elements.slice(0, 3).map(function(qna) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, qna), {
                question: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, qna.question), {
                    attachments: (0,format/* sortImageBlindTypeFormat */.zV)(qna.question.attachments),
                    accessibleType: accessibleTypeEnumParser(qna.question.accessibleType)
                }),
                questionCreatedAt: (0,format/* displayedAt */.hX)(qna.question.createdAt),
                answeredStatus: questionAnsweredStatusEnumParser(qna.answeredStatus),
                answerCreatedAt: null,
                answeredStatusText: (0,format/* getQnaAnswerStatus */.uY)(qna.answeredStatus)
            });
        })
    };
};
var useGetKeywordIntegratedSearchQna = function(keyword) {
    var ref = (0,search_gql_impl/* useGetkeywordSearchQnaQuery */.A$)({
        request: {
            keyword: keyword,
            size: useGetKeywordIntegratedSearchQna_KEYWORD_SEARCH_SIZE
        }
    }, {
        select: parseKeywordIntegratedSearchQnaVo,
        enabled: keyword.length > 1
    }), keywordSearchQna = ref.data, isKeywordSearchQnaLoading = ref.isLoading;
    return {
        keywordSearchQna: keywordSearchQna,
        isKeywordSearchQnaLoading: isKeywordSearchQnaLoading
    };
};
/* harmony default export */ var search_useGetKeywordIntegratedSearchQna = (useGetKeywordIntegratedSearchQna);

;// CONCATENATED MODULE: ./src/hooks/search/useHomeSearchViewModel.ts






































var INITIAL_MODAL_STATE = {
    isOpen: false,
    info: {
        type: undefined,
        props: {
            title: "",
            buttons: []
        }
    }
};
var INTEGRATED_SEARCH_RESULT_TABS = [
    {
        key: 0,
        label: "통합",
        value: search/* EIntegratedSearchTabType.All */.DD.All
    },
    {
        key: 1,
        label: "비대면 진료",
        value: search/* EIntegratedSearchTabType.Doctor */.DD.Doctor
    },
    {
        key: 2,
        label: "가까운 병원 찾기",
        value: search/* EIntegratedSearchTabType.Hospital */.DD.Hospital
    },
    {
        key: 3,
        label: "실시간 의료상담",
        value: search/* EIntegratedSearchTabType.Qna */.DD.Qna
    },
    {
        key: 4,
        label: "건강 매거진",
        value: search/* EIntegratedSearchTabType.Magazine */.DD.Magazine
    },
    {
        key: 5,
        label: "의약품 사전",
        value: search/* EIntegratedSearchTabType.MedicineDictionary */.DD.MedicineDictionary
    }, 
];
var DOCTOR_LIST_LIMIT = 4;
var useHomeSearchViewModel = function(props) {
    (0,useSetAuthOnScreenFocus/* default */.Z)();
    var navigation = (0,useNavigator/* default */.Z)();
    var ref = (0,useCustomRouter/* default */.Z)(), router = ref.router, moveToPage = ref.moveToPage, pageName = ref.pageName;
    var ref1 = (0,useModal/* default */.Z)(), closeCurrentModal = ref1.closeModal;
    var showToast = (0,useToast/* default */.Z)().showToast;
    var logger = (0,useLogger/* default */.Z)();
    var entryType = props.entryType;
    var _query = router.query, queryLatitude = _query.latitude, queryLongitude = _query.longitude;
    var shouldSnackBarOpen = router.query.shouldSnackBarOpen;
    var _query1 = router.query, _keyword = _query1.keyword, keyword = _keyword === void 0 ? "" : _keyword;
    var ref2 = (0,react.useState)(), regionByDepth = ref2[0], setRegionByDepth = ref2[1];
    var ref3 = (0,react.useState)(false), isSnackBarOpen = ref3[0], setIsSnackBarOpen = ref3[1];
    var ref4 = (0,react.useState)(!!keyword), isSearchResultShow = ref4[0], setIsSearchResultShow = ref4[1];
    var searchInputRef = (0,react.useRef)(null);
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,es.useRecoilState)(recentHomeSearchKeywordListState), 2), recentKeywordList = ref5[0], setRecentKeywordList = ref5[1];
    var ref6 = (0,react.useState)((0,_object_spread/* default */.Z)({}, INITIAL_MODAL_STATE)), modal = ref6[0], setModal = ref6[1];
    var ref7 = (0,react.useState)(false), geolocationPermissionLoading = ref7[0], setGeolocationPermissionLoading = ref7[1];
    var ref8 = (0,react.useState)([]), recentKeywordViewData = ref8[0], setRecentKeywordViewData = ref8[1];
    var _tab;
    var ref9 = (0,react.useState)((_tab = router.query.tab) !== null && _tab !== void 0 ? _tab : search/* EIntegratedSearchTabType.All */.DD.All), selectedTabValue = ref9[0], setSelectedTabValue = ref9[1];
    var initialCoord = (0,react.useMemo)(function() {
        if (!queryLatitude || !queryLongitude) {
            return SearchHospitalService/* SearchHospitalService.initializeUserCoordinate */.h.initializeUserCoordinate();
        }
        var latitude = toNumber_default()(queryLatitude);
        var longitude = toNumber_default()(queryLongitude);
        if (isNaN(latitude) || isNaN(longitude)) {
            return SearchHospitalService/* SearchHospitalService.initializeUserCoordinate */.h.initializeUserCoordinate();
        }
        return {
            latitude: latitude,
            longitude: longitude
        };
    }, [
        queryLatitude,
        queryLongitude
    ]);
    var ref10 = (0,react.useState)(initialCoord), coordinate = ref10[0], setCoordinate = ref10[1];
    var ref11 = (0,useGetUserAddressByLocation/* default */.Z)(coordinate.latitude, coordinate.longitude), tmp = ref11.data, sigunguDongli = tmp === void 0 ? SearchHospitalService/* SearchHospitalService.initializeUserSigunguDongli */.h.initializeUserSigunguDongli() : tmp, addressRefetch = ref11.refetch;
    var ref12 = (0,useAdBanner/* default */.Z)(list/* AdPageType.Search */.hO.Search, props.client), bannerAdExchange = ref12.bannerAdExchange, handleSendExposureLog = ref12.handleSendExposureLog;
    var ref13 = search_useGetKeywordIntegratedSearchQna(keyword), keywordSearchQna = ref13.keywordSearchQna, isKeywordSearchQnaLoading = ref13.isKeywordSearchQnaLoading;
    var ref14 = search_useGetKeywordIntegratedSearchMagazine(keyword), keywordSearchMagazine = ref14.keywordSearchMagazine, isKeywordSearchMagazineLoading = ref14.isKeywordSearchMagazineLoading;
    var ref15 = search_useGetKeywordIntegratedSearchHospital(keyword, coordinate.latitude, coordinate.longitude), keywordSearchHospital = ref15.keywordSearchHospital, isKeywordSearchHospitalLoading = ref15.isKeywordSearchHospitalLoading;
    var ref16 = (0,useGetKeywordIntegratedSearchMedicineDictionary/* default */.Z)({
        keyword: keyword,
        enabled: !!keyword && keyword.length > 0
    }), keywordSearchMedicineDictionary = ref16.keywordSearchMedicineDictionary, isKeywordSearchMedicineDictionaryLoading = ref16.isKeywordSearchMedicineDictionaryLoading;
    var ref17 = (0,useInfiniteSearchNonF2fDoctors/* default */.Z)({
        request: {
            keyword: keyword,
            sortType: gql_schema/* DoctorSortType.Random */.tt_.Random,
            page: 1,
            limit: DOCTOR_LIST_LIMIT,
            doctorType: gql_schema/* DoctorType.Doctor */.J42.Doctor,
            telemedicineEligibleTargetType: gql_schema/* TelemedicineEligibleTargetType.NightAndHolidayOnly */.H7r.NightAndHolidayOnly
        }
    }, {
        enabled: !!keyword
    }), items = ref17.items, hasNextPage = ref17.hasNextPage, category = ref17.category, isDoctorLoading = ref17.isLoading;
    var generalSearchMetaByKeyword = search_useGeneralSearchMetaByKeyword({
        keyword: keyword
    }).generalSearchMetaByKeyword;
    (0,useWebViewBackEventHandler/* default */.Z)({
        isBackEventTrigger: isSearchResultShow,
        callback: function() {
            handleResetSearchKeyword();
        }
    });
    var trimmedDoctors = (0,_to_consumable_array/* default */.Z)(items).splice(0, DOCTOR_LIST_LIMIT - 1);
    var getHeaderAddress = function() {
        var address = "".concat(sigunguDongli.sigungu, " ").concat(sigunguDongli.dongLi);
        if (regionByDepth === null || regionByDepth === void 0 ? void 0 : regionByDepth.siDoName) {
            if (!regionByDepth.siGunGuName && !regionByDepth.legalEupMyeonDongName) {
                address = "".concat(regionByDepth.siDoName);
            } else if (regionByDepth.siGunGuName && !regionByDepth.legalEupMyeonDongName) {
                address = "".concat(regionByDepth.siDoName, " ").concat(regionByDepth.siGunGuName);
            } else if (regionByDepth.siGunGuName && regionByDepth.legalEupMyeonDongName) {
                address = "".concat(regionByDepth.siGunGuName, " ").concat(regionByDepth.legalEupMyeonDongName);
            } else if (!regionByDepth.siGunGuName && regionByDepth.legalEupMyeonDongName) {
                address = "".concat(regionByDepth.siDoName, " ").concat(regionByDepth.legalEupMyeonDongName);
            }
        }
        return address;
    };
    var initRegionFilter = function() {
        setRegionByDepth(undefined);
    };
    var requestGeolocationPermission = (0,react.useCallback)(function() {
        if (!navigator.geolocation) {
            showToast({
                message: "다른 브라우저로 해당 기능을 이용해주세요"
            });
            setCoordinate({
                latitude: initialCoord.latitude,
                longitude: initialCoord.longitude
            });
            return;
        }
        setGeolocationPermissionLoading(true);
        navigator.geolocation.getCurrentPosition(function(param) {
            var coords = param.coords;
            initRegionFilter();
            setGeolocationPermissionLoading(false);
            (0,url/* updateSearchParams */.aM)([
                {
                    key: "latitude",
                    value: coords.latitude
                },
                {
                    key: "longitude",
                    value: coords.longitude
                }, 
            ]);
        }, function() {
            setGeolocationPermissionLoading(false);
            showToast({
                message: "위치 사용을 허용을 해야 내 위치 설정이 가능해요"
            });
        }, {
            enableHighAccuracy: true
        });
    }, [
        initialCoord,
        showToast
    ]);
    var setSearchKeyword = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(newKeyword) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setIsSearchResultShow(true);
                        return [
                            4,
                            (0,url/* updateSearchParams */.aM)([
                                {
                                    key: "keyword",
                                    value: newKeyword
                                }
                            ])
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function setSearchKeyword(newKeyword) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleInputChange = function(value) {
        (0,url/* updateSearchParams */.aM)([
            {
                key: "keyword",
                value: value
            }
        ]);
    };
    var closeModal = function() {
        closeCurrentModal();
        setModal(INITIAL_MODAL_STATE);
    };
    var handleSubmit = function() {
        var ref;
        var newKeywordList = HomeSearchService.getNewKeywordList((0,_to_consumable_array/* default */.Z)(recentKeywordList), keyword);
        setRecentKeywordList(newKeywordList);
        (ref = searchInputRef.current) === null || ref === void 0 ? void 0 : ref.blur();
    };
    // 검색 버튼 클릭
    var handleChangeKeyword = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, ref1, newKeyword;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        newKeyword = (ref1 = (ref = searchInputRef.current) === null || ref === void 0 ? void 0 : ref.value) !== null && ref1 !== void 0 ? ref1 : "";
                        if (!newKeyword.trim()) {
                            setModal({
                                isOpen: true,
                                info: {
                                    type: types_modal/* MODAL_TYPE.ALERT */.f.ALERT,
                                    props: {
                                        title: "검색어를 입력해주세요.",
                                        buttons: [
                                            {
                                                type: types_modal/* MODAL_BUTTON_TYPE.BOLD */.J.BOLD,
                                                label: "확인",
                                                onClick: function() {
                                                    return closeModal();
                                                }
                                            }
                                        ]
                                    }
                                }
                            });
                            return [
                                2
                            ];
                        }
                        if (newKeyword.length < 2) {
                            setModal({
                                isOpen: true,
                                info: {
                                    type: types_modal/* MODAL_TYPE.ALERT */.f.ALERT,
                                    props: {
                                        title: "2글자 이상 입력해 주세요.",
                                        message: "더 정확도 높은 결과를 볼 수 있어요.",
                                        buttons: [
                                            {
                                                type: types_modal/* MODAL_BUTTON_TYPE.BOLD */.J.BOLD,
                                                label: "확인",
                                                onClick: function() {
                                                    return closeModal();
                                                }
                                            }
                                        ]
                                    }
                                }
                            });
                            return [
                                2
                            ];
                        }
                        (0,utils_logger/* coreLogger */.cl)({
                            eventName: "click_search",
                            pageName: pageName,
                            payload: {
                                section: "search_bar",
                                keyword: newKeyword,
                                entry_point: entryType
                            }
                        });
                        return [
                            4,
                            setSearchKeyword(newKeyword)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleChangeKeyword() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleResetSearchKeyword = function(e) {
        var ref;
        e === null || e === void 0 ? void 0 : e.preventDefault();
        (ref = searchInputRef.current) === null || ref === void 0 ? void 0 : ref.blur();
        setIsSearchResultShow(false);
        (0,url/* updateSearchParams */.aM)([
            {
                key: "keyword",
                value: ""
            },
            {
                key: "tab",
                value: ""
            }, 
        ]);
        setSelectedTabValue(search/* EIntegratedSearchTabType.All */.DD.All);
        if (keyword && searchInputRef.current) {
            searchInputRef.current.value = "";
        }
    };
    // 최근 검색어 / 자주 찾는 검색어로 검색
    var handleSearchDirectKeyword = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(keyword) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        (0,utils_logger/* coreLogger */.cl)({
                            eventName: "click_search",
                            pageName: pageName,
                            payload: {
                                section: "recent",
                                keyword: keyword,
                                entry_point: entryType
                            }
                        });
                        return [
                            4,
                            setSearchKeyword(keyword)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSearchDirectKeyword(keyword) {
            return _ref.apply(this, arguments);
        };
    }();
    // 최근 검색어 선택 삭제
    var handleDeleteItemRecentKeyword = function(keyword) {
        var filter = recentKeywordViewData.filter(function(recentKeyword) {
            return keyword !== recentKeyword;
        });
        setRecentKeywordList(filter);
    };
    // 최근 검색어 전체 삭제
    var handleDeleteAllRecentKeyword = function() {
        setRecentKeywordList([]);
    };
    var handleSnackBarClose = function() {
        setIsSnackBarOpen(false);
    };
    var handleClickRequestButton = function(buttonPosition) {
        (0,utils_logger/* coreLogger */.cl)({
            eventName: "request_additional_info_click",
            pageName: pageName,
            payload: {
                position: buttonPosition,
                keyword: keyword
            }
        });
        moveToPage({
            webLink: "".concat(common/* ROUTES.SEARCH */.Z6.SEARCH(keyword.replaceAll(" ", "+"), entryType).REQUEST_INFO.path),
            mobileScreenName: common/* ROUTES.SEARCH */.Z6.SEARCH(keyword.replaceAll(" ", "+"), entryType).REQUEST_INFO.appScreenName,
            params: {
                keyword: keyword
            }
        });
    };
    var handleClickQuestion = function(questionId) {
        (0,utils_logger/* coreLogger */.cl)({
            eventName: "search_item_click",
            pageName: pageName,
            payload: {
                keyword: keyword,
                content_id: questionId,
                tab: search/* EIntegratedSearchTabType.All */.DD.All,
                result_section: search/* EIntegratedSearchTabType.Qna */.DD.Qna
            }
        });
        moveToPage({
            webLink: "".concat(common/* ROUTES.QNA.DETAIL.path */.Z6.QNA.DETAIL.path, "/").concat(questionId),
            mobileScreenName: common/* ROUTES.QNA.DETAIL.appScreenName */.Z6.QNA.DETAIL.appScreenName,
            params: {
                questionId: questionId,
                result_section: search/* EIntegratedSearchTabType.Qna */.DD.Qna
            }
        });
    };
    var handleClickDoctor = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(doctor) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                if (!(0,RNPlugins/* isWebView */.vp)()) {
                    return [
                        2
                    ];
                }
                (0,utils_logger/* coreLogger */.cl)({
                    eventName: "search_item_click",
                    pageName: pageName,
                    payload: {
                        keyword: keyword,
                        content_id: doctor.doctorId,
                        tab: search/* EIntegratedSearchTabType.All */.DD.All,
                        result_section: search/* EIntegratedSearchTabType.Doctor */.DD.Doctor
                    }
                });
                (0,RNPlugins/* sendPostMessageToNative */.T0)(RNPlugins/* NATIVE_POST_MESSAGE_TYPE.MOVE_TO_PAGE */.nn.MOVE_TO_PAGE, {
                    screenName: common/* APP_SCREEN_NAME.DOCTOR_DETAIL */.x.DOCTOR_DETAIL,
                    params: {
                        doctorId: doctor.doctorId,
                        type: "subject",
                        entry: "search"
                    }
                });
                return [
                    2
                ];
            });
        });
        return function handleClickDoctor(doctor) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleClickMagazine = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(magazine) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                (0,utils_logger/* coreLogger */.cl)({
                    eventName: "search_item_click",
                    pageName: pageName,
                    payload: {
                        keyword: keyword,
                        content_id: magazine.magazinePid,
                        tab: search/* EIntegratedSearchTabType.All */.DD.All,
                        result_section: search/* EIntegratedSearchTabType.Magazine */.DD.Magazine
                    }
                });
                moveToPage({
                    webLink: "".concat(common/* ROUTES.MAGAZINE.DETAIL.path */.Z6.MAGAZINE.DETAIL.path, "/").concat(magazine.magazinePid),
                    mobileScreenName: common/* ROUTES.MAGAZINE.DETAIL.appScreenName */.Z6.MAGAZINE.DETAIL.appScreenName,
                    params: {
                        id: magazine.magazinePid
                    }
                });
                return [
                    2
                ];
            });
        });
        return function handleClickMagazine(magazine) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleClickMedicineDictionary = function(medicineDictionary) {
        return function() {
            (0,utils_logger/* coreLogger */.cl)({
                eventName: "search_item_click",
                pageName: pageName,
                payload: {
                    keyword: keyword,
                    content_id: medicineDictionary.getPublicId(),
                    tab: search/* EIntegratedSearchTabType.All */.DD.All,
                    result_section: search/* EIntegratedSearchTabType.MedicineDictionary */.DD.MedicineDictionary
                }
            });
            navigation.pushScreen({
                url: "".concat(common/* ROUTES.MEDICINE_DICTIONARY.DETAIL.path */.Z6.MEDICINE_DICTIONARY.DETAIL.path, "/").concat(medicineDictionary.getPublicId(), "/").concat(encodeURIComponent(keyword))
            });
        };
    };
    var goToAppHospital = function(hospitalPid) {
        if ((0,RNPlugins/* isWebView */.vp)()) {
            (0,utils_logger/* coreLogger */.cl)({
                eventName: "search_item_click",
                pageName: pageName,
                payload: {
                    keyword: keyword,
                    content_id: hospitalPid,
                    tab: search/* EIntegratedSearchTabType.All */.DD.All,
                    result_section: search/* EIntegratedSearchTabType.Hospital */.DD.Hospital
                }
            });
            (0,RNPlugins/* sendPostMessageToNative */.T0)(RNPlugins/* NATIVE_POST_MESSAGE_TYPE.MOVE_TO_PAGE */.nn.MOVE_TO_PAGE, {
                screenName: common/* ROUTES.HOSPITAL.DETAIL.appScreenName */.Z6.HOSPITAL.DETAIL.appScreenName,
                params: {
                    hospitalPid: hospitalPid
                }
            });
        }
    };
    var handleClickMoreData = (0,react.useCallback)(function(type) {
        return function() {
            (0,utils_logger/* coreLogger */.cl)({
                eventName: "search_item_more_click",
                pageName: pageName,
                payload: {
                    keyword: keyword,
                    result_section: type
                }
            });
            moveToPage({
                webLink: "".concat(common/* ROUTES.COMMON.SEARCH.path */.Z6.COMMON.SEARCH.path, "?").concat(entryType ? "entryType=".concat(entryType) : "", "&keyword=").concat(keyword.replaceAll(" ", "+")),
                mobileScreenName: common/* ROUTES.COMMON.SEARCH.appScreenName */.Z6.COMMON.SEARCH.appScreenName,
                params: {
                    keyword: keyword
                }
            });
        };
    }, [
        keyword
    ]);
    var onChangeTabByMoreData = function(type) {
        (0,utils_logger/* coreLogger */.cl)({
            eventName: "search_item_more_click",
            pageName: pageName,
            payload: {
                keyword: keyword,
                result_section: type
            }
        });
        if ((0,RNPlugins/* isWebView */.vp)() && type === search/* EIntegratedSearchTabType.Doctor */.DD.Doctor && category) {
            (0,RNPlugins/* sendPostMessageToNative */.T0)(RNPlugins/* NATIVE_POST_MESSAGE_TYPE.MOVE_TO_DOCTOR_LIST_WITH_TARGET_CHECK */.nn.MOVE_TO_DOCTOR_LIST_WITH_TARGET_CHECK, {
                type: category.category,
                id: category.id
            });
            return;
        }
        setSelectedTabValue(type);
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    var popularSymptomList = search_useGetPopularKeywordsForDiseaseSymptomSearch().popularSymptomList;
    var handleSymptomKeywordClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(keyword) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setIsSearchResultShow(true);
                        return [
                            4,
                            setSearchKeyword(keyword)
                        ];
                    case 1:
                        _state.sent();
                        (0,utils_logger/* coreLogger */.cl)({
                            eventName: "click_search",
                            pageName: pageName,
                            payload: {
                                keyword: keyword,
                                section: "popular_symptom",
                                entry_point: entryType
                            }
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSymptomKeywordClick(keyword) {
            return _ref.apply(this, arguments);
        };
    }();
    // 탭 클릭 handler
    var onClickTabItem = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(tab) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        (0,utils_logger/* coreLogger */.cl)({
                            eventName: "integrated_search_tab_click",
                            pageName: pageName,
                            payload: {
                                tab: tab.value
                            }
                        });
                        setSelectedTabValue(tab.value);
                        return [
                            4,
                            (0,url/* updateSearchParams */.aM)([
                                {
                                    key: "tab",
                                    value: tab.value
                                }
                            ])
                        ];
                    case 1:
                        _state.sent();
                        window.scrollTo({
                            top: 0,
                            behavior: "smooth"
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return function onClickTabItem(tab) {
            return _ref.apply(this, arguments);
        };
    }();
    var navigateToDoctorList = function(type) {
        var eventName = type === search/* EGeneralSearchSnippetType.NonFaceToFaceDiagnosis */.Dp.NonFaceToFaceDiagnosis ? SearchLoggerEventName.NonFaceToFaceDiagnosisClickInSnippet : SearchLoggerEventName.NonFaceToFacePrescriptionClickInSnippet;
        logger.log({
            eventName: eventName,
            payload: {
                keyword: keyword
            }
        });
        onChangeTabByMoreData(search/* EIntegratedSearchTabType.Doctor */.DD.Doctor);
    };
    var navigateToFindPharmacyScreen = function() {
        logger.log({
            eventName: SearchLoggerEventName.FindPharmacyClickInSnippetFeature,
            payload: {
                keyword: keyword
            }
        });
        navigation.pushScreen({
            url: common/* ROUTES.PHARMACIES.PHARMACIES_FIND.pathName */.Z6.PHARMACIES.PHARMACIES_FIND.pathName
        });
    };
    var navigateToEmergencyContraceptiveScreen = function() {
        if (!(0,RNPlugins/* isWebView */.vp)()) {
            airbridge/* default.setDynamicLink */.Z.setDynamicLink({
                campaign: "web_home_search",
                content: "web_emergency_contraceptive_snippet",
                term: "사후피임약 진료 예약",
                sub_id: keyword
            });
            return;
        }
        logger.log({
            eventName: SearchLoggerEventName.EmergencyContraceptiveClickInSnippetFeature,
            payload: {
                keyword: keyword
            }
        });
        var CONTRACEPTIVE_SYMPTOM_CATEGORY_ID = 10;
        var type = DiagnosisCategoryService/* EDeprecatedCategoryType.Symptom */.W8.Symptom;
        navigation.pushAppScreen({
            screenName: common/* ROUTES.DOCTOR.F2F_LIST.appScreenName */.Z6.DOCTOR.F2F_LIST.appScreenName,
            params: {
                categoryId: CONTRACEPTIVE_SYMPTOM_CATEGORY_ID,
                type: type
            }
        });
    };
    var navigateDietInjectionScreen = function() {
        if (!(0,RNPlugins/* isWebView */.vp)()) {
            airbridge/* default.setDynamicLink */.Z.setDynamicLink({
                campaign: "web_home_search",
                content: "web_diet_injection_snippet",
                term: "다이어트 주사 받기",
                sub_id: keyword
            });
            return;
        }
        logger.log({
            eventName: SearchLoggerEventName.DietInjectionClickInSnippetFeature,
            payload: {
                keyword: keyword
            }
        });
        navigation.pushScreen({
            url: common/* ROUTES.FACE_TO_FACE.PREFERENCE_STEP.path */.Z6.FACE_TO_FACE.PREFERENCE_STEP.path
        });
    };
    var handleBackButtonClick = function() {
        if (isSearchResultShow) {
            handleResetSearchKeyword();
            return;
        }
        (0,RNPlugins/* historyBack */.$i)();
    };
    var isIntegratedSearchLoading = (0,react.useMemo)(function() {
        return isKeywordSearchQnaLoading || isKeywordSearchMagazineLoading || isKeywordSearchHospitalLoading || isDoctorLoading || isKeywordSearchMedicineDictionaryLoading;
    }, [
        isKeywordSearchQnaLoading,
        isKeywordSearchMagazineLoading,
        isKeywordSearchHospitalLoading,
        isDoctorLoading,
        isKeywordSearchMedicineDictionaryLoading, 
    ]);
    (0,react.useEffect)(function() {
        if (!shouldSnackBarOpen) {
            return;
        }
        setIsSnackBarOpen(true);
        router.replace("/search");
    }, []);
    (0,react.useEffect)(function() {
        if (keyword && searchInputRef.current) {
            searchInputRef.current.value = keyword;
            setIsSearchResultShow(true);
        }
    }, [
        keyword
    ]);
    (0,react.useEffect)(function() {
        if (!router.query.keyword) {
            setIsSearchResultShow(false);
        }
    }, [
        router.asPath,
        router.query.keyword
    ]);
    (0,react.useEffect)(function() {
        setRecentKeywordViewData(recentKeywordList);
    }, [
        recentKeywordList
    ]);
    (0,react.useEffect)(function() {
        var focusInput = function() {
            var ref;
            return searchInputRef === null || searchInputRef === void 0 ? void 0 : (ref = searchInputRef.current) === null || ref === void 0 ? void 0 : ref.focus();
        };
        focusInput();
    }, []);
    (0,react.useEffect)(function() {
        if (queryLatitude && queryLongitude) {
            setCoordinate({
                latitude: toNumber_default()(queryLatitude),
                longitude: toNumber_default()(queryLongitude)
            });
        }
    }, [
        queryLatitude,
        queryLongitude
    ]);
    (0,react.useEffect)(function() {
        addressRefetch();
    }, [
        coordinate
    ]);
    return {
        handleSendExposureLog: handleSendExposureLog,
        bannerAdExchange: bannerAdExchange,
        searchInputRef: searchInputRef,
        keyword: keyword,
        isSnackBarOpen: isSnackBarOpen,
        recentKeywordViewData: recentKeywordViewData.filter(function(item) {
            return typeof item === "string";
        }),
        modal: modal,
        popularSymptomList: popularSymptomList,
        isSearchResultShow: isSearchResultShow,
        INTEGRATED_SEARCH_RESULT_TABS: INTEGRATED_SEARCH_RESULT_TABS,
        selectedTabValue: selectedTabValue,
        keywordSearchQna: keywordSearchQna,
        keywordSearchMagazine: keywordSearchMagazine,
        keywordSearchHospital: keywordSearchHospital,
        keywordSearchMedicineDictionary: keywordSearchMedicineDictionary,
        coordinate: coordinate,
        geolocationPermissionLoading: geolocationPermissionLoading,
        hasNoData: !(keywordSearchQna === null || keywordSearchQna === void 0 ? void 0 : keywordSearchQna.elements.length) && !(keywordSearchMagazine === null || keywordSearchMagazine === void 0 ? void 0 : keywordSearchMagazine.elements.length) && !(keywordSearchHospital === null || keywordSearchHospital === void 0 ? void 0 : keywordSearchHospital.elements.length) && !(keywordSearchMedicineDictionary === null || keywordSearchMedicineDictionary === void 0 ? void 0 : keywordSearchMedicineDictionary.elements.length) && !(trimmedDoctors === null || trimmedDoctors === void 0 ? void 0 : trimmedDoctors.length),
        doctors: trimmedDoctors,
        hasMoreDoctors: !!hasNextPage,
        category: category,
        generalSearchMetaByKeyword: generalSearchMetaByKeyword,
        isIntegratedSearchLoading: isIntegratedSearchLoading,
        handleInputChange: handleInputChange,
        handleSnackBarClose: handleSnackBarClose,
        handleSubmit: handleSubmit,
        handleResetSearchKeyword: handleResetSearchKeyword,
        handleSearchDirectKeyword: handleSearchDirectKeyword,
        handleDeleteItemRecentKeyword: handleDeleteItemRecentKeyword,
        handleDeleteAllRecentKeyword: handleDeleteAllRecentKeyword,
        handleChangeKeyword: handleChangeKeyword,
        handleClickRequestButton: handleClickRequestButton,
        handleClickQuestion: handleClickQuestion,
        handleClickDoctor: handleClickDoctor,
        handleClickMedicineDictionary: handleClickMedicineDictionary,
        handleClickMagazine: handleClickMagazine,
        handleClickMoreData: handleClickMoreData,
        handleSymptomKeywordClick: handleSymptomKeywordClick,
        onClickTabItem: onClickTabItem,
        onChangeTabByMoreData: onChangeTabByMoreData,
        goToAppHospital: goToAppHospital,
        getHeaderAddress: getHeaderAddress,
        requestGeolocationPermission: requestGeolocationPermission,
        navigateToDoctorList: navigateToDoctorList,
        navigateToFindPharmacyScreen: navigateToFindPharmacyScreen,
        navigateDietInjectionScreen: navigateDietInjectionScreen,
        handleBackButtonClick: handleBackButtonClick,
        navigateToEmergencyContraceptiveScreen: navigateToEmergencyContraceptiveScreen
    };
};
/* harmony default export */ var search_useHomeSearchViewModel = (useHomeSearchViewModel);

// EXTERNAL MODULE: ./src/types/app.ts
var app = __webpack_require__(9912);
// EXTERNAL MODULE: ./src/entities/medicine-dictionary/model/medicineDictionary.model.ts
var medicineDictionary_model = __webpack_require__(72115);
// EXTERNAL MODULE: ./src/hooks/magazine/mobile/magazine.gql.impl.tsx
var magazine_gql_impl = __webpack_require__(22548);
;// CONCATENATED MODULE: ./src/hooks/search/medicineDictionary/useGetKeywordSearchMedicineDictionaryInfiniteQuery.ts




var useGetKeywordSearchMedicineDictionaryInfiniteQuery = function(variables, queryOptions) {
    return (0,useInfiniteQuery/* useInfiniteQuery */.N)(search_gql_impl/* useGetSearchMedicineDictionaryByCursorScorePageQuery.getKey */.z2.getKey(variables), function(param) {
        var pageParam = param.pageParam;
        var ref, ref1;
        return search_gql_impl/* useGetSearchMedicineDictionaryByCursorScorePageQuery.fetcher */.z2.fetcher({
            request: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, variables.request), {
                pivotId: (ref = pageParam === null || pageParam === void 0 ? void 0 : pageParam.pivotId) !== null && ref !== void 0 ? ref : undefined,
                pivotScore: (ref1 = pageParam === null || pageParam === void 0 ? void 0 : pageParam.pivotScore) !== null && ref1 !== void 0 ? ref1 : undefined
            })
        })();
    }, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, queryOptions), {
        getNextPageParam: function(lastPage) {
            if (lastPage.searchMedicineDictionaryByCursorScorePage.items.length === variables.request.limit) {
                return {
                    pivotId: lastPage.searchMedicineDictionaryByCursorScorePage.pivotId,
                    pivotScore: lastPage.searchMedicineDictionaryByCursorScorePage.pivotScore
                };
            }
            return undefined;
        }
    }));
};
/* harmony default export */ var medicineDictionary_useGetKeywordSearchMedicineDictionaryInfiniteQuery = (useGetKeywordSearchMedicineDictionaryInfiniteQuery);

;// CONCATENATED MODULE: ./src/hooks/search/medicineDictionary/useGetKeywordSearchMedicineDictionaryInfinite.ts







var parseMedicineDictionary = function(data) {
    if (data) {
        return data.flatMap(function(page) {
            return page.searchMedicineDictionaryByCursorScorePage.items;
        }).map(function(medicine) {
            var ref;
            var _medicineImage, ref1, _image;
            return new medicineDictionary_model/* default */.Z({
                id: medicine.id,
                publicId: medicine.publicId,
                basicInfo: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, medicine.basicInfo), {
                    medicineImage: (_medicineImage = medicine.basicInfo.medicineImage) !== null && _medicineImage !== void 0 ? _medicineImage : undefined
                }),
                medicineGuide: {
                    wholeSummary: (ref1 = (ref = medicine.medicineGuide) === null || ref === void 0 ? void 0 : ref.wholeSummary.join("")) !== null && ref1 !== void 0 ? ref1 : ""
                },
                packagingInfo: {
                    image: (_image = medicine.packagingInfo.image) !== null && _image !== void 0 ? _image : undefined
                }
            });
        });
    }
    return [];
};
var MEDICINE_DICTIONARIES_SIZE = 20;
var useGetKeywordSearchMedicineDictionaryInfinite = function(param) {
    var keyword = param.keyword, _size = param.size, size = _size === void 0 ? MEDICINE_DICTIONARIES_SIZE : _size, _enabled = param.enabled, enabled = _enabled === void 0 ? true : _enabled;
    var ref = medicineDictionary_useGetKeywordSearchMedicineDictionaryInfiniteQuery({
        request: {
            keyword: keyword,
            limit: size
        }
    }, {
        select: function(data) {
            return {
                pages: parseMedicineDictionary(data.pages),
                pageParams: data.pageParams
            };
        },
        enabled: enabled && !!keyword && keyword.length > 0
    }), medicineDictionariesData = ref.data, isMedicineDictionariesLoading = ref.isLoading, hasMedicineDictionariesNextPage = ref.hasNextPage, fetchMedicineDictionariesNextPage = ref.fetchNextPage;
    return {
        medicineDictionariesData: medicineDictionariesData,
        isMedicineDictionariesLoading: isMedicineDictionariesLoading,
        hasMedicineDictionariesNextPage: hasMedicineDictionariesNextPage,
        fetchMedicineDictionariesNextPage: fetchMedicineDictionariesNextPage
    };
};
/* harmony default export */ var medicineDictionary_useGetKeywordSearchMedicineDictionaryInfinite = (useGetKeywordSearchMedicineDictionaryInfinite);
useGetKeywordSearchMedicineDictionaryInfinite.prefetchQuery = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(queryClient, params) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        queryClient.prefetchInfiniteQuery(magazine_gql_impl/* useGetKeywordSearchMagazineCursorPageQuery.getKey */.d7.getKey({
                            request: params
                        }), magazine_gql_impl/* useGetKeywordSearchMagazineCursorPageQuery.fetcher */.d7.fetcher({
                            request: params
                        }))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function(queryClient, params) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/hooks/search/medicineDictionary/useSearchMedicineDictionaryViewModel.ts







var useSearchMedicineDictionaryViewModel = function(param) {
    var keyword = param.keyword, tab = param.tab;
    var ref = (0,useCustomRouter/* default */.Z)(), pageName = ref.pageName, moveToPage = ref.moveToPage;
    var pushScreen = (0,useNavigator/* default */.Z)().pushScreen;
    var ref1 = medicineDictionary_useGetKeywordSearchMedicineDictionaryInfinite({
        keyword: keyword,
        enabled: tab === search/* EIntegratedSearchTabType.MedicineDictionary */.DD.MedicineDictionary
    }), medicineDictionariesData = ref1.medicineDictionariesData, isMedicineDictionariesLoading = ref1.isMedicineDictionariesLoading, hasMedicineDictionariesNextPage = ref1.hasMedicineDictionariesNextPage, fetchMedicineDictionariesNextPage = ref1.fetchMedicineDictionariesNextPage;
    var handleClickRequestButton = function() {
        (0,utils_logger/* coreLogger */.cl)({
            eventName: "request_additional_info_click",
            pageName: pageName,
            payload: {
                position: search/* ERequestButtonType.BOTTOM */.E.BOTTOM,
                keyword: keyword,
                section_name: "integrate_search_hospital"
            }
        });
        moveToPage({
            webLink: "".concat(common/* ROUTES.SEARCH */.Z6.SEARCH(keyword.replaceAll(" ", "+")).REQUEST_INFO.path),
            mobileScreenName: common/* ROUTES.SEARCH */.Z6.SEARCH(keyword.replaceAll(" ", "+")).REQUEST_INFO.appScreenName,
            params: {
                keyword: keyword
            }
        });
    };
    var onClickLogMedicineDictionary = function(medicineDictionaryId) {
        (0,utils_logger/* coreLogger */.cl)({
            eventName: "search_item_click",
            pageName: pageName,
            payload: {
                keyword: keyword,
                content_id: medicineDictionaryId,
                tab: search/* EIntegratedSearchTabType.MedicineDictionary */.DD.MedicineDictionary
            }
        });
    };
    var onClickMedicineDictionary = function(medicineDictionaryId) {
        return function() {
            pushScreen({
                url: (0,util/* createMedicineDictionaryDetailUrlWithKeyword */.pT)(medicineDictionaryId, keyword)
            });
        };
    };
    var ref2;
    return {
        keyword: keyword,
        medicineDictionaries: (ref2 = medicineDictionariesData === null || medicineDictionariesData === void 0 ? void 0 : medicineDictionariesData.pages.flatMap(function(medicineDictionary) {
            return medicineDictionary;
        })) !== null && ref2 !== void 0 ? ref2 : [],
        isMedicineDictionariesLoading: isMedicineDictionariesLoading,
        hasMedicineDictionariesNextPage: hasMedicineDictionariesNextPage,
        fetchMedicineDictionariesNextPage: fetchMedicineDictionariesNextPage,
        onClickMedicineDictionary: onClickMedicineDictionary,
        onClickLogMedicineDictionary: onClickLogMedicineDictionary,
        handleClickRequestButton: handleClickRequestButton
    };
};
/* harmony default export */ var medicineDictionary_useSearchMedicineDictionaryViewModel = (useSearchMedicineDictionaryViewModel);

;// CONCATENATED MODULE: ./src/components/templates/mobile/home/HomeSearchTemplate/index.tsx

function HomeSearchTemplate_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: sticky;\n  z-index: ",
        ";\n\n  ",
        ";\n"
    ]);
    HomeSearchTemplate_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



















var HomeSearchTemplate = function(param) {
    var client = param.client, entryType = param.entryType;
    (0,useScreenFocus/* default */.Z)();
    var showToast = (0,useToast/* default */.Z)().showToast;
    var viewModel = search_useHomeSearchViewModel({
        client: client,
        entryType: entryType
    });
    var qnaViewModel = qna_useSearchQuestionViewModel({
        keyword: viewModel.keyword,
        tab: viewModel.selectedTabValue
    });
    var magazineViewModel = magazine_useSearchMagazineViewModel({
        keyword: viewModel.keyword,
        tab: viewModel.selectedTabValue
    });
    var doctorViewModel = doctor_useSearchDoctorViewModel({
        homeSearchCategory: viewModel.category,
        keyword: viewModel.keyword,
        tab: viewModel.selectedTabValue
    });
    var hospitalViewModel = useSearchHospitalViewModel({
        keyword: viewModel.keyword,
        tab: viewModel.selectedTabValue,
        latitude: viewModel.coordinate.latitude,
        longitude: viewModel.coordinate.longitude
    });
    var medicineDictionaryViewModel = medicineDictionary_useSearchMedicineDictionaryViewModel({
        keyword: viewModel.keyword,
        tab: viewModel.selectedTabValue
    });
    (0,react.useEffect)(function() {
        if (!viewModel.isSnackBarOpen) {
            return;
        }
        showToast({
            message: "소중한 의견을 남겨주셔서 감사합니다."
        });
    }, [
        viewModel.isSnackBarOpen
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TemplateLayout/* default.Wrapper */.Z.Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TemplateLayout/* default.Content */.Z.Content, {
            children: [
                client.clientType === app/* ClientType.WEB */.B.WEB && /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbs/* default.Wrapper */.Z.Wrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbs/* default */.Z, {
                        visible: true,
                        name: "통합검색",
                        type: "search",
                        path: "".concat(common/* ROUTES.SEARCH */.Z6.SEARCH().HOME.path)
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeSearchTemplate_SearchBarWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(molecules_DNSearchHeader, {
                        placeholder: entryType === "symptom" ? "감기, 코로나, 목이 따가워요" : "증상, 질병, 병원을 검색해보세요",
                        shouldShowResetButton: !!viewModel.keyword,
                        searchInputRef: viewModel.searchInputRef,
                        onSubmit: viewModel.handleChangeKeyword,
                        onReset: viewModel.handleResetSearchKeyword,
                        onClickBackButton: viewModel.handleBackButtonClick
                    })
                }),
                !viewModel.isSearchResultShow && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_HomeDiseaseSymptomSearch, {
                    entryType: entryType,
                    popularSymptomList: viewModel.popularSymptomList,
                    handleSymptomKeywordClick: viewModel.handleSymptomKeywordClick,
                    handleDeleteItemRecentKeyword: viewModel.handleDeleteItemRecentKeyword,
                    handleDeleteAllRecentKeyword: viewModel.handleDeleteAllRecentKeyword,
                    handleSearchDirectKeyword: viewModel.handleSearchDirectKeyword,
                    recentKeywordViewData: viewModel.recentKeywordViewData,
                    client: client,
                    bannerAdExchange: viewModel.bannerAdExchange,
                    onImpressionAdLog: viewModel.handleSendExposureLog
                }),
                viewModel.isSearchResultShow && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SearchResult, {
                    viewModel: viewModel,
                    qnaViewModel: qnaViewModel,
                    magazineViewModel: magazineViewModel,
                    doctorViewModel: doctorViewModel,
                    isMobileWeb: client.clientType === app/* ClientType.MOBILE_WEB */.B.MOBILE_WEB,
                    hospitalViewModel: hospitalViewModel,
                    medicineDictionaryViewModel: medicineDictionaryViewModel
                })
            ]
        })
    });
};
/* harmony default export */ var home_HomeSearchTemplate = (HomeSearchTemplate);
var HomeSearchTemplate_SearchBarWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b3d7bf1f-0"
})(HomeSearchTemplate_templateObject(), zIndex/* zIndex.AppHeader */.W.AppHeader, function(param) {
    var theme = param.theme;
    return "\n    top: ".concat(theme.client.clientType === app/* ClientType.MOBILE_WEB */.B.MOBILE_WEB ? theme.size.mobileWebHeader.height : 0, "px;\n  ");
});

;// CONCATENATED MODULE: ./src/pages/search/index.tsx
// PageDescription: 통합검색 페이지




var DEFAULT_IMAGE_HEIGHT = 600;
var DEFAULT_IMAGE_WIDTH = 315;
var EPageType;
(function(EPageType) {
    EPageType[EPageType["SYMPTOM_SEARCH"] = 0] = "SYMPTOM_SEARCH";
    EPageType[EPageType["SEARCH_RESULT"] = 1] = "SEARCH_RESULT";
    EPageType[EPageType["INTEGRATED_SEARCH"] = 2] = "INTEGRATED_SEARCH";
})(EPageType || (EPageType = {}));
var getPageType = function(entryType, keyword) {
    if (entryType === "symptom") {
        return EPageType.SYMPTOM_SEARCH;
    }
    if (keyword) {
        return EPageType.SEARCH_RESULT;
    }
    return EPageType.INTEGRATED_SEARCH;
};
var getSeoContents = function(pageType, keyword) {
    if (pageType === EPageType.SEARCH_RESULT) {
        var _NEXT_PUBLIC_SEARCH_RESULT_OG_IMAGE;
        return {
            title: "".concat(keyword, " 검색결과 - 닥터나우"),
            description: "증상, 질병, 병원, 의료진 Q&A 등 필요한 모든 정보를 확인해 보세요.",
            imageUrl: (_NEXT_PUBLIC_SEARCH_RESULT_OG_IMAGE = "https://doctornow-front-images.s3.ap-northeast-2.amazonaws.com/og-searchresult.png") !== null && _NEXT_PUBLIC_SEARCH_RESULT_OG_IMAGE !== void 0 ? _NEXT_PUBLIC_SEARCH_RESULT_OG_IMAGE : "https://doctornow-front-images.s3.ap-northeast-2.amazonaws.com/og-searchresult.png"
        };
    }
    var _NEXT_PUBLIC_SYMPTOM_SEARCH_OG_IMAGE;
    return {
        title: "증상검색 - 닥터나우",
        description: "증상만 검색해도 내가 알고 싶은 정보를 쉽고 빠르게 찾을 수 있어요.",
        imageUrl: (_NEXT_PUBLIC_SYMPTOM_SEARCH_OG_IMAGE = "https://doctornow-front-images.s3.ap-northeast-2.amazonaws.com/og-symptomsearch.png") !== null && _NEXT_PUBLIC_SYMPTOM_SEARCH_OG_IMAGE !== void 0 ? _NEXT_PUBLIC_SYMPTOM_SEARCH_OG_IMAGE : "https://doctornow-front-images.s3.ap-northeast-2.amazonaws.com/og-symptomsearch.png"
    };
};
var SearchPage = function(props) {
    var entryType = props.entryType, client = props.client, keyword = props.keyword;
    var ref = getSeoContents(getPageType(entryType, keyword), keyword), title = ref.title, description = ref.description, imageUrl = ref.imageUrl;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: title,
                description: description,
                openGraph: {
                    type: "website",
                    title: title,
                    description: description,
                    locale: "ko-KR",
                    siteName: "닥터나우",
                    images: [
                        {
                            url: imageUrl,
                            width: DEFAULT_IMAGE_HEIGHT,
                            height: DEFAULT_IMAGE_WIDTH,
                            alt: title
                        }, 
                    ],
                    defaultImageHeight: DEFAULT_IMAGE_HEIGHT,
                    defaultImageWidth: DEFAULT_IMAGE_WIDTH
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(home_HomeSearchTemplate, {
                entryType: entryType,
                client: client
            })
        ]
    });
};
SearchPage.Layout = DefaultLayout/* default */.Z;
var __N_SSP = true;
/* harmony default export */ var pages_search = (SearchPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1498,4329,9950,1743,9004,6551,5247,7626,7530,1662,2384,1944,9792,6019,1767,9774,2888,179], function() { return __webpack_exec__(68389); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);